import { UploadIdentificationCommandResultStatus } from "Api/Api";
import {
  AddressType,
  Bank,
  BankEnvironment,
  LicenseCode,
  LoyaltyEventCode,
  PartyType,
  TransactionStatus,
  UploadIdentificationCommandResultStatus2,
  VatStatus,
} from "Infrastructure/Api/Api";
import type { ResourceDictionary } from "./Resources";

export const SlovakResourcesDictionary: ResourceDictionary = {
  Hooks: {
    BankingAuth: {
      Error: "Pripojenie banky sa nepodarilo",
    },
    OCR: {
      Error: "Údaje z dokumentov sa nepodarilo prečítať",
      Declined: "Doklad neprešiel automatickou kontrolou pravosti.",
    },
    Paypoint: {
      AssignNfcCardSuccess: "NFC karta bola prirazena k paypointu {{name}}",
      AssignNfcCardError: "Chyba pri prirazeni NFC karty k paypointu",
      PaypointEdited: "Paypoint {{name}} bol upravený",
      PaypointEditError: "Chyba pri úprave paypointu",
      PaypointCreateError: "Chyba pri vytváraní paypointu",
      PaypointCreated: "Paypoint {{name}} bol vytvorený",
      AssignNfcCardNoConflict:
        "Chyba - Táto NFC karta je už přiřazena k jinému paypointu",
      ScanError: "Platbu sa nepodarilo začať, skúste to prosím znova",
    },
    Transaction: {
      TipUpdateError: "Sprepitné sa nepodarilo aktualizovať",
    },
    BankingAccount: {
      Deleted: "Bankový účet bol vymazaný",
      DeleteError: "Chyba pri mazaní bankového účtu",
      PrimaryAccountChanged: "Primárny účet bol zmenený",
      PrimaryAccountChangeError: "Primárny účet sa nepodarilo zmeniť",
      StatusChanged: "Účet bol upravený",
      StatusChangeError: "Účet sa nepodarilo upraviť",
    },
    TerminalContract: {
      DownloadError: "Nastala chyba pri sťahovaní zmluvy",
      UcbContractPrefix: "UCB_podklad_zmluvy_",
    },
    Verifications: {
      Error: "Registračné údaje sa nepodarilo overiť",
    },
    VerificationEmail: {
      Error: "Nepodarilo sa odoslať verifikačný e-mail",
      Success: "Verifikačný e-mail bol odoslaný",
    },
    CampaignTransaction: {
      Error: "Chyba pri iniciovaní kampane transakcie",
      Success: "Kampane transakcia bola úspešne iniciovaná",
    },
    Ares: {
      Error: "Pri komunikácii s registrom firiem sa vyskytla chyba.",
      SubjectNotFound: "Subjekt nebol nájdený",
    },
    Employee: {
      AccessSent: "Pozvánka zamestnancovi bola odoslaná",
      BackOfficeTargetError:
        "Táto e-mailová adresa patrí internému účtu {{appName}} (Admin, AML, onboarding) a nie je možné ju pozvať. Použite inú e-mailovú adresu.",
      AccessSendError: "Prístup sa nepodarilo odoslať",
      EmployeeExistsError:
        "Táto osoba už má zamestnanecký prístup k tejto spoločnosti.",
      InviteeNotRegisteredError:
        "Pre tento e-mail neexistuje účet v {{appName}}. Dotyčná osoba sa musí najprv v {{appName}} zaregistrovať, až potom ju môžete pozvať.",
      InvitationCancelled: "Pozvánka bola zrušená",
      InvitationCancelError: "Pozvánku sa nepodarilo zrušiť",
      EmployeeRemoved: "Zamestnanec bol odobratý",
      EmployeeRemoveError: "Zamestnanca sa nepodarilo odobrať",
    },
    Notifications: {
      Created: "Notifikácia bola úspešne vytvorená",
      CreateError: "Chyba pri vytváraní notifikácie",
      Updated: "Notifikácia bola úspešne aktualizovaná",
      UpdateError: "Chyba pri aktualizácii notifikácie",
      Deleted: "Notifikácia bola úspešne zmazaná",
      DeleteError: "Chyba pri mazaní notifikácie",
      Restored: "Notifikácia bola úspešne obnovená",
      RestoreError: "Chyba pri obnovovaní notifikácie",
    },
  },
  Stories: {
    Bar: {
      YourStory: "Moja story",
    },
    ImageUpload: {
      Prompt: "Pretiahnite obrázok alebo kliknite pre výber",
      Error: "Nahranie obrázka sa nepodarilo",
      InvalidType: "Podporované sú iba obrázky PNG, JPEG alebo WebP",
      TooLarge: "Obrázok môže mať maximálne {{megabytes}} MB",
    },
    VideoUpload: {
      Prompt: "Pretiahnite video alebo kliknite pre výber",
      Error: "Nahranie videa sa nepodarilo",
      TooLong: "Video môže mať maximálne {{seconds}} sekúnd",
      InvalidType: "Podporované sú iba videá MP4, WebM alebo MOV",
      TooLarge: "Video môže mať maximálne {{megabytes}} MB",
    },
    Management: {
      Title: "Stories",
      CreateButton: "Nová story",
      Empty: "Zatiaľ žiadne stories",
      LoadError: "Stories sa nepodarilo načítať",
      Status: {
        Draft: "Koncept",
        Live: "Aktívna",
        Expired: "Vypršala",
        Unpublished: "Neaktívna",
      },
      Table: {
        Author: "Autor",
        Text: "Text",
        State: "Stav",
        LastPublishedAt: "Naposledy publikované",
        ExpiresAt: "Vyprší",
        DateCreated: "Vytvorené",
        Publications: "Počet publikovaní",
        Actions: "Akcie",
        Preview: "Náhľad",
        Publish: "Publikovať",
        Republish: "Publikovať znova",
        LiveUntil: "Aktívna do {{dateTime}}",
        Unpublish: "Deaktivovať",
      },
      Messages: {
        PublishSuccess: "Story bola publikovaná",
        PublishError: "Publikovanie zlyhalo",
        DeleteSuccess: "Story bola zmazaná",
        DeleteError: "Zmazanie zlyhalo",
        DeleteConfirmTitle: "Zmazať story?",
        DeleteConfirm: "Story bude natrvalo odstránená.",
        LockedWhileLive:
          "Aktívnu story nie je možné upravovať, kým nevyprší alebo nie je deaktivovaná.",
        UnpublishSuccess: "Story bola deaktivovaná",
        UnpublishError: "Deaktivácia story zlyhala",
        UnpublishConfirmTitle: "Deaktivovať story?",
        UnpublishConfirm:
          "Divákom zmizne okamžite. Neskôr ju môžete upraviť a znova publikovať; opätovné publikovanie čerpá ďalší slot z denného limitu autora.",
        NotLiveAnymore: "Story už nie je aktívna, zoznam bol obnovený",
      },
      Form: {
        CreateTitle: "Nová story",
        EditTitle: "Upraviť story",
        SaveAndPublish: "Uložiť a publikovať",
        SaveDraft: "Uložiť ako koncept",
        Save: "Uložiť",
        SaveSuccess: "Story bola uložená",
        SaveError: "Uloženie zlyhalo",
      },
    },
    PostStory: {
      StoryImage: "Obrázok story",
      StoryVideo: "Video story",
      Text: "Text",
      ButtonLabel: "Popis tlačidla",
      ButtonUrl: "Odkaz tlačidla",
      SheetSection: "Detail ponuky",
      SheetTitle: "Názov",
      SheetDescription: "Popis",
      SheetPrice: "Cena",
      SheetPriceNote: "Poznámka k cene",
      SheetImage: "Obrázok ponuky",
      Form: {
        Format: {
          Title: "Formát",
          Subtitle: "Vyberte jeden — story je buď fotka, alebo video.",
          PhotoTitle: "Foto story",
          PhotoHint: "{{formats}} · zobrazí sa na {{seconds}} sekúnd",
          VideoTitle: "Video story",
          VideoHint: "{{formats}} · najviac {{seconds}} sekúnd",
        },
        Media: {
          PhotoTitle: "Fotka",
          PhotoSubtitle:
            "Najlepšie vyzerá na výšku 9:16. Najviac {{megabytes}} MB.",
          VideoTitle: "Video",
          VideoSubtitle:
            "Najlepšie vyzerá na výšku 9:16. Najviac {{seconds}} sekúnd a {{megabytes}} MB.",
          PosterLabel: "Úvodný obrázok",
          PosterHint:
            "Nepovinné. Bez úvodného obrázka sa story otvorí na čiernej snímke, kým sa video nespustí.",
        },
        Text: {
          Title: "Text",
        },
        Button: {
          Title: "Tlačidlo",
          Subtitle:
            "Zobrazí sa na story a otvorí túto ponuku. Odkaz sa použije na tlačidle vnútri ponuky.",
          LabelPlaceholder: "napr. Získať ponuku",
          UrlPlaceholder: "https://…",
        },
        Offer: {
          Subtitle: "Pripojte k story ponuku z marketplace.",
          Attach: "Pripojiť ponuku",
          Remove: "Odobrať ponuku",
        },
      },
      LimitExceeded:
        "Dosiahli ste maximálny počet story za posledných 24 hodín. Skúste to prosím neskôr.",
      UsageLabel:
        "Publikované story za posledných 24 hodín: {{used}} / {{limit}}",
      Validation: {
        MediaRequired: "Story musí obsahovať obrázok alebo video",
        ButtonUrlInvalid: "Zadajte platný odkaz začínajúci https://",
        ButtonLabelRequired:
          "Ponuka potrebuje popis tlačidla, ktorým sa otvorí",
      },
    },
  },
  Common: {
    LoadMore: "Načítať ďalšie",
    BackToMoone: "Späť do {{appName}}",
    DownloadError: "Stiahnutie súboru sa nepodarilo",
    SaveError: "Uloženie sa nepodarilo",
    UnknownUserType: "Neznámá role",
    Unsupported: "nepodporované",
    Retry: "Skúsiť znova",
    Restore: "Obnoviť",
    TaxNumber: "DIČ",
    VatNumber: "IČ DPH",
    VatStatus: {
      [VatStatus.Unknown]: "Neoverené",
      [VatStatus.NotRegistered]: "Nie je registrovaný pre DPH",
      [VatStatus.Registered]: "Platné IČ DPH",
      [VatStatus.Payer]: "Platiteľ DPH",
      [VatStatus.RegisteredNonPayer]: "Identifikovaná osoba pre DPH",
    },
    VatRegistryStatusLabel: "Stav v registri DPH",
    VatRegistryStatus: "Stav v registri DPH: {{status}}",
    VatRegistryUnavailableHint:
      "Register DPH teraz neodpovedal. IČ DPH môžete doplniť teraz alebo kedykoľvek neskôr.",
    VatNumberRejectedByRegistry:
      "Toto IČ DPH register DPH nepozná. Skontrolujte, či je zadané správne — inak bude plnenie fakturované s českou DPH.",
    Restart: "Restart",
    Loading: "Načítání",
    ThankYou: "Ďakujeme",
    Disable: "Deaktivovat",
    Notes: "Poznámky",
    Copy: "Kopírovať",
    Status: "Stav",
    Balance: "Zostatok",
    ComingSoon: "Obsah pripravujeme",
    Month: "Mesiac",
    NotAvailable: "Nie je k dispozícii",
    Verification: {
      Verified: "Overené",
      NotVerified: "Neoverené",
    },
    User: "Používateľ",
    AnonymousUser: "Používateľ {{appName}}",
    UnnamedChannel: "Bez názvu",
    SearchMinCharsHint:
      "Hľadajte podľa @prezývky alebo mena, zadajte aspoň {{minChars}} znaky.",
    MoreOptions: "Ďalšie možnosti",
    RiskProfileStatus: {
      NotVerified: "Neoverené",
      LowRisk: "Nízke",
      MediumRisk: "Stredné",
      HighRisk: "Vysoké",
      Unacceptable: "Neprijateľné",
    },
    UserType: {
      Hunter: "Hunter",
      Customer: "Používateľ",
      Merchant: "Obchodník",
      Admin: "Administrátor",
      Aml: "AML",
      Employee: "Zamestnanec",
      CustomerOnboarding: "Onboarding zákazníkov",
      HunterPlus: "Hunter+",
      AdminLite: "Admin (iba na čítanie)",
      Disponent: "Disponent",
      Child: "Dieťa",
    },
    FacilityCategory: {
      Restaurants: "Reštaurácie",
      Food: "Jedlo",
      Car: "Auto",
      Electronics: "Elektronika",
      ClothingAndShoes: "Oblečenie a obuv",
      HealthAndBeauty: "Zdravie a krása",
      Finance: "Financie",
      LeisureTime: "Voľný čas",
      PhoneTvAndInternet: "Telefón, TV a internet",
      Housing: "Bydlenie",
      Travel: "Cestovanie",
      Insurance: "Poistenie",
      Education: "Vzdelávanie",
      Institutions: "Inštitúcie",
      ConstructionAndMaintenance: "Stavebníctvo a údržba",
      ECommerceAndOnlineServices: "E-commerce a online služby",
      PersonalServices: "Osobné služby",
      LegalAndConsultingServices: "Právne a poradenské služby",
      IndustrialProductionAndProcessing: "Priemyselná výroba a spracovanie",
      Other: "Ostatné",
    },
    WeekDay: {
      Monday: "Pondelok",
      Tuesday: "Utorok",
      Wednesday: "Streda",
      Thursday: "Štvrtok",
      Friday: "Piatok",
      Saturday: "Sobota",
      Sunday: "Nedeľa",
    },
    GeneralInfo: "Základné informácie",
    Yes: "Áno",
    No: "Nie",
    Next: "Ďalej",
    Close: "Zavrieť",
    Open: "Otvoriť",
    Clear: "Vymazať",
    Pause: "Pozastaviť",
    Play: "Prehrať",
    Mute: "Stlmiť",
    Unmute: "Zapnúť zvuk",
    BeneficialOwner: {
      Title: "Skutočný vlastník",
      Name: "Meno",
      LastName: "Priezvisko",
      Gender: "Pohlavie",
      BirthDate: "Dátum narodenia",
      Nationality: "Štátna príslušnosť",
      IsForeigner: "Skutočný vlastník je cudzinec",
    },
    Address: {
      Title: "Adresa",
      NoAddressAvailable: "Žiadna dostupná adresa",
      Type: {
        [AddressType.Permanent]: "Trvalé bydlisko",
        [AddressType.Mail]: "Korešpondenčná adresa",
        [AddressType.Headquarters]: "Sídlo",
      },
      Street: "Ulica",
      StreetNumber: "Súpisné číslo",
      OrientationNumber: "Orientančné číslo",
      PostalCode: "PSČ",
      Municipality: "Mesto",
    },
    Licenses: "Licencie",
    QRPayment: "QR platba",
    ShareToBankApp: "Zdieľať",
    AppName: "{{appName}}",
    Amount: "Suma",
    TotalAmount: "Celková suma",
    Note: "Poznámka",
    MandatoryNoteDescription:
      "Poznámku je potrebné uviesť! Bez poznámky nebude platba spárovaná.",
    Unknown: "Neznáme",
    UnknownRecipient: "Neznámy príjemca",
    ShowAll: "Zobraziť všetko",
    ShowMore: "Zobraziť viac",
    ShowLess: "Zobraziť menej",
    ShowProfile: "Zobraziť profil",
    VariableSymbol: "Variabilný symbol",
    Required: "Povinné pole",
    InvalidIBAN: "Neplatný IBAN",
    CancelEdit: "Zrušiť úpravy",
    Cancel: "Zrušiť",
    Confirm: "Potvrdiť",
    UnsavedChangesTitle: "Neuložené zmeny",
    UnsavedChangesWarning:
      "Máte neuložené zmeny. Naozaj chcete zavrieť formulár? Všetky neuložené údaje budú stratené.",
    DiscardChanges: "Zahodiť zmeny",
    NiceDay: "Pekný deň",
    Send: "Odoslať",
    Continue: "Pokračovať",
    FillMissing: "Vyplňte všetky povinné údaje",
    IncompleteSection: "Údaje v tejto sekcii nie sú kompletné",
    FirstName: "Meno",
    LastName: "Priezvisko",
    Gender: "Pohlavie",
    PersonalNumber: "Rodné číslo",
    BirthPlace: "Miesto narodenia",
    Nationality: "Štátna príslušnosť",
    OtherNationalities: "Ďalšia štátna príslušnosť",
    Number: "Číslo",
    Type: "Typ",
    IdentityDocument: "Doklad totožnosti",
    Contact: "Kontakt",
    Phone: "Telefón",
    PhoneVerified: "Telefón overený",
    PhoneVerificationDescription:
      "Prosím overte svoje telefónne číslo. Pomáha to chrániť {{appName}} pred spamom a falošnými účtami.",
    Remove: "Odobrať",
    Replace: "Nahradiť",
    Optional: "nepovinné",
    Delete: "Odstrániť",
    Edit: "Upraviť",
    Verify: "Overiť",
    BirthDate: "Dátum narodenia",
    AccountNumber: "Číslo účtu",
    TransactionPaymentCode: "ID transakcie",
    IBAN: "IBAN",
    Save: "Uložiť",
    Saved: "Uložené",
    DownloadQRCode: "Uložiť QR kód",
    Email: "E-mail",
    Login: "Login",
    CompanyName: "Názov subjektu",
    CompanyNumber: "IČO",
    PartyTypeLabel: "Forma podnikania",
    Back: "Späť",
    PartyType: {
      [PartyType.LegalEntity]: "Právnická osoba",
      [PartyType.SelfEmployed]: "SZČO",
      [PartyType.NaturalPerson]: "Fyzická osoba",
    },
    PartyTypeShortcut: {
      [PartyType.LegalEntity]: "PO",
      [PartyType.SelfEmployed]: "SZČO",
      [PartyType.NaturalPerson]: "FO",
    },
    Sent: "Odoslané",
    UnknownDate: "Neznámy dátum",
    Time: {
      TimePassed: {
        Now: "práve teraz",
        Minute: "pred minútou",
        Hour: "pred hodinou",
        Day: "pred dňom",
        Week: "pred týždňom",
        Month: "pred mesiacom",
        Year: "pred rokom",
        Minute_one: "pred {{count}} minútou",
        Minute_few: "pred {{count}} minútami",
        Minute_other: "pred {{count}} minútami",
        Hour_one: "pred {{count}} hodinou",
        Hour_few: "pred {{count}} hodinami",
        Hour_other: "pred {{count}} hodinami",
        Day_one: "pred {{count}} dňom",
        Day_few: "pred {{count}} dňami",
        Day_other: "pred {{count}} dňami",
        Week_one: "pred {{count}} týždňom",
        Week_few: "pred {{count}} týždňami",
        Week_other: "pred {{count}} týždňami",
        Month_one: "pred {{count}} mesiacom",
        Month_few: "pred {{count}} mesiacmi",
        Month_other: "pred {{count}} mesiacmi",
        Year_one: "pred {{count}} rokom",
        Year_few: "pred {{count}} rokmi",
        Year_other: "pred {{count}} rokmi",
      },
      TimeRemaining: {
        Minute: "minúta",
        Hour: "hodina",
        Day: "deň",
        Week: "týždeň",
        Month: "mesiac",
        Year: "rok",
        Minute_one: "{{count}} minúta",
        Minute_few: "{{count}} minúty",
        Minute_other: "{{count}} minút",
        Hour_one: "{{count}} hodina",
        Hour_few: "{{count}} hodiny",
        Hour_other: "{{count}} hodín",
        Day_one: "{{count}} deň",
        Day_few: "{{count}} dni",
        Day_other: "{{count}} dní",
        Week_one: "{{count}} týždeň",
        Week_few: "{{count}} týždne",
        Week_other: "{{count}} týždňov",
        Month_one: "{{count}} mesiac",
        Month_few: "{{count}} mesiace",
        Month_other: "{{count}} mesiacov",
        Year_one: "{{count}} rok",
        Year_few: "{{count}} rokov",
        Year_other: "{{count}} rokov",
      },
    },
    Price: "Cena",
    License: "Licencia",
    QRInstructions:
      "Neopisujte údaje ručne, využite QR kód, ktorý načítate vo vašom mobilnom bankovníctve!",
  },
  CodeLists: {
    IdentificationList: {
      IDCard: "Občiansky preukaz",
      Passport: "Pas",
      DrivingLicense: "Vodičský preukaz",
      Other: "Iný",
    },
    IdentityDocumentVerdict: {
      NotChecked: "Neskontrolované",
      Approved: "Schválené",
      Declined: "Zamietnuté",
      InReview: "Na ručnú kontrolu",
      Unavailable: "Kontrola nedostupná",
    },
  },
  Errors: {
    MissingId: "Chyba: chýbajúca ID entity",
    DataLoadingError: "Data sa nepodarilo načítať",
    RequestError:
      "Omluváme sa, ale niečo sa pokazilo, skúste to prosím znovu neskôr.",
    ApplicationError: {
      Title: "Nastala chyba",
      Home: "Domov",
      ErrorOccurred: "Je nám ľúto, ale v aplikácii došlo k chybe",
      TeamHasBeenInformed:
        "Naši programátori už o chybe boli informovaní a na oprave už pracujú.",
      AreYouDeveloper: "Ste programátor? Pozrite v čom bola chyba.",
    },
    Error404: {
      Subtitle: "Stránka nebola nájdená",
      Home: "Domov",
    },
    Error403: {
      Subtitle: "K zobrazeniu tejto stránky nemáte prístupové práva",
    },
    NoUserRole: "Chyba, uživatel nemá priradenú žiadnu rolu",
    UnknownError: "Nastala neznáma chyba",
  },
  Offline: {
    Title: "Ste offline",
    NoInternet: "Skontrolujte pripojenie k internetu a skúste to znova.",
    ServerUnreachable: {
      Title: "Problémy s pripojením",
      Message:
        "Momentálne máme technické problémy. Ospravedlňujeme sa za komplikácie, pracujeme na ich vyriešení.",
    },
    Reconnected: "Pripojenie obnovené",
  },
  SignIn: {
    Title: "Prihlásenie",
    Form: {
      Controls: {
        SignInButtonLabel: "Prihlásiť",
        CancelButtonLabel: "Zrušiť",
        ForgottenPassword: "Zapomneli ste heslo?",
      },
      Fields: {
        Email: "E-mail",
        Password: "Heslo",
      },
    },
    Error: {
      General: "Nastala chyba",
      Forbidden: "Špatné heslo alebo e-mail",
      InvalidLogin: "Špatné heslo alebo e-mail",
      InvalidCredentials: "Špatné heslo alebo e-mail",
      ApplicationVerification: "Špatné heslo alebo e-mail",
      PhoneNumberNotFound: "Telefónne číslo nebolo nájdené",
      SmsSendingFailed: "Selhalo odosielanie SMS",
      InvalidToken: "Nevalidný token",
      AccountNotFound: "Špatné heslo alebo e-mail",
      NotFound: "Špatné heslo alebo e-mail",
      AccountIsDeactivated:
        "Účet bol deaktivovaný. Ak chcete účet obnoviť, kontaktujte podporu.",
      AccountLinkedToIdentity:
        "Tento účet bol prevedený pod váš hlavný účet. Prihláste sa prosím e-mailom, ktorý používate ako hlavný účet.",
    },
  },
  SignUp: {
    Title: {
      Merchant: "Nový obchodný účet",
      Customer: "Nový osobný účet",
      Hunter: "Nový hunter účet",
    },
    Form: {
      Controls: {
        SignUpButtonLabel: "Vytvoriť účet",
      },
      Fields: {
        Login: "E-mail",
        Password: "Heslo",
        AgreeWithTermsAndConditions: {
          MooneLite: {
            Text: "Vytvorením účtu súhlasím s",
            LinkText: "obchodnými podmienkami služby {{appName}} Lite",
            LinkUrl: "/content/terms/Moone-moone-lite.pdf",
          },
          EULACheckboxLabel: {
            StartText: "Registráciou do aplikácie {{appName}} zavíram",
            ContractText: "Smluvou o poskytovaní platobných služieb",
            ContractUrl:
              "/content/terms/2A-Moone-precontract-contract-info.pdf",
            MiddleText: "s spoločnosťou Mo.one a.s., ktorej súčasťou sú tieto",
            RelatedDocsText: "Súvisiace podmienky",
            RelatedDocsUrl: "/content/terms/2B-Moone-related-docs.pdf",
          },
          HunterEULACheckboxLabel: {
            StartText: "Objednávaním a zaplatením licencie zavíram",
            ContractText: "Smluvou o digitálnej franšíze",
            ContractUrl:
              "/content/terms/legione-hunters-franchise-contract.pdf",
            MiddleText: "s LEGI.ONE LTD., ktorej súčasťou sú tieto",
            RelatedDocsText: "Súvisiace podmienky",
            RelatedDocsUrl: "/content/terms/2-hunters-related-terms.pdf",
          },
          FullMooneEULA: {
            StartText: "Vytvorením účtu súhlasím s",
            ContractText: "Smluvou o poskytovaní platobných služieb",
            ContractUrl:
              "/content/terms/2A-Moone-precontract-contract-info.pdf",
            MiddleText: "s spoločnosťou Mo.one a.s., ktorej súčasťou sú tieto",
            RelatedDocsText: "Súvisiace podmienky",
            RelatedDocsUrl: "/content/terms/2B-Moone-related-docs.pdf",
          },
        },
      },
    },
    Error: {
      General: "Nastala chyba",
      UserExists: "Účet už existuje",
      WeakPassword:
        "Heslo musí mať aspoň 8 znakov, obsahovať jedno malé, jedno veľké písmeno a jedno číslo",
    },
    AffiliateLandingDisclaimer: {
      Title: "Už máš účet Mo.one?",
      Body: "Ak už účet máš, namiesto registrácie sa prihlás a oznám svoj e-mail tomu, kto ťa pozýva — pošle ti pozvánku priamo do schránky v aplikácii.",
      SignInButton: "Prihlásiť sa",
    },
  },
  Validation: {
    InvalidLogin: "Login nie je platný",
    InvalidPersonalNumber: "Neplatné rodné číslo",
    OtherNationalitySameAsPrimary:
      "Ďalšia štátna príslušnosť musí byť iná ako hlavná",
    InvalidVatNumber: "Neplatný tvar IČ DPH",
    PersonalNumber:
      "Rodné číslo musí mať maximálne {{count}} číslic, číslo zadajte bez lomítka",
    CompanyName: "Názov subjektu je povinný",
    CompanyNumber: "IČO musí mať {{count}} číslic",
    Phone: {
      InvalidFormat: "Neplatný formát telefónneho čísla",
      MinDigits: "Telefónne číslo musí obsahovať aspoň {{count}} číslic",
      MaxCharacters:
        "Telefónne číslo nesmí obsahovať viac než {{count}} znakov",
    },
    Required: "Povinné pole",
    InvalidEmail: "E-mail je neplatný",
    InvalidUrl: "URL je neplatná",
    Password: {
      Match: "Heslá sa musia zhodovať",
      MatchRequirement: "Heslá sa zhodujú",
      Required: "Vyplňte heslo",
      MinLength: "Aspoň {{length}} znakov",
      MinLowercase: "Aspoň jedno malé písmeno",
      MinUppercase: "Aspoň jedno veľké písmeno",
      MinNumber: "Aspoň jedno číslo",
    },
    EulaAgreement: "Musíte súhlasiť s obch. podmienkami",
    WalletAddress: "U vlastnej peňaženky musíte vyplniť jej adresu.",
    InvalidBankAccount: "Neplatný bankový účet",
    InvalidPostalCode: "Zadajte PSČ vo formáte 811 01",
    ResidenceRequired:
      "Doplňte miesto bydliska osoby — ulicu alebo číslo domu, obec a PSČ",
    ExpirationAfterScheduled: "Dátum expirácie musí byť po naplánovanom dátume",
    DateMustBeInFuture: "Dátum musí byť v budúcnosti",
    TimeMustBeInFuture: "Čas musí byť v budúcnosti",
    MaxLength: "Toto pole nesmie mať viac ako {{count}} znakov",
  },
  ValidationMessages: {
    Required: "Vyplňte prosím pole",
    ArrayMinOne: "Musí byť vybraná aspoň jedna možnosť",
    TooSmallString: "Musí obsahovať aspoň {{minimum}} znakov",
    TooBigString: "Nesmie obsahovať viac než {{maximum}} znakov",
    InvalidEmail: "Zadajte platnú e-mailovú adresu",
    InvalidUrl: "Zadajte platnú URL adresu",
  },
  Menu: {
    BottomMenuItems: {
      Overview: "Prehľad",
      History: "Transakcie",
      InitiateKeypadPayment: "Pokladňa",
      ActionButton: "Zaplatiť",
      Accounts: "Účty",
      Settings: "Viac",
      Merchants: "Obchodníci",
      Licenses: "Licencie",
      NewMerchant: "Obchodník",
      Users: "Používatelia",
      Stardust: "Stardust",
      Valor: "Valor",
      Settlement: "Vyúčtovanie",
      ThanksToYou: "Vďaka Tebe!",
      NotificationsManagement: "Notifikácie",
      ToBeVerified: "Na overenie",
      Hunters: "Hunteri",
      WhereToPay: "Kde platiť",
      Chat: "Chat",
    },
    Help: "Nápoveda",
    Logout: "Odhlásiť sa",
  },
  Onboarding: {
    ProcessTitle: "Informácie o Vás",
    Title: "Overte svoju totožnosť",
    LoadingTitle: "Informácie o Vás",
    ErrorTitle: "Chyba aplikácie",
    BeneficialOwnersTitle: "Skutoční majitelia",
    LicenseSelectionTitle: "Vitajte v Legi.one",
    ManualLicensePaymentTitle: "Platba licencie",
    BankAccountVerificationTitle: "Overenie účtu",
    PoliticallyExposed: {
      Title: "Som politicky exponovaná osoba",
      Alert:
        "Politicky exponovaným osobám, žiaľ, zatiaľ nemôžeme službu poskytnúť.",
    },
    HunterDescription: {
      IdentityVerification:
        "Než spolu oficiálne začneme, potrebujeme overiť tvoju totožnosť.",
      HCRMDescription:
        "HCRM (Hunter & Customer Relationship Manager) je tvoje osobné pracovné prostredie v rámci Legi.one.",
      RemoteContract:
        "Odtiaľto budeš registrovať nových obchodníkov, sledovať svoju sieť, spravovať odmeny a mať prehľad o všetkom dôležitom. Je to tvoja digitálna základňa.",
      DocumentSecurity:
        "Pretože spolu uzatvárame zmluvu na diaľku, potrebujeme si overiť, že si to naozaj ty.",
      QuickProcess:
        "Je to ten istý princíp, ako keď podpisuješ zmluvu s operátorom alebo finančnou službou online – bez osobného stretnutia je overenie nevyhnutné.",
      Welcome: "Vitaj v Legi.one HCRM!",
      IdentityVerificationRequired:
        "Než spolu oficiálne začneme, potrebujeme overiť tvoju totožnosť.",
      HCRMWorkEnvironment:
        "Odtiaľto budeš registrovať nových obchodníkov, sledovať svoju sieť, spravovať odmeny a mať prehľad o všetkom dôležitom. Je to tvoja digitálna základňa.",
      RemoteContractVerification:
        "Pretože spolu uzatvárame zmluvu na diaľku, potrebujeme si overiť, že si to naozaj ty.",
      VerificationPrinciple:
        "Je to ten istý princíp, ako keď podpisuješ zmluvu s operátorom alebo finančnou službou online – bez osobného stretnutia je overenie nevyhnutné.",
      QuickProcessAndWelcome:
        "Stačí minúta – a potom môžeš začať naplno využívať všetky funkcie HCRM. Vitaj v tíme!",
    },
    MerchantOrCustomerDescription: {
      Welcome: "Vitajte v {{appName}}!",
      IdentityVerificationRequired:
        "Než Vám otvoríme účet, potrebujeme overiť Vašu totožnosť.",
      MoonePaymentIdentity:
        "{{appName}} nie je len aplikácia – je to vaša platobná identita.",
      PaymentIdentityDescription:
        "Vďaka nej budete platiť, potvrdzovať transakcie a bezpečne sa preukazovať naprieč službami. Preto je dôležité overiť, že ste to skutočne vy.",
      LicensedPaymentInstitution:
        "Sme licencovaná platobná inštitúcia pod dohľadom Českej národnej banky.",
      BankLevelIdentityVerification:
        "Pri overovaní totožnosti pre nás platia rovnaké pravidlá ako pre banky – ukladá nám ich zákon č. 253/2008 Zb., o niektorých opatreniach proti legalizácii výnosov z trestnej činnosti a financovaniu terorizmu.",
      DocumentsUsagePurpose:
        "Vaše doklady slúžia výhradne na tento účel. Sú šifrované, chránené a nikdy ich nepoužijeme inak bez vášho výslovného súhlasu.",
      QuickProcessAndThankYou:
        "Zvládnete to za minútu – a potom môžete {{appName}} začať naplno využívať. Ďakujeme, že nám dôverujete.",
    },
    Steps: {
      Documents: {
        NoOwningPartyError: "Nepodarilo sa načítať údaje o používateľovi",
        Declined: {
          Title: "Doklad neprešiel automatickou kontrolou",
          Description:
            "Skúste doklad odfotiť znova (nie sken ani snímku obrazovky), alebo pokračujte – doklad potom overí náš operátor ručne.",
          Retry: "Nahrať znova",
          Continue: "Pokračovať s ručnou kontrolou",
          AttemptsLeft: "Zostávajúci počet pokusov: {{count}}",
          AttemptsExhausted:
            "Automatickú kontrolu už nie je možné opakovať. Pokračujte ďalším krokom, doklad overí náš operátor.",
          Reasons: {
            DocumentExpired: "Doklad má uplynutú platnosť.",
            NotOriginal:
              "Nejde o fotografiu fyzického dokladu (sken, kópia alebo snímka obrazovky).",
            Unreadable:
              "Doklad je nečitateľný – odfoťte ho celý, ostro a bez odleskov.",
            Unsupported: "Tento typ dokladu nevieme automaticky overiť.",
            Generic: "Automatická kontrola doklad nepotvrdila.",
          },
        },
        ExistingDocumentsInfo:
          "Vaše doklady sú už nahrané a prebieha ich spracovanie. Môžete pokračovať ďalším krokom.",
        LoadingError: "Nepodarilo sa načítať údaje, skúste to prosím neskôr.",
        Processing: "Spracovávame údaje. Chvíľku strpenia.",
        ProcessingFailed:
          "Nepodarilo sa spracovať údaje z občianskeho preukazu",
        FirstDocumentTitle: "Občiansky preukaz",
        SecondDocumentTitle: "Druhý doklad",
        SecondDocumentDescription:
          "Druhým dokladom môže byť vodičský preukaz alebo cestovný pas.",
        Forms: {
          DocumentTitle: "Nahrať sken dokladu",
          DocumentDescription: "Kliknite sem pre nahranie alebo odfotenie",
          FrontSide: "Predná strana občianskeho preukazu",
          BackSide: "Zadná strana občianskeho preukazu",
          SecondDocumentFrontSide: "Predná strana druhého dokladu",
          SecondDocumentBackSide: "Zadná strana druhého dokladu",
          SecondDocumentTypeLabel: "Typ druhého dokladu",
          SecondDocumentTypePassport: "Cestovný pas",
          SecondDocumentTypeDrivingLicense: "Vodičský preukaz",
          SecondDocumentTypeOther: "Iný",
        },
        Validations: {
          ForegroundMissing:
            "Nahrajte prosím prednú stranu občianskeho preukazu",
          BackgroundMissing:
            "Nahrajte prosím zadnú stranu občianskeho preukazu",
          SecondForegroundMissing:
            "Nahrajte prosím prednú stranu druhého dokladu",
          SecondBackgroundMissing:
            "Nahrajte prosím zadnú stranu druhého dokladu",
          SecondDocumentTypeMissing: "Vyberte prosím typ druhého dokladu",
        },
      },
      PersonalInformation: {
        SaveError: "Chyba pri ukladaní údajov",
        LoadingError: "Chyba pri načítaní údajov",
        Title: "Z nahraných dokladov sme vyčítali nasledujúce údaje:",
        DataConfirmation: "Potvrdzujem správnosť základných údajov a adresy",
        StardustParticipation: {
          Text: "Súhlasím so zaradením do vernostného programu",
          LinkText: "Stardust",
          LinkUrl: "/content/terms/Moone-stardust-general.pdf",
        },
        ThanksToYouParticipation: {
          Text: "Súhlasím so zaradením do programu odporúčaní",
          LinkText: "Vďaka Tebe!",
        },
        FormGroups: {
          PersonalInformation: "Základné údaje",
          Address: "Adresa",
          IdentityDocument: "Doklad totožnosti",
        },
        DocumentValidity: {
          Generic: "Platnosť dokladu",
          From: "Platnosť dokladu od",
          To: "Platnosť dokladu do",
        },
        ScanIncomplete:
          "Niektoré hodnoty sa nepodarilo načítať, bude vykonaná kontrola naším pracovníkom.",
        DataMarkedAsIncorrect:
          "Ďakujeme za informáciu, do 24h bude vykonaná kontrola naším pracovníkom.",
        DocumentIssued: "Doklad vydal",
        StreetAddress: "Ulica",
        ConfirmDataRequest: "Musíte potvrdiť správnosť údajov",
        UseCompanyAddress: "Bývam na adrese sídla firmy",
        ValueLabels: {
          PersonalInfo: {
            FirstName: "Meno",
            LastName: "Priezvisko",
            PersonalNumber: "Rodné číslo",
            BirthPlace: "Miesto narodenia",
            Gender: "Pohlavie",
            Nationality: "Štátna príslušnosť",
          },
          AddressInfo: {
            StreetWithNumber: "Ulica a súpisné číslo",
            Municipality: "Mesto",
            PostalCode: "PSČ",
          },
          DocumentInfo: {
            Type: "Typ",
            Number: "Číslo",
            Validity: "Platnosť",
            Issued: "Vydal",
          },
        },
      },
      FinalStep: {
        SubmitButton: "Dokončiť",
        LoadingError: "Chyba, nepodarilo sa načítať potrebné údaje.",
        SuccessToast: "Vaše údaje boli úspešne odoslané.",
        Form: {
          HasNonEUResidence:
            "Mám aktuálne (ke dni registrácie) bydlisko mimo EU po dobu dlhšiu než 12 mesiacov",
          HasNonEUNationality: "Som štátnym príslušníkom inej krajiny mimo EÚ",
        },
      },
    },
    BusinessOnboarding: {
      Steps: {
        LicenseSelection: {
          Title: "Vitajte v Legi.one",
          Description:
            "Kúpou licencie získavate právo stať sa hunterom pre Legi.one.",
          AlreadyOwned: "Túto licenciu už vlastníte.",
          Form: {
            PriceIncludesVAT: "Uvedené ceny sú včetně 21% DPH.",
            ChooseLicense: "Vyberte verziu licencie, ktorú si chcete zakúpiť.",
            WalletCheckboxLabel: "Chcem poslať do vlastnej peňaženky",
            PrivateWalletAddress: "Adresa peňaženky",
            PrivateWalletAddressDescription:
              "Zadajte adresu svojej peňaženky na Polygon blockchaine.",
            NoLicensesAvailableForCountry:
              "Pre zvolenú krajinu už nie sú k dispozícii žiadne dostupné licencie.",
            SelectCountryFirst:
              "Pre objednávku licencie najprv vyberte krajinu.",
            SubmitButton: "Objednať a zaplatiť",
            SeePaymentDetails: "Zobraziť platobné údaje",
            AlreadyOrdered: "Túto licenciu ste si už objednali.",
          },
        },
        BankAccount: {
          Title: "Pripojenie účtu",
          AvailableBanks: "Ponuka bánk",
          BanksComingSoon: "Banky, ktoré pripravujeme",
        },
        FacilityCompletion: {
          Title: "Údaje o prevádzke",
          Description:
            "Doplňte prosím údaje o svojich prevádzkach. Vyplňte adresu, kontaktné údaje a ďalšie potrebné informácie. Ak nemáte prevádzku, tento krok preskočte a kliknite nižšie na Pokračovať.",
          IncompleteFacilitiesWarning:
            "Niektoré prevádzky nie sú dokončené. Doplňte prosím ich údaje, alebo ich najskôr odstráňte.",
          OrbitLFacilityRequiredWarning:
            "Pre aktiváciu terminálu je potrebné pridať prevádzku s fotografiami.",
          ContinueWithoutFacility: "Pokračovať bez prevádzky",
        },
        OwnerModal: {
          Title: "Informácie o skutočnom vlastníkovi",
        },
        BeneficialOwners: {
          SaveError: "Chyba pri ukladaní údajov o vlastníkovi",
          Title: "Skutočný vlastník",
          Question: "Ste jediným skutočným vlastníkom firmy?",
          SecondaryQuestion: "Viete, kto sú skutoční vlastníci?",
          Description:
            "Skutočným vlastníkom je každá fyzická osoba, ktorá v konečnom dôsledku tzv. vlastní alebo kontroluje právnickú osobu alebo právne usporiadanie",
          CheckboxTitle: "Som skutočný vlastník",
          CheckboxDescription:
            "Skutočným vlastníkom je každá fyzická osoba, ktorá v konečnom dôsledku tzv. vlastní alebo kontroluje právnickú osobu alebo právne usporiadanie",
          OwnersTitle: "Ďalší skutoční vlastníci",
          AddOwner: "Pridať skutočného vlastníka",
          AddNextOwner: "Pridať ďalšieho skutočného vlastníka",
          UboChoice: {
            IAmOwner: "Áno, som",
            IAmOwnerDescription:
              "Údaje o skutočnom vlastníkovi budú automaticky vyplnené z Vášho profilu",
            NotTheOnlyOwner: "Nie / Je nás viac",
            ManualEntry: "Vložiť",
            ManualEntryDescription:
              "Zadajte údaje o skutočných vlastníkoch ručne",
            Unknown: "Neviem",
            UnknownDescription:
              "Informácia bude overená naším AML špecialistom",
          },
          FormGroups: {
            BasicInformation: "Základné údaje",
            Address: "Adresa",
          },
        },
        IncomeInformation: {
          SaveError: "Chyba pri ukladaní údajov o príjmoch",
          Title: "Informácie o Vás",
          FormGroups: {
            Business: "Vaše podnikanie",
            Personal: "Údaje o Vás",
          },
          Fields: {
            BusinessActivity: "Predmet podnikania",
            SourceOfIncome: "Zdroj príjmov",
            RelationType: "Vaša pozícia",
            IsPoliticallyExposedPerson: "Som politicky exponovaná osoba",
            HasNonEUResidence:
              "Mám aktuálne (ke dni registrácie) bydlisko mimo EU po dobu dlhšiu než 12 mesiacov",
            HasNonEUNationality:
              "Som štátnym príslušníkom inej krajiny mimo EÚ",
            ExpectedMonthlyRevenue: "Očakávaný mesačný objem",
            AverageTransactionValue: "Priemerná hodnota jednej transakcie",
            TaxResidencyCountry: "Daňová rezidencia",
            OtherBusinessActivity: "Upresnite predmet podnikania",
            OtherSourceOfIncome: "Upresnite zdroj príjmov",
          },
        },
        BusinessInformation: {
          SaveError: "Chyba pri ukladaní údajov o podnikateľskom subjekte",
          CompanyNumberAresMismatch:
            "Zadané IČO sa nezhoduje s údajmi subjektu z registra firiem",
          CompanyNumberAlreadyInUse:
            "Toto IČO je už registrované iným obchodníkom",
          LoadingError: "Údaje osoby sa nepodarilo načítať.",
          Title: "Informácie o podnikaní",
          RegionLabel: "Krajina registrácie",
          SlovakVatRegistrationNotice:
            "Upozornenie k IČ DPH: Ak ste zdaniteľná osoba so sídlom v Slovenskej republike a prijímate službu od dodávateľa z iného členského štátu, ste podľa § 7a zákona č. 222/2004 Z. z. o DPH povinný požiadať o registráciu pre daň ešte pred prijatím prvej takejto služby. Registrácia podľa § 7a z vás nerobí platiteľa DPH. Ak nám platné IČ DPH neuvediete, bude plnenie fakturované s českou DPH, ktorú si na Slovensku nemôžete odpočítať ani požiadať o jej vrátenie.",
          FormGroups: {
            BasicInformation: "Základné informácie",
            Headquarters: "Sídlo",
            Contact: "Kontakt",
          },
        },
      },
    },
    BanksInPreparation: "Banky, ktoré pripravujeme",
    PotentialYearlySavings: "Potenciálna ročná úspora",
  },
  Transactions: {
    Title: "Transakcie",
    History: "História",
    NoTransactions: "Nie sú k dispozícii žiadne transakcie.",
    CancelTransaction: "Zrušiť transakciu",
    RefundTransaction: "Vrátiť platbu",
    TransactionCancelError: "Nastala chyba pri zrušení transakcie.",
    InverseTransactionCreated:
      "Bola vytvorená inverzná transakcia, ktorá musí byť potvrdená z užívateľského účtu obchodníka.",
    Payment: {
      Incoming: "Prichádzajúca platba",
      Outgoing: "Odchádzajúca platba",
      Unknown: "Platba",
    },
    Type: {
      Buy: "Nákup",
      Sell: "Predaj",
      Withdrawal: "Výber",
      LeadReward: "Odměna za odporúčanie",
      LeadRewardConsumer: "Odměna za registráciu",
      Voucher: {
        GiftCard: "Darčeková karta",
        SignUpSubsidy: "Darček k registrácii",
      },
      Coinback: "Coinback",
    },
    ErrorPayment: {
      Title: "Nastala chyba",
      TitleNotCompleted: "Platba nebola dokončená",
      Description: "Je nám to ľúto, ale počas platby došlo k problému.",
    },
    SuccessPayment: {
      Title: "Úspešne zaplatené!",
      DescriptionFirstLine: "Peniaze boli úspešne odoslané",
      DescriptionSecondLine: "na účet obchodníka.",
    },
    Anonymous: {
      DownloadReceipt: "Stiahnuť účtenku do zariadenia",
      FillEmail: "Zadajte e-mail, aby sme Vám mohli zaslať účtenku.",
      SignupTitle: "Vytvorte si účet a využívajte výhody {{appName}}",
      Benefits:
        "✨ Zbierajte Stardust a zarábajte s {{appName}}<newline/>🤝 Pomôž svojim lokálnym obchodníkom<newline/>💳 Rýchla platobná metóda vždy po ruke<newline/>📖 História transakcií a financie na jednom mieste",
      CampaignSignupTitle:
        "Vytvorením účtu sa pridáš do tímu {{campaignName}} a pomáhaš každou platbou!",
      CampaignSignupDescription:
        "Vyber si jednu z dostupných možností vytvorenia účtu, zaregistruj sa na jedno kliknutie a plat s Mo.one.",
      CreateAccountViaEmail: "Vytvoriť účet cez E-mail",
      JustWantReceipt: "Chcem len účtenku",
      BackToSignup: "Späť k vytvoreniu účtu",
      LoadingSkeleton: {
        loadingInfo: {
          title: "Overenie platby",
          description:
            "Probíhá kontrola platby <newline/> Načítáme informácie o tejto platbe",
        },
        processingTransaction: {
          title: "Probíhá spracovanie",
          description:
            "Vaša platba sa spracováva <newline/> Čakáme na potvrdenie od Vašej banky",
        },
      },
    },
    Status: {
      Completed: "Vykonané",
      PendingTrade: "Spracováva sa",
      PendingPayout: "Čaká na potvrdenie eshopom",
      WithdrawRequested: "Prebieha výber",
      Withdrawn: "Vykonané",
    },
    TransactionStatus: {
      Created: "Čaká na zaplateni",
      Cancelled: "Zrušená",
      Fail: "Zlyhala",
      Initiated: "Platba bola zahájená",
      Processing: "Prebieha spracovanie",
      Success: "Úspešne prijatá",
      InvestigationNeeded: "Neznámy stav",
    },
    RefundState: {
      Title: "Vratka",
      Refunded: "Refundované",
      Pending: "Čaká na vrátenie",
    },
    TransactionDirection: {
      Incoming: "Prichádzajúca platba",
      Outgoing: "Odchádzajúca platba",
      IncomingRefund: "Prichádzajúce vrátenie platby",
      OutgoingRefund: "Odchádzajúce vrátenie platby",
      Unknown: "Neznámy smer",
    },
    BankTransferInfo:
      "Bankový prevod môže trvať až 2 pracovné dni, záleží na rýchlosti banky.",
    TransactionStatusDescription: {
      Created: "Táto transakcia čaká zaplatenie.",
      Cancelled: "Táto transakcia bola zrušená.",
      Fail: "Transakcia zlyhala.",
      Initiated: "Platba bola zahájená, čakáme na potvrdenie.",
      Processing: "Transakcia sa práve spracováva.",
      Success: "Táto transakcia bola úspešne dokončená.",
      InvestigationNeeded: "Neznámy stav",
    },
    ReceiptOnly: "Chcem len účtenku",
  },
  SetPassword: {
    Error: {
      General: "Nastala chyba.",
      TokenNotFound: "Token je neplatný",
      TokenExpired: "Platnosť odkazu pre nastavenie hesla vypršala.",
      TokenExpiredLinkText: "Požiadať o nový odkaz",
      WeakPassword:
        "Heslo musí mať aspoň 8 znakov, obsahovať jedno malé, jedno veľké písmeno a jedno číslo",
    },
  },
  BankIDVerification: {
    Error: {
      General:
        "Autentifikácia cez BankID sa nepodarila. Skúste to prosím znova.",
      BankIDUserInfoError: "Nepodarilo sa získať údaje z BankID.",
      VerificationAlreadyExists: "Používateľ z BankID už bol overený.",
    },
  },
  Voucher: {
    ApplyError: {
      General: "Nastala chyba",
      NotFound:
        "Zadaný kód nie je správny. Skontrolujte, či je správne opísaný. Ak problémy pretrvávajú, kontaktujte nás.",
      Applied: "Kupón bol použitý",
      UserAccountNotFound: "Používateľ nenájdený",
      UserNotFound: "Používateľ nenájdený",
      UserIsWaitingForEmailVerification: "Používateľ nenájdený",
      InvalidRecaptcha:
        "Recaptcha nie je platná. Obnovte aplikáciu a skúste to znova.",
    },
    ToOverview: "Na prehľad",
    SignIn: "Prihlásiť sa",
    AgreeWith: "Súhlasím s",
    Continue: "Pokračovať",
    CardCodeInstructions: "2. Opište 16-miestny kód z karty",
  },
  Balance: {
    Title: "Prehľad",
    BalanceContent: {
      Title: "Dostupné prostriedky",
      PayMeAction: "Zaplať mi",
      SendPaymentAction: "Platba",
      HiddenBalance:
        "Pre zobrazenie zostatku dokončite registráciu a počkajte na overenie vášho účtu",
      ShowBalance: "Zobraziť zostatok",
      HideBalance: "Skryť zostatok",
      CurrencyCount: "{{count}} mien",
      CurrencyCount_one: "{{count}} mena",
      CurrencyCount_few: "{{count}} meny",
      CurrencyCount_other: "{{count}} mien",
      CurrencySheetTitle: "Moje meny",
    },
  },
  Banking: {
    Auth: {
      Title: "Pripojiť účet",
      Description: "Vyberte si banku, ktorú chcete pripojiť.",
      BankList: {
        Title: "Ponuka bánk",
        ComingSoon: "Pripravujeme",
      },
      BankConnectionInfo:
        "Pripojenie banky je jednorazový proces, pripojte banku a používajte {{appName}} platby neobmedzene!",
      BankConnectionWarning:
        "Upozornenie: Kvalita pripojenia závisí od bánk. Ak máte problém s prihlásením či platbou, kontaktujte svoju banku.",
    },
    AccountSelection: {
      Title: "Pripojenie {{bankName}}",
      Description:
        "Ak niektoré z pripojených účtov s {{appName}} používať nechcete, odoberte ich zo zoznamu nižšie.",
      Cancel: "Zrušiť",
      Confirm: "Potvrdiť",
      AccountsSetUp: "Účty boli úspešne nastavené",
      RemoveError: "Chyba pri odstraňovaní účtov",
      DeleteLaterInfo:
        "Účty môžete tiež odstrániť neskôr v záložke Viac\u00A0→\u00A0Bankové účty.",
      SelectedAccounts: "Vybrať všetko",
      AllAccounts: "Všetky účty",
      WarningMessage:
        "Môžete pripojiť len účet vedený pod Vaším menom. Ak pripojíte cudzí účet, bude zo strany {{appName}} zamietnutý.",
    },
    BanksInPreparation: "Banky, ktoré pripravujeme",
    QRPaymentForeignBank: "Platba cudzou bankou pomocou QR kódu",
    BatchPayments: {
      Title: "Hromadné platby",
      DetailTitle: "Detail hromadnej platby",
      EmptyList: "Zatiaľ neboli vytvorené žiadne hromadné platby.",
      NotFound: "Hromadná platba nebola nájdená.",
      LoadMore: "Načítať ďalšie",
      Account: "Účet",
      TotalAmount: "Celková čiastka",
      PaymentCount: "Počet platieb",
      CreatedAt: "Vytvorené",
      AuthorizedAt: "Autorizované",
      CompletedAt: "Dokončené",
      SignInBank: "Autorizovať v banke",
      PaymentsTable: "Platby",
      Columns: {
        Date: "Dátum",
        Status: "Stav",
        Account: "Účet",
        PaymentCount: "Počet platieb",
        Total: "Celkom",
        Recipient: "Príjemca",
        IBAN: "IBAN",
        VS: "VS",
        Amount: "Čiastka",
      },
      Status: {
        Created: "Vytvorené",
        Initiated: "Čaká na autorizáciu",
        Processing: "Spracováva sa",
        Success: "Dokončené",
        Fail: "Zlyhalo",
        Cancelled: "Zrušené",
      },
    },
  },
  BankNames: {
    CSOB: "ČSOB",
    CSAS: "Česká spořitelna",
    KB: "Komerční banka",
    AirBank: "Air Bank",
    UCB: "UniCredit Bank",
    MONETA: "Moneta Money Bank",
    FIO: "Fio banka",
    MBank: "mBank",
    RB: "Raiffeisenbank",
    Citfin: "Citfin",
    TRINITY: "Trinity Bank",
    PenezniDum: "Peněžní dům",
    Artesa: "Artesa",
    CREDITAS: "CREDITAS",
    NEY: "NEY spořitelní družstvo",
    MaxBanka: "Max banka",
    NRB: "Národní rozvojová banka",
    JandT: "J&T Banka",
    PPF: "PPF banka",
    Oberbank: "Oberbank",
    PartnersBank: "Partners Banka",
    CNB: "Česká národní banka",
    Revolut: "Revolut",
    CZKT: "CZKT",
  },
  BankEnvironmentNames: {
    [BankEnvironment.CSOB_SANDBOX]: "ČSOB",
    [BankEnvironment.CSOB_PROD]: "ČSOB",
    [BankEnvironment.CSAS_SANDBOX]: "Česká spořitelna",
    [BankEnvironment.CSAS_PROD]: "Česká spořitelna",
    [BankEnvironment.KB_SANDBOX]: "Komerční banka",
    [BankEnvironment.KB_PROD]: "Komerční banka",
    [BankEnvironment.AirBank_SANDBOX]: "Air Bank",
    [BankEnvironment.AirBank_PROD]: "Air Bank",
    [BankEnvironment.UCB_SANDBOX]: "UniCredit Bank",
    [BankEnvironment.UCB_PROD]: "UniCredit Bank",
    [BankEnvironment.MONETA_SANDBOX]: "Moneta Money Bank",
    [BankEnvironment.MONETA_PROD]: "Moneta Money Bank",
    [BankEnvironment.FIO_SANDBOX]: "Fio banka",
    [BankEnvironment.FIO_PROD]: "Fio banka",
    [BankEnvironment.MBANK_SANDBOX]: "mBank",
    [BankEnvironment.MBANK_PROD]: "mBank",
    [BankEnvironment.RB_SANDBOX]: "Raiffeisenbank",
    [BankEnvironment.RB_PROD]: "Raiffeisenbank",
    [BankEnvironment.Citfin_PROD]: "Citfin",
    [BankEnvironment.TRINITY_PROD]: "Trinity Bank",
    [BankEnvironment.PenezniDum_PROD]: "Peněžní dům",
    [BankEnvironment.Artesa_PROD]: "Artesa",
    [BankEnvironment.CREDITAS_PROD]: "CREDITAS",
    [BankEnvironment.NEY_PROD]: "NEY spořitelní družstvo",
    [BankEnvironment.MaxBanka_PROD]: "Max banka",
    [BankEnvironment.NRB_PROD]: "Národní rozvojová banka",
    [BankEnvironment.JandT_PROD]: "J&T Banka",
    [BankEnvironment.PPF_PROD]: "PPF banka",
    [BankEnvironment.Oberbank_PROD]: "Oberbank",
    [BankEnvironment.PartnersBank_PROD]: "Partners Banka",
    [BankEnvironment.CNB_PROD]: "Česká národní banka",
    [BankEnvironment.Revolut_SANDBOX]: "Revolut",
    [BankEnvironment.Revolut_PROD]: "Revolut",
    [BankEnvironment.CZKT_SANDBOX]: "CZKT",
    [BankEnvironment.CZKT_PROD]: "CZKT",
  },
  BankRating: {
    Banks: {
      [Bank.CSOB]: {
        Rating: "1.5",
        AdditionalInfo: "",
        Warnings:
          "• Na pripojenie účtu je potrebné kliknúť na QR kód alebo zadať používateľské meno a heslo<linebreak/> • Doručenie push notifikácie z aplikácie Smart Key niekedy trvá až 1 minútu<linebreak/> • Návrat z aplikácie banky späť do {{appName}} je potrebné vykonať manuálne",
        HowToConnect:
          "Pri pripájaní účtu cez mobil kliknite na QR kód, ktorý vás presmeruje priamo do aplikácie Smart Key. Ak neobdržíte push notifikáciu, otvorte Smart Key priamo z menu vášho telefónu a potvrďte požadovanú akciu (napr. platbu) tam. Po pripojení účtu/zaplatení klepnite na šípku späť pre návrat zo Smart Key späť do prostredia {{appName}}. Menšie platby (najmä do 500 Kč) niekedy nemusíte potvrdzovať v aplikácii – v takom prípade posuňte stránku úplne dole a kliknite na zelené tlačidlo vpravo dole.",
        Review:
          "API pripojenie od ČSOB hodnotíme ako priemerné. Pri pripájaní účtu je potrebné kliknúť na QR kód, čo môže byť pre niektorých používateľov mätúce. Texty na webe ČSOB sa na telefóne zobrazujú anglicky. Push notifikácie z aplikácie Smart Key sa občas doručujú s niekoľkosekundovým oneskorením. Chýba automatické presmerovanie späť do prostredia {{appName}}. Pozitívne hodnotíme použitie jednofaktorového overenia pri menších platbách na overené účty, kedy platba prebehne veľmi rýchlo.",
        Email: "ombudsman@csob.cz",
      },

      [Bank.CSAS]: {
        Rating: "2.5",
        AdditionalInfo: "",
        Warnings:
          "• Na pripojenie účtu je potrebné vyplniť Klientské číslo/Používateľské meno a dátum narodenia<linebreak/> • Návrat z aplikácie George späť do {{appName}} je potrebné vykonať manuálne",
        HowToConnect:
          "Pred pripojením účtu si overte, že máte po ruke svoje používateľské meno/klientske číslo, ktoré používate na prihlásenie do internetového bankovníctva. Po pripojení účtu/zaplatení klepnite na šípku späť pre návrat z George späť do prostredia {{appName}}.",
        Review:
          "API pripojenie od Českej sporiteľne hodnotíme ako kvalitné a pomerne stabilné. Push notifikácie fungujú správne a rýchlo. Na pripojenie účtu musí používateľ zadať používateľské meno/klientske číslo a dátum narodenia, čo môže mnohých používateľov obťažovať. Chýba automatické presmerovanie z George späť do prostredia {{appName}}.",
        Email: "ombudsman@csas.cz",
      },

      [Bank.KB]: {
        Rating: "0.5",
        AdditionalInfo: "",
        Warnings:
          "• Na pripojenie účtu je potrebné zadať používateľské meno a svoje telefónne číslo<linebreak/> • Návrat z aplikácie banky späť do {{appName}} je potrebné vykonať manuálne<linebreak/> • Potvrdená platba sa vykoná až po návrate používateľa späť do prostredia {{appName}}!",
        HowToConnect:
          "Na pripojenie účtu musíte zadať svoje používateľské meno, ktorým sa prihlasujete do internetového bankovníctva. <bold>Po potvrdení platby sa musíte vrátiť z aplikácie banky späť do prostredia {{appName}} – inak platba neprebehne!</bold> Ak používate aj aplikáciu KB+, aj aplikáciu KB Kľúč (firemné bankovníctvo), prídu vám dve notifikácie – stačí, ak požadovanú akciu (napr. platbu) potvrdíte v ktorejkoľvek z nich.",
        Review:
          "API pripojenie od Komerčnej banky aktuálne hodnotíme ako používateľsky neprehľadné až nefunkčné. Na pripojenie účtu musí používateľ zadať používateľské meno a následne telefónne číslo, čo môže mnohých obťažovať. Pre jednu akciu vyskakujú súbežne dve notifikácie (z aplikácie KB+ aj KB Kľúč), čo je značne mätúce. Chýba automatické presmerovanie späť do prostredia {{appName}}. Ak sa používateľ nevráti z aplikácie banky (KB+ alebo KB Kľúč) manuálne späť do {{appName}}, už potvrdená platba neprebehne, čo vnímame ako zásadnú prekážku – na problém sme upozornili a robíme maximum, aby ho banka odstránila.",
        Email: "ombudsman@kb.cz",
        NotRecommended: {
          Reason: "Podstatné porušenie regulácie ČNB.",
          WarningText:
            "Pokúšate sa pripojiť Komerčnú banku, ktorá v aktuálnom prevedení porušuje reguláciu Českej Národnej Banky.<linebreak/><linebreak/>Pripojením tejto banky si výrazne skomplikujete platby cez {{appName}}. Zvážte prosím pripojenie inej banky.",
          RiskItButton: "RISKNEM TO S KB",
        },
      },

      [Bank.AirBank]: {
        Rating: "2.5",
        AdditionalInfo: "",
        Warnings:
          "• Neresponzívne zobrazenie webu<linebreak/> • Doručenie push notifikácie z aplikácie MyAir niekedy trvá dlhšie<linebreak/> • Po pripojení účtu odkliknite v MyAir všetky potvrdenia<linebreak/> • Návrat z aplikácie banky späť do {{appName}} je potrebné vykonať manuálne (iOS)",
        HowToConnect:
          "Na pripojenie účtu kliknite na čierne tlačidlo „Prihlásiť cez aplikáciu“, ktoré vás presmeruje priamo do aplikácie MyAir. Ak neobdržíte push notifikáciu, otvorte MyAir priamo z menu vášho telefónu a potvrďte požadovanú akciu (napr. platbu) tam. Vďaka neresponzívnemu zobrazeniu webu banky sa môže stať, že sa na chvíľu stratíte – odporúčame prstom posúvať na obrazovke, stránku si priblížiť a nájsť správne pole či tlačidlo. Po pripojení účtu/zaplatení klepnite na šípku späť pre návrat z MyAir späť do prostredia {{appName}} (platí pre iPhone).",
        Review:
          "API pripojenie Air Bank hodnotíme ako jedno z lepších. Na pripojenie účtu nemusíte zadávať používateľské meno ani heslo. Za negatíva považujeme neresponzívne zobrazenie webu a občasné oneskorené doručenie push notifikácie. Presmerovanie späť do {{appName}} je sprevádzané zbytočným 5-sekundovým čakaním. Chýba automatické presmerovanie späť do prostredia {{appName}} (platí pre iPhone).",
        Email: "info@airbank.cz",
      },

      [Bank.UCB]: {
        Rating: "1.5",
        AdditionalInfo: "",
        Warnings:
          "• Aplikácia SmartBanking je veľmi pomalá<linebreak/> • Banka opakovane žiada o udelenie súhlasu s cookies<linebreak/> • Banka sa pred každou platbou pýta, či sa používateľ nachádza na mobile alebo počítači",
        HowToConnect:
          "Aplikácia je pomalá, počkajte a neponáhľajte sa – platbu po chvíli dokončíte. Pred každou platbou musíte potvrdiť, či sa nachádzate na počítači (Online Banking), mobilnom telefóne (SmartBanking) alebo či ste firemný zákazník (Corporate). Ak od vás banka žiada súhlas s cookies, musíte ho potvrdiť.",
        Review:
          "API pripojenie od UniCredit Bank hodnotíme ako priemerné. Aplikácia SmartBanking je veľmi pomalá, čo neúmerne predlžuje celý proces platby. Negatívne hodnotíme otravné žiadosti o súhlas s cookies a neustále otázky, či sa používateľ pripája z mobilného telefónu, počítača alebo či je korporátnym zákazníkom. Zostatok na účte sa aktualizuje iba 4× denne. Pozitívom je naopak pripájanie účtu priamo cez aplikáciu SmartBanking bez nutnosti poznať používateľské meno či heslo, a tiež automatické presmerovanie z aplikácie banky späť do prostredia {{appName}}.",
        Email: "info@unicreditgroup.cz",
      },

      [Bank.MONETA]: {
        Rating: "4.75",
        AdditionalInfo: "",
        Warnings:
          "Nič zásadné. Ak vo flow narazíte na chybu, dajte nám vedieť – MONETA s nami aktívne komunikuje a spoločne sa pokúsime problém vyriešiť.",
        HowToConnect:
          "Pripojenie bankového účtu v MONETA vykonáte na jedno silné overenie a jeden klik, po potvrdení ste automaticky presmerovaní zo Smart Banky späť do {{appName}}. Rovnako hladko prebieha aj platba – potvrdíte ju v Smart Banke a aplikácia vás sama vráti do {{appName}}.",
        Review:
          "API pripojenie MONETA Money Bank prešlo v roku 2026 výrazným zlepšením a dnes patrí k najlepším na českom trhu. Pripojenie účtu aj platba fungujú na jedno silné overenie a jedno klepnutie, bez nadbytočných prihlásení a s automatickým návratom do {{appName}}. Z pohľadu používateľskej skúsenosti ide o riadnu implementáciu v súlade s reguláciou aj výkladovým stanoviskom Českej národnej banky RS 2025-28 z 27. 11. 2025. Oceňujeme tiež, že MONETA na naše podnety reagovala a sľúbenú opravu platobného flow dodala. Ak by ste napriek tomu objavili chybu, nahláste nám ju – banka s nami komunikuje a pokúsi sa ju odstrániť.",
        Email: "ombudsmanproklienty@moneta.cz",
      },

      [Bank.FIO]: {
        Rating: "4.25",
        AdditionalInfo: "",
        Warnings:
          "Po pripojení účtu aj po potvrdení platby je potrebné klepnúť na tlačidlo „Hotovo“, až potom sa vrátite do {{appName}}. Stav platby sa v {{appName}} načíta s miernym oneskorením – chvíľu vyčkajte, platba prebieha.",
        HowToConnect:
          "Pripojenie účtu aj platbu potvrdíte priamo v aplikácii Fio banky, do ktorej vás {{appName}} automaticky presmeruje. Po potvrdení klepnite na „Hotovo“ a budete presmerovaní späť do {{appName}}.",
        Review:
          "API pripojenie Fio banky hodnotíme veľmi pozitívne, a to na Androide aj iOS. Pripojenie účtu už nevyžaduje zadávanie používateľského mena a hesla a presmerovanie priamo do aplikácie Fio banky a späť funguje spoľahlivo na oboch platformách. Oproti výkladovému stanovisku Českej národnej banky RS 2025-28 z 27. 11. 2025 zostáva vo flow jeden klik navyše – potvrdenie tlačidlom „Hotovo“ – a stav platby sa v {{appName}} načítava o niečo pomalšie, než by sme si priali. Ide o drobnosti, ktoré Fio banku delia od najvyššieho hodnotenia. Ak vo flow objavíte chybu, nahláste nám ju.",
        Email: "fio@fio.cz",
      },
      [Bank.MBank]: {
        Rating: "0.5",
        AdditionalInfo: "",
        Warnings:
          "• Na pripojenie účtu aj vykonanie platby je potrebné vyplniť číselný Identifikátor a heslo<linebreak/> • Pred vykonaním platby je vždy vyžadované prihlásenie do mobilnej aplikácie mBank<linebreak/> • Návrat z mobilnej aplikácie mBank späť do {{appName}} je potrebné vykonať manuálne",
        HowToConnect:
          "Na pripojenie účtu musíte poznať svoj číselný Identifikátor a heslo. Ak ich nemáte, musíte si ich vytvoriť v internetovom bankovníctve mBank. Po potvrdení prihlásenia v mobilnej aplikácii mBank sa vráťte späť do prehliadača a vyberte bankový účet, ktorý chcete do {{appName}} pripojiť. Pred potvrdením platby sa musíte opätovne prihlásiť do mobilnej aplikácie mBank, preto vám platba s touto bankou prakticky vždy bude trvať o niečo dlhšie ako u konkurencie.",
        Review:
          'API pripojenie mBank vykazuje celý rad prekážok, ktoré znižujú naše hodnotenie na pouhú pol hviezdičky. Pripojenie bankového účtu do mBank znepríjemňuje nutnosť poznať číselný Identifikátor a heslo. Negatívne hodnotíme nútené prihlasovanie do aplikácie mBank pred vykonaním platby, čo proces platby neúmerne predlžuje. Chýba automatické presmerovanie späť do prostredia {{appName}} - ak nechcete čakať 15 sekúnd na presmerovanie, musíte klepnúť na tlačidlo "Rozumiem".',
        Email: "kontakt@mBank.cz",
      },
      [Bank.RB]: {
        Rating: "2",
        AdditionalInfo: "",
        Warnings:
          "• Pre pripojenie účtu je potrebné zadať klientske číslo<linebreak/> • Vrátiť sa z potvrdenia platby späť do {{appName}} je potrebné vykonať manuálne",
        HowToConnect:
          'Pre pripojenie účtu musíte zadať svoje klientske číslo, ktoré používate na prihlásenie do internetového bankovníctva. Pri potvrdzovaní platby musíte najprv na webe banky klepnúť na žlté tlačidlo "Podpísať", až potom sa otvorí aplikácia. Po potvrdení platby klepnite pre návrat späť do {{appName}} najprv na šípku späť a následne na tlačidlo "Presmerovať späť do aplikácie".',
        Review:
          'API pripojenie Raiffeisenbank hodnotíme v súčasnej konkurencii nadpriemerne. Oceňujeme rýchlosť platby a stabilitu doručenia push notifikácií. Proces platby spomaľuje potvrdzovanie platby nadvakrát - raz na webe Raiffeisenbank klepnutím na žlté tlačidlo "Podpísať" a druhýkrát v aplikácii banky. Chýba automatické presmerovanie späť do prostredia {{appName}} po vykonaní platby - musíte sa preklikať späť do Mo.one, inak obchodník neuvidí, že platba bola skutočne zaplatená.',
        Email: "reklamace@rb.cz",
      },
      [Bank.Citfin]: {
        Rating: "",
        AdditionalInfo: "",
        Warnings: "",
        HowToConnect: "",
        Review: "",
        Email: "",
      },
      [Bank.TRINITY]: {
        Rating: "",
        AdditionalInfo: "",
        Warnings: "",
        HowToConnect: "",
        Review: "",
        Email: "",
      },
      [Bank.PenezniDum]: {
        Rating: "",
        AdditionalInfo: "",
        Warnings: "",
        HowToConnect: "",
        Review: "",
        Email: "",
      },
      [Bank.Artesa]: {
        Rating: "",
        AdditionalInfo: "",
        Warnings: "",
        HowToConnect: "",
        Review: "",
        Email: "",
      },
      [Bank.CREDITAS]: {
        Rating: "",
        AdditionalInfo: "",
        Warnings: "",
        HowToConnect: "",
        Review: "",
        Email: "",
      },
      [Bank.NEY]: {
        Rating: "",
        AdditionalInfo: "",
        Warnings: "",
        HowToConnect: "",
        Review: "",
        Email: "",
      },
      [Bank.MaxBanka]: {
        Rating: "",
        AdditionalInfo: "",
        Warnings: "",
        HowToConnect: "",
        Review: "",
        Email: "",
      },
      [Bank.NRB]: {
        Rating: "",
        AdditionalInfo: "",
        Warnings: "",
        HowToConnect: "",
        Review: "",
        Email: "",
      },
      [Bank.JandT]: {
        Rating: "",
        AdditionalInfo: "",
        Warnings: "",
        HowToConnect: "",
        Review: "",
        Email: "",
      },
      [Bank.PPF]: {
        Rating: "",
        AdditionalInfo: "",
        Warnings: "",
        HowToConnect: "",
        Review: "",
        Email: "",
      },
      [Bank.Oberbank]: {
        Rating: "",
        AdditionalInfo: "",
        Warnings: "",
        HowToConnect: "",
        Review: "",
        Email: "",
      },
      [Bank.PartnersBank]: {
        Rating: "",
        AdditionalInfo: "",
        Warnings: "",
        HowToConnect: "",
        Review: "",
        Email: "",
      },
      [Bank.CNB]: {
        Rating: "",
        AdditionalInfo: "",
        Warnings: "",
        HowToConnect: "",
        Review: "",
        Email: "",
      },
      [Bank.Revolut]: {
        Rating: "",
        AdditionalInfo: "",
        Warnings: "",
        HowToConnect: "",
        Review: "",
        Email: "",
      },
      [Bank.CZKT]: {
        Rating: "",
        Warnings: "",
        AdditionalInfo: "",
        HowToConnect: "",
        Review: "",
        Email: "",
      },
    },
    NotRecommended: {
      Badge: "NEODPORÚČAME",
      InfoboxTitle: "NEODPORÚČAME",
      BetterButton: "CHCEM NIEČO LEPŠIE",
    },
    Title: "Hodnotenie pripojenia bánk",
    Description:
      "Obchodníkom a zákazníkom prinášame jednoduché a pohodlné okamžité platby v kamenných obchodoch aj na internete. Svoj systém a funkcionality neustále vylepšujeme.<linebreak/> Zážitok pri platbe s {{appName}} je však priamo ovplyvnený kvalitou napojenia na technológiu, ktorú nám poskytujú jednotlivé banky. Odporúčame si preto vopred naštudovať a vyskúšať obmedzenia, na ktoré môžete u vašej banky naraziť pri pripojení účtu alebo vykonaní platby. Spoločne s bankami pracujeme na odstránení jednotlivých bariér tak, aby do konca roka 2026 bol zážitok pri platbe naozaj skvelý.<linebreak/> Zaviedli sme hodnotiaci systém, vďaka ktorému sa môžete pozrieť, ako si vaša banka stojí. Naše hodnotenie sa volá “Miss API” a slúži ako pozitívna motivácia pre banky, aby zlepšovali svoje technológie a váš zážitok pri platbe s {{appName}}. Ak nebudete s kvalitou pripojenia svojej banky spokojní, odporúčame používať inú banku s lepším hodnotením. Účet v inej banke dnes založíte počas pár minút a online z vášho telefónu či počítača.",
    AccessibilityLabel: "",
    ContactUs: {
      PreText:
        "Ak narazíte na ďalšie obmedzenia, ktoré nie sú u vašej banky uvedené, dajte nám to prosím vedieť na",
      Email: "info@mo.one",
      PostText: "Vašej spätnej väzby si vážime!",
    },
    Detail: {
      CurrentRating: "Aktuálne hodnotenie: {{rating}}/5.00",
      Titles: {
        Warning: "Pozor na:",
        HowToConnect: "Ako na to:",
        Review: "Hodnotenie:",
        Email: "Ak chcete veci zmeniť, ozvite sa ombudsmanovi vašej banky na",
      },
    },
  },
  Transfer: {
    FromAccount: "Vyber odchádzajúci účet",
    ToAccount: "Vyber prichádzajúci účet",
    Amount: "Zadaj sumu",
    Note: "Pridať poznámku",
    SubmitButton: "Previesť",
    TransferButton: "Previesť peniaze",
    ConnectMoreAccounts: "Pripojte ďalší účet",
    NoBankAccountsError: "Nepodarilo sa načítať bankové účty.",
  },
  Merchant: {
    Employees: {
      Title: "Zamestnanci",
    },
    LicenseShares: {
      Title: "Zdieľanie provízie",
    },
    Payment: {
      LoadingError: "Údaje sa nepodarilo načítať.",
      Title: "Dnešná tržba",
      InitiatePaymentButton: "Vyvolať platbu",
      InitiateKeypadPaymentButton: "PLATBA {{amount}}",
    },
    Initiate: {
      PaypointHasNoAccountError:
        "Na zvolený paypoint nie je možné vykonávať platby, pretože nemá nastavený bankový účet.",
      NoBankAccountsError: "Chyba - Nepodarilo sa načítať bankové účty.",
      ActiveTransactionConflict: {
        Title: "Konflikt transakcií",
        Message: "Na tomto paypointe už existuje aktívna transakcia.",
        Description:
          "Môžete sa buď vrátiť späť a transakciu vystaviť na iný paypoint, alebo transakciu existujúcuna tomto paypointu prepísať.",
        OverwriteButton: "Prepísať existujúcu",
        Overwriting: "Prepísavanie...",
      },
      ConnectBankAccountLink: {
        PreText: "Pokladňu môžete začať využívať až po",
        LinkText: "Nastavení primárneho účtu.",
      },
      GenerateButton: "Generovať údaje",
      Form: {
        BusinessAccountSelectTitle: "Výber podnikateľského účtu",
        PersonalAccountSelectTitle: "Vyberte účet pre prijatie platby",
      },
    },
    InitiateDetail: {
      MerchantInstructions:
        'Zaplatiť môžete pomocou QR kódu, alebo vložením kódu transakcie vo formulári "Zaplatiť".',
      CustomerInstructions:
        "Ukaž platiteľovi unikátny QR kód platby, alebo s ním zdieľaj 3-miestne ID transakcie.",
      QRInstructions:
        "Platbu môžete vykonať načítaním QR kódu alebo zdieľaním kódu platby.",
      QRCodeInstructionsSuccess:
        "Pre zobrazenie detailu platby načtěte<newline/> QR kód na svojom telefóne.",
      QRCodeWarning:
        "NEPOUŽÍVAJTE čítačku vo Vašom bankovníctve! Otvorte {{appName}} skrze načítanie QR kódu cez fotoaparát alebo QR čítačku.",
      UsePaypointWarning:
        "Pre zvolenú platbu nie je nastavený PayPoint. Prosím nastavte si PayPoint pre zlepšenie procesu {{appName}} platby.",
      PaymentStatus: "Status platby",
      TransactionFee: "Poplatok z transakcie",
      ProgressHeader: {
        [TransactionStatus.Created]: "Čaká na zaplatenie",
        [TransactionStatus.Initiated]: "Zahájená",
        [TransactionStatus.Processing]: "Zpracovává se",
        [TransactionStatus.Success]: "Úspešne prijatá",
        [TransactionStatus.Cancelled]: "Zrušená",
        [TransactionStatus.Fail]: "Zlyhala",
        [TransactionStatus.InvestigationNeeded]: "Neznámy stav",
      },
      Loading: "Príprava platby...",
      ShareTitle: "Platba na {{appName}}",
      ShareText:
        "{{name}} vás volá! Suma {{amount}} je pripravená na cestu. Kliknite a pošlite ju na miesto určenia! Ďakujeme, že platíte s {{appName}}!",
      ShareReceiptTitle: "Potvrdenie o platbe - {{appName}}",
      ShareReceiptText:
        "Potvrdenie o platbe\n\nID transakcie: {{transactionId}}\nSuma: {{amount}}\nPoznámka: {{note}}\nVariabilný symbol: {{reference}}\nÚčet/IBAN: {{iban}}\n\nVďaka, že platíš s {{appName}}!",
      ActionButtons: {
        Share: "Zdieľať",
        Info: "Informácie",
        Qr: "QR {{appName}}",
      },
      NFCInstruction: "Načítajte NFC a dokončite platbu na svojom telefóne.",
      Error: "Nastala chyba pri načítaní platebného príkazu",
      CreateAnotherPayment: "Vytvoriť ďalšiu platbu",
      BackToOverview: "Späť na prehľad",
      ThankYouMessage: "Ďakujeme, že platíte s {{ appName }}!",
    },
    MerchantStatus: {
      InDraft: "registrácia otvorená",
      InvitedWaitingForConfirmation: "Pozvánka odoslaná",
      Onboarding: "Onboarding",
      WaitingForPaymentTerminal: "Čaká na platobný terminál",
      Active: "Aktívny",
      BlockedFinancialServices: "Blokovaný",
    },
    NoProductAssigned: "Nemáte priradený žiadny produkt.",
    NoPaypointProduct:
      "Nemáte priradený žiadny produkt umožňujúci vytvorenie paypointu.",
    DataFailedToLoad: "Údaje sa nepodarilo načítať.",
    PaymentDetails: "Platobné údaje:",
    AccountNumber: "Číslo účtu:",
    VariableSymbol: "Variabilný symbol:",
    IBAN: "IBAN:",
    PaymentReference: "Referencia platby:",
    Amount: "Suma:",
    Note: "Poznámka:",
    NoAccountSet: "Nie je nastavený žiadny účet",
    ConnectedBankAccounts: "Pripojené bankové účty",
  },
  Customer: {
    Pay: {
      Title: "Zaplatiť",
      DescriptionText:
        "Zaplatiť môžete aj pomocou oskenovania QR kódu protistrany.",
      PayButton: "Zaplatiť",
      PayButtonWithAmount: "Zaplatiť {{amount}}",
      ChooseBankAccount: "Vyberte si účet, ktorým chcete zaplatiť",
      ChooseBank: "Vyberte si banku, ktorou chcete zaplatiť",
      AddNextBankAccount: "+ Pridať ďalší účet",
      SelectBankAccount: "Výber bankového účtu",
      TransactionIdentifier: "Identifikátor transakcie",
      Amount: "Suma",
      BillAmount: "Suma účtu",
      Tip: "Prepitné",
      AddTip: "Pridať prepitné",
      fivePercent: "5%",
      tenPercent: "10%",
      twentyPercent: "20%",
      custom: "Vlastné",
      TipContinueWithout: "Pokračovať bez prepitného",
      TipCustomAmountLabel: "Výška prepitného",
      BankAccount: "Bankový účet",
      QuickPayment: {
        Processing: "Prebieha rýchla platba...",
        Error: "Rýchla platba zlyhala",
        QuickPaymentFailed:
          "Transakciu sa nepodarilo dokončiť rýchlou platbou.",
        UseAnotherAccount: "Použiť iný účet",
      },
      AnonymousCollector: {
        UnsupportedMode:
          "Tento platobný odkaz tu nemožno použiť. Skontrolujte prosím odkaz a skúste to znova.",
      },
      MooneLiteAccountExplanation:
        "= obmedzená funkcionalita účtu.<newline/>Pre využívanie {{appName}} naplno je potrebné dokončiť registráciu.",
      ManualEntry: {
        Title: "Zaplatiť",
        NfcTitle: "Priložte telefón k platobnému bodu",
        NfcSubtitle: "Bezkontaktná platba cez NFC.",
        ManualTitle: "Zadajte ID transakcie",
        ManualTitleWithNfc: "Alebo zadajte ID transakcie ručne",
        ManualSubtitle: "Nájdete ho u protistrany.",
        InputPlaceholder: "Napr. A5DH8Q",
        InputLabel: "Identifikátor transakcie",
        SubmitButton: "Pokračovať",
        InvalidId: "Zadajte prosím platné ID transakcie",
        TransactionIdNotProvided: "Nebolo zadané ID transakcie.",
      },
    },
  },
  BankAccounts: {
    List: {
      Description:
        'Tieto bankové účty sú pripojené k Vašemu účtu. Ak chcete pridať ďalší bankový účet, kliknite na tlačidlo "Pripojiť bankový účet."',
      NoAccounts: "Nemáte žiadne pripojené bankové účty.",
      SaveOrder: "Uložiť poradie",
      EditOrder: "Upraviť poradie",
      AddAccount: "Pripojiť bankový účet",
    },
    VerificationStatus: {
      Inactive: "Neaktívny",
      AwaitingVerification: "Čaká na overenie",
      Rejected: "Zamietnuté",
      Active: "Aktívny",
      Restricted: "Lite účet",
      PreApproved: "Predschválené",
    },
    VerificationStatusDescription: {
      Active: "Účet je plne overený a možno ho použiť pre všetky transakcie.",
      AwaitingVerification:
        "Účet je v procese overovania. Nie je možné ho nastaviť ako primárny, kým nie je overenie dokončené.",
      Restricted:
        "Účet je v režime Lite s obmedzenou funkcionalitou. Nie je možné ho nastaviť ako primárny.",
      Inactive: "Účet je neaktívny a nie je možné ho použiť pre transakcie.",
      Rejected: "Overenie účtu bolo zamietnuté. Účet nie je možné použiť.",
      PreApproved:
        "Účet je predschválený. Môžete prijímať platby z účtu na účet do obmedzenej výšky, kým nebude účet úplne overený.",
    },
    BankVerificationSource: {
      AIS: "AIS",
      QR: "Mikroplatba",
    },
  },
  Form: {
    PersonalData: {
      Sex: {
        Female: "Žena",
        Male: "Muž",
        NotSet: "Neuvedené",
      },
    },
    PartyType: {
      NaturalPerson: "Fyzická osoba",
      LegalEntity: "Právnická osoba",
      SelfEmployed: "Podnikajúca fyzická osoba (SZČO)",
    },
    BusinessActivity: {
      RetailAndGoodsSales: "Maloobchod a predaj tovaru",
      FoodServicesAndGastronomy: "Stravovacie služby a gastronómia",
      AccommodationAndTourism: "Ubytovanie a cestovný ruch",
      BeautyHealthAndWellness: "Krása, zdravie a wellness",
      ConstructionCraftsAndMaintenance: "Stavebníctvo, remeslá a údržba",
      TransportAutoAndLogistics: "Doprava, auto-moto a logistika",
      FinancialLegalAndConsulting: "Finančné, právne a poradenské služby",
      EducationSportsAndLeisure: "Vzdelávanie, šport a voľný čas",
      TechnologyITAndOnline: "Technológie, IT a online služby",
      IndustryManufacturingAndWholesale: "Priemysel, výroba a veľkoobchod",
      OtherAndPublicServices: "Ostatné a verejné služby",
      RetailAndCommerce: "Maloobchod a obchod",
      FoodAndBeverageServices: "Stravovacie služby",
      AccommodationAndHospitality: "Ubytovanie a pohostinstvo",
      BeautyAndPersonalCare: "Krása a osobná starostlivosť",
      HealthcareAndPersonalCare: "Zdravotníctvo a osobná starostlivosť",
      ConstructionAndMaintenance: "Stavebníctvo a údržba",
      TransportationAndLogistics: "Doprava a logistika",
      FinancialServicesAndInsurance: "Finančné služby a poisťovníctvo",
      RealEstateAndPropertyServices: "Nehnuteľnosti a správa majetku",
      LegalAndConsultingServices: "Právne a poradenské služby",
      EducationAndTraining: "Vzdelávanie a školenie",
      ArtsCultureAndEntertainment: "Umenie, kultúra a zábava",
      SportsAndRecreation: "Šport a rekreácia",
      TechnologyAndITServices: "Technológie a IT služby",
      ECommerceAndOnlineServices: "E-commerce a online služby",
      IndustrialProductionAndProcessing: "Priemyselná výroba a spracovanie",
      Other: "Iné",
      PersonalServices: "Osobné služby",
    },
    SourceOfIncome: {
      GoodsSalesRevenue: "Tržby z predaja tovaru",
      ServiceAndCraftIncome: "Príjmy z poskytovania služieb a remesiel",
      HospitalityAndAccommodation: "Prevádzka pohostinstva a ubytovania",
      CommissionsAndLicensing: "Provízie, sprostredkovanie a licenčné poplatky",
      PropertyAndInvestmentIncome: "Výnosy z majetku, prenájmu a investícií",
      PublicBudgetsAndGrants: "Verejné rozpočty, dotácie a dary",
      OtherBusinessIncome: "Iné podnikateľské príjmy",
      Employment: "Zamestnanie",
      SelfEmployment: "Podnikanie",
      Other: "Iné",
    },
    SourceOfIncomeHint: {
      GoodsSalesRevenue:
        "Maloobchod, veľkoobchod, stánky, digitálne produkty, e-commerce.",
      ServiceAndCraftIncome:
        "Všetky služby od kaderníčky cez inštalatéra až po IT, konzultácie a marketing.",
      HospitalityAndAccommodation:
        "Reštaurácie, bary, kaviarne, hotely, penzióny a krátkodobé prenájmy.",
      CommissionsAndLicensing:
        "Realitných maklérov, poradcov, affiliate partnerov, autorské práva a patenty.",
      PropertyAndInvestmentIncome:
        "Dlhodobý prenájom nehnuteľností, dividendy, podiely na zisku a holdingovú činnosť.",
      PublicBudgetsAndGrants:
        "Príjmy neziskoviek, štátne príspevky, cirkvi a nadačné zbierky.",
      OtherBusinessIncome:
        "Špecifické prípady, ktoré nespadajú do vyššie uvedených kategórií.",
    },
    ExpectedMonthlyRevenue: {
      LessThan100K: "Menej ako 100 000 Kč",
      From100KTo500K: "100 000 až 500 000 Kč",
      From500KTo1M: "500 000 až 1 000 000 Kč",
      Over1M: "Viac ako 1 000 000 Kč",
    },
    AverageTransactionValue: {
      LessThan1K: "Menej ako 1 000 Kč",
      From1KTo10K: "1 000 až 10 000 Kč",
      From10KTo50K: "10 000 až 50 000 Kč",
      Over50K: "Viac ako 50 000 Kč",
    },
    RelationType: {
      BeneficialOwner: "Skutočný vlastník",
      ProxyHolder: "Prokurista",
      HuntersHunter: "Lovcov lovec",
      BranchManager: "Vedúci odštepného závodu",
      Mayor: "Starosta",
      Governor: "Hejtman",
      CityMayor: "Primátor",
      ContactPerson: "Kontaktná osoba",
      HuntersMerchant: "Lovcov obchodník",
      MerchantsEmployee: "Zamestnanec obchodníka",
      HuntersCustomer: "Lovcov používateľ",
      CustomersCustomer: "Používateľov používateľ",
      MerchantsCustomer: "Obchodníkov používateľ",
      StatutoryBody: "Štatutárny orgán",
      InsolvencyAdministrator: "Insolvenčný správca",
      Liquidator: "Likvidátor",
      ForcedAdministrator: "Nútený správca",
      BranchOfficeManager: "Vedúci organizačnej zložky",
      ManagingDirector: "Konateľ",
      BoardChairman: "Predseda predstavenstva",
      BoardMember: "Člen predstavenstva",
      SupervisoryBoardChairman: "Predseda dozornej rady",
      SupervisoryBoardMember: "Člen dozornej rady",
      Partner: "Spoločník",
      GeneralPartner: "Komplementár",
      Chairman: "Predseda",
      CommitteeMember: "Člen výboru",
      TrustManager: "Správca zvereneckého fondu",
    },
    RoleCategory: {
      StatutoryBody: "Štatutárny orgán",
      StatutoryBodyHint:
        "Členom štatutárneho orgánu je najmä konateľ, člen/predseda predstavenstva, člen/predseda správnej rady",
      ProxyHolder: "Prokurista",
      Other: "Iné",
      SpecificRole: "Upresnenie pozície",
    },
    BankVerification: {
      NotVerified: "Neoverené",
      Verified: "Overené",
      InProgress: "Prebieha overovanie",
    },
    BankVerificationSource: {
      AIS: "AIS",
      QR: "Mikroplatba",
    },

    IdentityVerification: {
      NotVerified: "Neoverené",
      Verified: "Overené",
      Processing: "Prebieha overovanie",
      ToVerify: "K overeniu",
      Expired: "Expirované",
    },
    AdditionalInfo: {
      NotVerified: "Neoverené",
      Verified: "Overené",
      NeedsInvestigation: "Vyžaduje kontrolu",
    },
    UserStatus: {
      Unknown: "Neznámy",
      InvitedWaitingForConfirmation: "Pozvánka odoslaná",
      Active: "Aktívny",
      WaitingForEmailConfirmation: "Čaká na potvrdenie e-mailu",
      Deactivated: "Deaktivovaný",
      BlockedFinances: "Blokovaný",
      Anonymous: "Anonymný",
      Onboarding: "Onboarding",
      EmailConfirmed: "Potvrdený e-mail",
      RoleSelection: "SSO výber roly",
    },
    IdentityUserStatus: {
      Active: "Aktívna",
      Pending: "Čaká na prijatie",
      Suspended: "Pozastavená",
      Deactivated: "Zrušená",
      Onboarding: "Onboarding",
    },
    AddressType: {
      Permanent: "Trvalé bydlisko",
      Mail: "Korešpondenčná",
      Headquarters: "Sídlo",
    },
    Version: {
      MooneLite: "{{appName}} Lite",
      FullMoone: "Full {{appName}}",
    },
  },
  FormSelectors: {
    BusinessForm: {
      Title: "Forma podnikania",
    },
  },
  User: {
    AccessRole: {
      Admin: "Administrátor",
      Customer: "Používateľ",
      Employee: "Zamestnanec",
      Merchant: "Obchodník",
      Hunter: "Hunter",
      Aml: "AML",
      HunterPlus: "Hunter+",
      CustomerOnboarding: "Customer Onboarding",
      AdminLite: "Admin (iba na čítanie)",
      Disponent: "Disponent",
      Child: "Dieťa",
    },
    RoleFilter: {
      CustomerOnly: "Používateľ (bez ďalších rol)",
    },
  },
  Hunter: {
    Dashboard: {
      UnderConstruction:
        "Tu pre Vás pripravujeme leaderboards hunterov, akadémiu a ďalšie...",
      MissingLicenseHolderBankAccount:
        "Pre výplatu odmien pripojte bankový účet vedený na vlastníka franchisovej licencie.",
      HunterPortalBanner: {
        Title: "Hunter Portál",
        Description:
          "Terminály, akvizície, akcie, akadémia a ďalšie na jednom mieste.",
      },
      Prerequisites: {
        Title: "Hunter prvé kroky",
        Description:
          "Staň sa predajným odborníkom na Mo.one v niekoľkých krokoch a osvoj si predajné praktiky.",
        Completed: "Dokončené",
        GreatWork: "Skvelá práca!",
        InfoMessage:
          "Pre získanie plného prístupu k Hunter funkciám je potrebné sa najprv oboznámiť so základmi Mo.one, splňte zoznam úloh a odomknite si Full Hunter!",
        CompletedMessage:
          "Všetko hotové! Teraz môžete začať posielať pozvánky obchodníkom.",
        Items: {
          RegisterAsMerchant:
            "Zaregistruj sa ako Obchodník a prejdi si aplikáciu",
          InviteUserViaAffiliate: "Pozvi nového používateľa cez Vďaka Tebe!",
          BanksAndPayments: "Pripoj si aspoň 3 banky a vykonaj 30 platieb",
          OfflineTraining: "Navštív",
          OfflineTrainingLink: "offline školenie Mo.one",
          OfflineTrainingUrl: "https://events.legi.one",
          BringMerchantsWithHunter:
            "Priveď 3 Obchodníkov v spolupráci so skúseným Hunterom",
        },
      },
    },
    LicensePaymentPending: {
      Title: "Vaša licencia zatiaľ nie je aktívna",
      ProcessingInfo:
        "Momentálne nemáte žiadnu aktívnu licenciu. Ak ste už platbu odoslali, vyčkajte prosím na jej spracovanie a aktiváciu licencie — bankový prevod môže trvať 1–2 pracovné dni.",
      NotPaidYetLink: "Ešte ste platbu neodoslali?",
      NotPaidYetSubtitle: "Zobraziť platobné údaje",
      PaymentDetailsTitle: "Platobné údaje",
      NoLicenseTitle: "Nemáte žiadnu licenciu",
      NoLicenseInfo:
        "Momentálne nemáte žiadnu aktívnu licenciu. Pre vstup do {{appName}} Hunter sekcie si najprv objednajte licenciu.",
      OrderLicense: "Objednať licenciu",
      OrderAnotherLicense: "Objednať ďalšiu licenciu",
      SelectedLicenseLabel: "Objednaná licencia",
      BackToMoone: "Späť do {{appName}}",
    },
    Merchants: {
      Title: "Obchodníci",
      NewRegistration: {
        Title: "Nový obchodník",
        StartRegistrationButton: "Zahájiť registráciu",
        StartRegistrationError: "Chyba pri zahájení registrácie",
        StartRegistrationSuccess: "Registrácia zahájená",
        CreateMerchantError: "Chyba pri vytvorení obchodníka",
        Form: {
          Legend: {
            License: "Výber licencie",
            CommissionSharing: "Sdielanie provízie",
          },
          Fields: {
            License: "Licencia",
            Country: "Krajina",
            Region: "Krajina",
            CompanyNumber: "IČO",
            ConfirmationLabel:
              "Potvrdzujem, že som osobne hovoril(a) s vlastníkom firmy alebo zodpovednou osobou za platobné služby v danej spoločnosti.",
            RemoveHunter: "Odobrať huntera",
            CommissionSettings: "Nastavenie provízie",
            ShareCommissionWithHunters: "Zdieľať províziu s ďalšími Huntrami",
            ShareCommissionWithHuntersButton: " + Zdieľať s ďalším Hunterom",
          },
          NoLicenseForRegion:
            "Pre tento trh nemáte aktívnu licenciu. Vyberte inú krajinu, alebo si najprv zaobstarajte licenciu.",
          StatusIndicator: {
            Loading: "Kontrola dostupnosti",
            EnterCompanyNumber: "Zadajte IČO pre kontrolu dostupnosti",
            CompanyAvailable:
              "Výborne! {{company}} ešte {{appName}} nepoužíva.",
            CompanyNotAvailable:
              "Je nám ľúto, {{company}} už {{appName}} používa, alebo ho evidujeme v procese registrácie.",
            CompanyNotFound: "Zadané IČO sme v registri firiem nenašli",
          },
        },
      },
      AddNew: "Pridať obchodníka",
      OpenRegistrations: {
        Table: {
          Title: "Potenciálni obchodníci",
          Columns: {
            CompanyName: "Názov spoločnosti",
            CompanyNumber: "IČO",
            Phone: "Telefón",
            Email: "E-mail",
          },
        },
        Title: "Otvorené registrácie",
        LoadingError: "Chyba - Nepodarilo sa načítať stav registrácie",
        RegisterNewMerchant: "Registrácia nového obchodníka",
      },
      ListPage: {
        LoadingError: "Chyba - Nepodarilo sa načítať zoznam obchodníkov",
        LicenseError: "Chyba - Nepodarilo sa načítať údaje o Vašej licencii",
        LicenseNotActive:
          "Vaša licencia ešte nie je aktívna. Akonáhle dôjde k jej aktivácii, uvidíte tu zoznam obchodníkov.",
        ShowLicenses: "Zobraziť licencie",
        MerchantsTitle: "Obchodníci",
        SharedMerchantsTitle: "Obchodníci so zdieľanými províziami",
        Table: {
          Columns: {
            MerchantStatus: "Stav obchodníka",
            ContactPerson: "Kontaktná osoba",
            Party: {
              CompanyName: "Názov firmy",
              Phone: "Telefón",
              Email: "E-mail",
              SettlementStatus: "Vyúčtovanie",
            },
            LicenseNumber: "Licencia",
            SharePercentage: "Podiel %",
            TransactionsCount: "Počet transakcií",
            DaysRegistered: "Dni v obchodníkovi",
          },
        },
        SharedMerchantsError:
          "Chyba - Nepodarilo sa načítať zoznam obchodníkov so zdieľanými províziami",
      },
      CompleteRegistration: {
        MerchantCompany: {
          LoadingError: "Chyba - Nepodarilo sa načítať údaje obchodníka",
        },
        ContactPerson: {
          Title: "Kontaktná osoba",
          OptionalTitle: "Voliteľné kontaktné osoby",
          OptionalNoItems: "Nie sú pridané žiadne kontaktné osoby",
        },
        Facilities: {
          RequiredInfo: "Vyplňte prosím údaje o prevádzkach",
          ContinueWithoutFacility: "Pokračovať bez prevádzky",
        },
        SendAccess: {
          SendAccessError: "Prístup sa nepodarilo odoslať.",
          SendAccessSuccess:
            "Inštrukcie pre registráciu obchodníka boli odoslané",
          Title: "Zhrnutie",
          MandatoryStepsTitle:
            "Pred odoslaním prístupu je nutné splniť všetky nasledujúce body:",
          Login: "Login obchodníka",
          LoginDescription:
            "Tento e-mail bude obchodník používať na prihlásenie do {{appName}}.",
          SendAccessButton: "Poslať prístup",
          BackOfficeTarget:
            "Táto e-mailová adresa patrí internému účtu {{appName}} (Admin, AML, onboarding) a nie je možné ju pozvať. Použite inú e-mailovú adresu.",
          MerchantAlreadyExists:
            "Obchodník s týmto e-mailom už v {{appName}} existuje.",
          MerchantAlreadyHasAccessToThisCompany:
            "Tento používateľ už má prístup k tejto firme ako obchodník.",
          ExistingIdentityHint:
            "Tento e-mail je už v {{appName}}. Pozvánka sa zobrazí v aplikácii používateľa — e-mail neposielame.",
          NewIdentityHint:
            "Pošleme aktivačný e-mail s odkazom na nastavenie hesla.",
          CompanyNumberAlreadyRegistered:
            "Obchodník s IČO {{companyNumber}} je už v {{appName}} zaregistrovaný.",
          TestMerchantBannerTitle: "Skúšobná registrácia",
          TestMerchantBanner:
            "Pred dokončením všetkých prvých krokov máte k dispozícii jednu skúšobnú registráciu obchodníka, aby ste si mohli vyskúšať aplikáciu aj z jeho pohľadu.",
          Todos: {
            BasicInfo: "Vyplnenie základných údajov obchodníka",
            BeneficialOwners: "Pridanie skutočných vlastníkov spoločnosti",
            ContactPerson: "Pridanie kontaktnej osoby pre zúčtovanie",
            Facilities: "Pridanie prevádzky",
            Pricing: "Nastavenie cenníkov u všetkých vybraných produktov",
            HunterPrerequisites: "Splnenie všetkých Hunter prvých krokov",
          },
        },
        GeneralTitle: "Registrácia obchodníka",
        Title: "Registrácia {{company}} ",
        MerchantError: "Chyba - Obchodník nie je vybraný alebo neexistuje",
        LoadingError: "Chyba - Nepodarilo sa načítať stav registrácie",
        Steps: {
          party: "Obchodník",
          notes: "Poznámky",
          facilities: "Prevádzky",
          company: "Spoločnosť",
          products: "Produkty",
          fees: "Poplatky",
          completion: "Dokončenie",
        },
        NextStep: "Pokračovať",
        PreviousStep: "Späť",
        SaveMerchantPartyError: "Chyba pri ukladaní údajov obchodníka",
        SaveMerchantPartySuccess: "Údaje obchodníka boli uložené",
        Notes: {
          SaveSuccess: "Poznámky boli uložené",
          Title: "Poznámky",
          Label: "Vaše poznámky k obchodníkovi",
          SaveError: "Chyba pri ukladaní poznámek",
          NoNotes: "Žiadne poznámky...",
        },
      },
      Detail: {
        ActivateButton: "Aktivovať obchodníka",
        ActivateSuccess: "Obchodník bol aktivovaný.",
        ActivateError: "Aktivácia obchodníka sa nepodarila.",
        ResendAccessButton: "Znovu odoslať pozvánku",
        ResendAccessSuccess: "Prístupový e-mail bol úspešne odoslaný",
        ResendAccessSuccessWithUser:
          "Pozvánka bola znovu odoslaná na <bold>{{userLogin}}</bold>",
        ResendAccessError: "Chyba pri odosielaní prístupového e-mailu",
        CancelAccessButton: "Zrušiť pozvánku",
        CancelAccessConfirmTitle: "Zrušiť pozvánku?",
        CancelAccessConfirmBody:
          "Týmto sa zruší čakajúca pozvánka pre {{userLogin}}. Novú pozvánku môžete odoslať neskôr.",
        CancelAccessSuccess: "Pozvánka bola zrušená",
        CancelAccessError: "Chyba pri rušení pozvánky",
        CancelAccessForbidden:
          "Pozvánku môže zrušiť len hunter, ktorý ju odoslal, alebo administrátor.",
        Tabs: {
          Merchant: "Obchodník",
          Products: "Produkty",
          TerminalContracts: "Podklady",
          Paypoints: "Paypointy",
          Settlements: "Vyúčtovanie",
        },
      },
    },
    AllMerchants: {
      LoadingError: "Chyba - Nepodarilo sa načítať zoznam obchodníkov",
      OwnedByMe: "Môj obchodník",
      TableHeaders: {
        Status: "Stav obchodníka",
        CompanyNumber: "IČO",
        CompanyName: "Názov firmy",
        LicenseOwner: "Vlastník licencie",
        LicenseType: "Typ licencie",
        DateCreated: "Dátum vytvorenia",
        TransactionsCount: "Počet transakcií",
      },
    },
    UnassignedMerchants: {
      Description:
        "Obchodníci, ktorí sa zaregistrovali sami a nemajú priradeného huntera. Kliknite na riadok na priradenie huntera a nastavenie provízie.",
      LoadingError:
        "Chyba - Nepodarilo sa načítať zoznam obchodníkov bez huntera",
      EmptyState:
        "Žiadni obchodníci bez huntera. Všetci obchodníci majú priradeného huntera.",
      OpenDetailLabel: "Otvoriť detail obchodníka",
      TableHeaders: {
        Status: "Stav obchodníka",
        CompanyNumber: "IČO",
        CompanyName: "Názov firmy",
        DateCreated: "Dátum vytvorenia",
        Detail: "Detail",
      },
      AssignDialog: {
        Title: "Priradiť huntera pre",
        Subtitle: "{{companyName}} (IČO: {{companyNumber}})",
        PrimaryLicenseLabel: "Hlavná licencia",
        MainCommission: "Hlavná provízia",
        ShareLegend: "Zdieľať províziu s ďalšími licenciami",
        ShareCommissionWithHuntersButton: "Zdieľať províziu s huntermi",
        AssignButton: "Záväzne priradiť",
        AssignWarning:
          "Po priradení už nie je možné upraviť hunterov ani provízie",
        CancelButton: "Zrušiť",
        AssignSuccess: "Hunter bol úspešne priradený.",
        AlreadyHasHunterError: "Tento obchodník už má priradeného huntera.",
        GenericError: "Priradenie huntera sa nepodarilo.",
        Validation: {
          PrimaryRequired: "Hlavná licencia je povinná.",
          ShareOutOfRange:
            "Zdieľaná provízia musí byť väčšia ako 0 % a menšia ako 100 %.",
          PrimaryUnderMin: "Hlavnému hunterovi musí zostať aspoň 1 % provízie.",
        },
      },
    },
    HuntersOverview: {
      LoadingError: "Chyba - Nepodarilo sa načítať zoznam hunterov",
      Detail: {
        UserInfo: "Informácie o používateľovi",
        PartyInfo: "Informácie o subjekte",
        ContactInfo: "Kontaktné údaje",
        Login: "Prihlasovacie meno",
        Status: "Stav",
        FirstName: "Meno",
        LastName: "Priezvisko",
        BirthDate: "Dátum narodenia",
        CompanyName: "Názov spoločnosti",
        CompanyNumber: "IČO",
        TaxNumber: "DIČ",
        Email: "E-mail",
        Phone: "Telefón",
        Licenses: "Licencie",
        NoLicensesFound: "Žiadne licencie neboli nájdené",
        AffiliatedTo: "Affiliate",
        EditUser: "Upraviť",
        DateCreated: "Dátum vytvorenia",
        PartyType: "Typ osoby",
      },
      TableHeaders: {
        Login: "Prihlasovacie meno",
        FirstName: "Meno",
        LastName: "Priezvisko",
        CompanyName: "Názov spoločnosti",
        DateCreated: "Dátum vytvorenia",
        Status: "Stav",
        AffiliatedTo: "Affiliate",
        Prerequisites: "Predpoklady",
      },
    },
  },
  ApiStatuses: {
    UnknownError: "Nastala neočakávaná chyba pri spracovaní požiadavky",
    UploadIdentificationCommandResultStatus: {
      [UploadIdentificationCommandResultStatus.Success]: "Úspešne nahrané",
      [UploadIdentificationCommandResultStatus.MissingFiles]:
        "Prosím, nahrajte všetky súbory",
    },
    UploadIdentificationCommandResultStatus2: {
      [UploadIdentificationCommandResultStatus2.Success]: "Úspešne nahrané",
      [UploadIdentificationCommandResultStatus2.MissingFiles]:
        "Prosím, nahrajte všetky súbory",
      [UploadIdentificationCommandResultStatus2.VerificationAttemptsExhausted]:
        "Automatickú kontrolu dokladu už nie je možné opakovať, obráťte sa prosím na podporu.",
    },
  },
  System: {
    Addresses: "Adresy",
    BlockchainFee: "Poplatok za blockchain",
    MempoolFeeLevel: "Úroveň poplatku v mempoole",
    Exchange: "Burza",
    Trades: "Obchody",
    Moone: "{{appName}}",
    HotWallet: "+ Na Hot Wallet",
    ColdWallet: "+ Na Cold Wallet",
    ExchangeWithdrawal: " + K výberu z burzy ",
    UserAccounts: "- Na účtoch používateľov",
    ControlSum: "Kontrolný súčet",
    ExchangeWithdrawalFee: "Poplatok za výber z burzy",
    TradingVolume: "Obchodovaný objem",
    PerMonth: "Za mesiac",
    PerWeek: "Za týždeň",
    Per24h: "Za 24h",
    PurchasedBTC: "Nakúpené BTC",
    WithdrawnOrPending: "Vybrané alebo na výber",
    BTCLedgerSum: "Súčet účtovnej knihy BTC",
    CZKLedgerSum: "Súčet účtovnej knihy CZK",
  },
  Error: {
    Page403: "Error403",
    Page404: "Error404",
    Unexpected: "Došlo k neočakávanej chybe",
    NoAccess: "K tejto stránke nemáte prístup.",
    OpenRegistrationsFailed: "Otvorené registrácie sa nepodarilo načítať.",
    MerchantNotSelected: "Chyba - Obchodník nie je vybraný alebo neexistuje",
    LicenseInfoFailed: "Nepodarilo sa načítať informácie o Vašej licencii.",
    InvalidPaypointId: "Neplatné alebo chýbajúce paypoint ID",
    SomethingWentWrong: "Niečo sa pokazilo, skúste to prosím znovu neskôr.",
    InvalidUserRole: "Chyba, neplatná používateľská rola alebo obchodník",
    GoogleLoginFailed: "Chyba pri prihlásení cez Google",
    Error: "Chyba",
    ProgrammerHint: "Ste programátor? Pozrite v čom bola chyba.",
    AccountsFailed: "Chyba - Nepodarilo sa načítať Vaše účty",
    UserDataFailed: "Chyba, nepodarilo sa načítať údaje o používateľovi",
    VerificationDataFailed: "Chyba, nepodarilo sa načítať verifikačné údaje",
    DocumentsFailed: "Chyba, nepodarilo sa načítať dokumenty",
    PersonDataFailed: "Údaje osoby sa nepodarilo načítať.",
    IncomeDataFailed: "Údaje sa nepodarilo načítať.",
    FormPreparationFailed: "Pri príprave formulára sa vyskytla chyba",
    RelatedPartyDataFailed: "Chyba pri načítaní údajov súvisiacej osoby.",
    MerchantFacilitiesFailed: "Údaje o prevádzkach sa nepodarilo načítať.",
    UserFailed: "Chyba, používateľa sa nepodarilo načítať",
    ActingPersonFailed: "Chyba, konajúcu osobu sa nepodarilo načítať",
    DocumentsFailedToLoad: "Chyba, doklady sa nepodarilo načítať",
    AffiliateCodeFailed: "Váš affiliate kód sa nepodarilo získať.",
    NoInvitationsSent: "Zatiaľ ste neodoslali žiadne pozvánky.",
    QRPaymentFailed:
      "Ospravedlňujeme sa, ale niečo sa pokazilo, skúste to prosím znovu neskôr.",
  },
  Dashboard: {
    EmptyForRole: "Vaša rola nemá priradenú stránku s prehľadom.",
    NoAccess: "K tejto stránke nemáte prístup.",
    NoAccessRetry:
      "Skúste sa znovu <signInLink>prihlásiť</signInLink>. Ak Vaše problémy pretrvávajú, kontaktujte prosím našu podporu.",
    AlreadyHaveAccount: "Už máte {{appName}} účet?",
    IncomeTypeQuestion: "Aký je Váš typ príjmov?",
    Back: "SPÄŤ",
    Loading: "Načítavam...",
  },
  Auth: {
    Redirecting: "Presmerovanie",
    Error: "Chyba",
    StateSync: {
      LoggedInFromAnotherTab: "Boli ste prihlásený z inej karty.",
      LoggedOutFromAnotherTab: "Boli ste odhlásený z inej karty.",
    },
    AuthPageLayout: {
      DividerText: "alebo",
      SignInLinkText: "Prihláste sa",
      SignUpLinkText: "Zaregistrujte sa",
      SignInPrompt: "Už máte účet?",
      SignUpPrompt: "Ešte nemáte svoj účet?",
    },
    SSO: {
      CompleteSSORegistration: {
        Welcome: "Vitajte v {{appName}}!",
        Title: "Dokončenie registrácie",
        Description:
          "Keďže ide o Vaše prvé prihlásenie, potrebujeme zistiť, či sa k nám registrujete ako Používateľ, Obchodník alebo Hunter.",
        SignUpAs: "Registrovať ako",
        RoleDescription: {
          Merchant:
            "Ako obchodník môžete prijímať platby od svojich zákazníkov s nižšími poplatkami a využívať bezkontaktné paypointy.",
          Customer:
            "Ako používateľ môžete posielať priame platby, platiť za svoje nákupy a zbierať Stardust body.",
          Hunter:
            "Ako hunter môžete získať Legione licenciu, spravovať svojich obchodníkov a získavať provízie z ich transakcií",
        },
        RoleLabel: {
          Merchant: "Obchodník",
          Customer: "Používateľ",
          Hunter: "Hunter",
        },
      },
      Google: {
        ButtonLabel: "Prihlásiť sa cez Google",
      },
      Apple: {
        ButtonLabel: "Pokračovať s Apple",
        SignInFailed: "Prihlásenie cez Apple zlyhalo. Skúste to prosím znova.",
        NotSupportedInApp:
          "Prihlásenie cez Apple nie je v aplikácii podporované. Použite prosím webový prehliadač.",
      },
      BankID: {
        ButtonLabel: "Pokračovať s BankID",
      },
    },
    Migration: {
      Title: "Prepojenie účtu",
      Welcome: "Prepojte svoj účet s Identitou",
      Description:
        "Váš účet je potrebné prepojiť s hlavnou Identitou, aby zodpovedal novému modelu účtov. Stačí jeden z nasledujúcich krokov.",
      RoleHint: "Váš aktuálny účet má rolu: {{role}}",
      LinkToCustomerOption: "Už mám účet Customer — prepojiť",
      CreateIdentityOption: "Vytvoriť novú Identitu z tohto účtu",
      CreateIdentityDeferred:
        "Pre tento typ účtu nie je vytvorenie novej Identity podporované — prepojte účet s existujúcou Identitou.",
      LinkToCustomerTitle: "Prepojiť s existujúcim Customer účtom",
      LinkToCustomerDescription:
        "Zadajte prihlasovacie údaje svojho existujúceho Customer účtu. Vaša aktuálna rola bude pridaná pod túto Identitu.",
      LoginLabel: "E-mail Customer účtu",
      PasswordLabel: "Heslo Customer účtu",
      LinkButton: "Prepojiť účet",
      BackButton: "Späť",
      LinkError: "Prepojenie zlyhalo. Skontrolujte prihlasovacie údaje.",
      LinkSsoDivider: "alebo",
      LinkSsoDescription:
        "Prihláste sa účtom Google alebo Apple, ktorý používate pre svoj Customer účet.",
      LinkSsoNoAccount:
        "Pod týmto Google/Apple e-mailom nemáme žiadny Customer účet. Použite účet s rovnakým e-mailom, alebo sa prihláste heslom.",
      LinkSsoError:
        "Prepojenie cez Google/Apple zlyhalo. Skúste to prosím znovu.",
      CreateError: "Vytvorenie Identity zlyhalo. Skúste to prosím znovu.",
      AccountNotReady:
        "Tento účet nie je pripravený na použitie — registrácia nebola dokončená. Kontaktujte prosím podporu alebo svojho obchodného zástupcu a požiadajte o nové založenie účtu.",
      EmployeeNotSupported:
        "Zamestnanecké účty zatiaľ nie je možné prepojiť s Identitou. Obráťte sa prosím na svojho obchodníka alebo na podporu.",
      BackOfficeNotSupported:
        "Interné účty (Admin, AML, onboarding) sa neprepájajú ani nezakladajú svojpomocne — pripraví ich administrátor. Obráťte sa prosím na administrátora.",
      SignOut: "Odhlásiť sa",
      MerchantCreateIdentity: {
        Title: "Vytvoriť novú Identitu — štatutárny zástupca",
        Description:
          "Identita spoločnosti musí vychádzať z jej štatutárneho orgánu. Vyberte prosím, kto zo štatutárnych zástupcov ste, prípadne zadajte svoje údaje ručne.",
        CompanyLabel: "Spoločnosť",
        CompanyNumber: "(IČO: {{number}})",
        UnknownCompany: "(neznáma)",
        PickPersonTitle: "Štatutárni zástupcovia spoločnosti",
        AlreadyLinkedHint: "už má vlastnú Identitu",
        UnnamedPerson: "(bez mena)",
        StatutoryDeclaration:
          "Vyhlasujem, že som štatutárnym orgánom alebo členom štatutárneho orgánu spoločnosti {{company}}.",
        CreateAsButton: "Vytvoriť Identitu ako {{name}}",
        CreateAsButtonNoSelection: "Vytvoriť Identitu",
        ManualEntryToggle: "Nie som v zozname — zadať svoje údaje",
        ManualEntryToggleEmpty: "Zadať údaje ručne",
        ManualTitle: "Vaše osobné údaje (štatutárny zástupca)",
        FirstNameLabel: "Meno",
        LastNameLabel: "Priezvisko",
        BirthDateLabel: "Dátum narodenia",
        PhoneLabel: "Telefón",
        SubmitManualButton: "Vytvoriť Identitu",
        SubmitError: "Vytvorenie Identity zlyhalo. Skúste to prosím znovu.",
        LoadError: "Nepodarilo sa načítať zástupcov spoločnosti.",
        RelationTypes: {
          BeneficialOwner: "Skutočný majiteľ",
          ProxyHolder: "Prokurista",
          BranchManager: "Vedúci odštepného závodu",
          BranchOfficeManager: "Vedúci organizačnej zložky",
          ContactPerson: "Kontaktná osoba",
          StatutoryBody: "Štatutárny orgán",
          Mayor: "Starosta",
          Governor: "Predseda kraja",
          CityMayor: "Primátor",
          InsolvencyAdministrator: "Insolvenčný správca",
          Liquidator: "Likvidátor",
          ForcedAdministrator: "Nútený správca",
        },
      },
    },
    Invitations: {
      PageTitle: "Pozvánky",
      PageDescription:
        "Čakajúce pozvánky na prevzatie ďalších rolí v {{appName}}. Prijatím pridáte rolu k svojmu účtu, odmietnutím pozvánku zahodíte.",
      EmptyState: "Nemáte žiadne čakajúce pozvánky.",
      MerchantInviteTitle:
        "Boli ste pozvaný(á) prevádzkovať {{companyName}} ako obchodník.",
      MerchantInviteUnnamedCompany:
        "Boli ste pozvaný(á) prevádzkovať obchodnícky účet.",
      EmployeeInviteTitle:
        "Boli ste pozvaní pracovať pre {{companyName}} ako zamestnanec.",
      EmployeeBellTitle: "Nová pozvánka do firmy",
      EmployeeBellMessage:
        "Spoločnosť {{company}} vás pozýva ako zamestnanca. Pozvánku potvrdíte v sekcii Pozvánky.",
      MerchantBellTitle: "Nová pozvánka k spoločnosti",
      MerchantBellMessage:
        "Boli ste pozvaný(á) k správe spoločnosti {{company}}. Pozvánku potvrdíte v sekcii Pozvánky.",
      InvitedBy: "Pozval(a): {{inviter}}",
      ExpiresAt: "Platí do {{date}}",
      AcceptButton: "Prijať",
      DeclineButton: "Odmietnuť",
      KycRequired:
        "Pred prijatím dokončite overenie identity na svojom zákazníckom účte.",
      AcceptError: "Pozvánku sa nepodarilo prijať. Skúste to prosím znova.",
      AcceptedButSwitchFailed:
        "Pozvánka bola prijatá — ale nepodarilo sa na ňu prepnúť. Obnovte stránku alebo prepnite kontext v účte.",
      DeclineError: "Pozvánku sa nepodarilo odmietnuť. Skúste to prosím znova.",
      LoadError: "Nepodarilo sa načítať vaše pozvánky.",
    },
    ContextSwitcher: {
      Title: "Prepnúť rolu",
      AddRole: "Vytvoriť rolu",
      Switching: "Prepínam…",
      PersonalAccountHint: "Osobný účet",
      Roles: {
        Customer: "Zákazník",
        Hunter: "Hunter",
        HunterPlus: "Hunter Plus",
        Merchant: "Obchodník",
        Disponent: "Disponent",
        Employee: "Zamestnanec",
        Admin: "Administrátor",
        Aml: "AML",
        CustomerOnboarding: "Customer onboarding",
        AdminLite: "Admin (iba na čítanie)",
        Child: "Dieťa",
      },
    },
    ForgottenPassword: {
      Title: "Zabudnuté heslo",
      Email: "E-mail",
      ResetPasswordButton: "Resetovať heslo",
      SuccessMessage:
        "Ak používateľ s daným e-mailom existuje, poslali sme naň pokyny na obnovenie hesla.",
    },
    EmailVerification: {
      EmailSentTo: "Na Vašu e-mailovú adresu",
      Redirecting: "Presmerovanie",
      EmailVerification: "Overenie e-mailu",
      EmailSent: "E-mail bol odoslaný",
      ResendEmail: "Odoslať e-mail znova",
      EmailInstructions:
        "bol odoslaný e-mail s aktivačným odkazom. Pred pokračovaním je nutné účet aktivovať kliknutím na odkaz v tomto e-maile.",
      ResendEmailLabel: "Žiadny e-mail nedorazil?",
      ResendEmailText:
        "Skúste skontrolovať priečinok SPAM alebo Hromadné. Prípadne si nechajte poslať e-mail znova.",
    },
  },
  Account: {
    ThankYouFriendInvited: "Ďakujeme. Váš priateľ bol úspešne pozvaný.",
  },
  Components: {
    PasswordInput: {
      ShowPassword: "Zobraziť heslo",
      HidePassword: "Skryť heslo",
    },
    ShareButton: {
      AccessibilityLabel: "Zdieľať",
      Error: "Zdieľanie neprebehlo úspešne",
    },
    EmployeeAutocomplete: {
      Placeholder: "Vyberte zamestnancov",
      SelectAll: "Vybrať všetkých",
    },
    CategoryAutocomplete: {
      Placeholder: "Vyberte kategórie",
    },
    NoPrimaryAccountPopup: {
      Message:
        "Prosíme, zvolte si z Vašich pripojených bankovních účtov primárny účet, ktorý bude slúžiť ako východiskový účet pre Vaše transakcie.",
      Accounts: "Spravovať pripojené účty",
    },
    LanguageSwitcher: {
      ComingSoon: "Pripravujeme",
    },
    CountrySelector: {
      LoadingError:
        "Ospravedlňujeme sa, niečo sa pokazilo. Skúste to prosím neskôr.",
      Label: "Vyberte krajinu, v ktorej si chcete licenciu kúpiť",
      ComingSoon: "pripravujeme",
      SlovakLicensesComingSoon:
        "Slovenské licencie už čoskoro. Momentálne pripravujeme.",
    },
    RegionRequiredModal: {
      Title: "Vyber svoj trh",
      Description:
        "Trh určuje menu a settlement, v ktorom pôsobíš. Voľbu nie je možné neskôr zmeniť.",
      LoadingError: "Zoznam trhov nie je dostupný",
      Error: "Nastavenie regiónu sa nepodarilo. Skúste to prosím znova.",
      Confirm: "Potvrdiť",
    },
    LicenseOrder: {
      CreateError: "Objednávku licencie sa nepodarilo vytvoriť",
      CreateSuccess: "Objednávka licencie bola vytvorená",
      LoadingError:
        "Ospravedlňujeme sa, niečo sa pokazilo. Skúste to prosím neskôr.",
      Coupon: {
        Title: "Zľavový kupón",
        CheckboxLabel: "Mám zľavový kupón",
        Label: "Kód kupónu",
        Placeholder: "Zadajte kód kupónu",
        Validate: "Overiť",
        Applied: "Kupón uplatnený",
        Remove: "Odstrániť kupón",
        OriginalPrice: "Pôvodná cena",
        Discount: "Zľava",
        FinalPrice: "Cena po zľave",
        Error: {
          CouponNotFound: "Kupón nebol nájdený",
          CouponExpired: "Kupón už vypršal",
          CouponOutOfStock: "Kupón bol už vyčerpaný",
          CouponInvalidType: "Kupón nie je možné použiť pre tento typ licencie",
          CouponRegionMismatch: "Kupón neplatí pre vybranú krajinu",
          Unavailable: "Kupón už nie je možné použiť",
        },
      },
    },
    LicensePayment: {
      PendingActivationInfo:
        "Licencia bude aktivovaná po pripísaní platby. Ak už máte zaplatené, vyčkajte na pripísanie peňazí.",
    },
    Invoice: {
      PaymentData: "Platobné údaje",
      AccountNumber: "Číslo účtu",
      VariableSymbol: "Variabilný symbol",
      SpecificSymbol: "Špecifický symbol",
      IBAN: "IBAN",
      Reference: "Referencia platby",
      Amount: "Suma",
      Note: "Poznámka",
      MandatoryNoteDescription:
        "Poznámku je potrebné uviesť! Bez poznámky nebude platba spárovaná",
      EmployerGuidelineButton: "Stiahnuť pokyn pre zamestnávateľa",
      BulkDownload: {
        Download: "Stiahnuť faktúry",
        Success: "Faktúry boli úspešne stiahnuté",
        Error: "Nepodarilo sa stiahnuť faktúry",
      },
    },
    RevalidateBankingAuthModal: {
      Title: "U niektorých z Vašich bánk čoskoro vyprší overenie",
      Description:
        "Aby ste mohli používať {{appName}} ako ste zvyknutí aj naďalej, prosíme Vás o ich opätovné overenie.",
      InvalidTitle: "U niektorých z Vašich bánk vypršalo overenie",
      InvalidDescription:
        "Pre obnovenie funkcionality prosíme overte prístup k nasledujúcim bankám.",
      InvalidPispDescription:
        "Pre obnovenie platieb cez nasledujúce banky prosíme overte prístup.",
      ExpiringPispTitle: "Platobné oprávnenie čoskoro vyprší",
      ExpiringPispDescription:
        "Aby ste mohli aj naďalej platiť cez nasledujúce banky, prosíme o ich opätovné overenie.",
    },
    UnpaidSettlementPopup: {
      PayMonthlySettlement: "Zaplatiť mesačné vyúčtovanie vo výške {{amount}}.",
      PayMonthlySettlements: "Zaplatiť mesačné vyúčtovanie",
      NoSettlementTransactionError:
        "Chyba, vyúčtovanie nemá priradenú transakciu na zaplatenie",
    },
    LicensePicker: {
      LoadingError:
        "Ospravedlňujeme sa, ale niečo sa pokazilo. Skúste to prosím neskôr.",
      LicenseDescription: {
        [LicenseCode.Gold]:
          "Licencia Huntera v Legi.one s veľkým fyzickým obrazom.",
        [LicenseCode.Silver]:
          "Licencia Huntera v Legi.one so stredným fyzickým obrazom.",
        [LicenseCode.Bronze]:
          "Licencia Huntera v Legi.one s malým fyzickým obrazom.",
        [LicenseCode.Standard]:
          "Licencia Huntera v Legi.one s digitálnym obrazom.",
      },
      Perks: {
        Terminals: "terminálov",
        Terminals_one: "terminál",
        Terminals_few: "terminály",
        Terminals_other: "terminálov",
        SubAccounts: "podúčtov",
        SubAccounts_one: "podúčet",
        SubAccounts_few: "podúčty",
        SubAccounts_other: "podúčtov",
        NoSubAccounts: "Bez podúčtov",
      },
    },
    BanksList: {
      DataLoadingError:
        "Ospravedlňujeme sa, ponuku bánk sa nepodarilo načítať.",
      ShowAll: "Zobraziť všetko ({{count}})",
      HideAll: "Skryť",
    },
    LimitedAccountPopup: {
      Title: "Obmedzený účet",
      Message:
        "Vami zadané informácie je nutné overiť naším pracovníkom. Akonáhle bude všetko overené, budeme Vás informovať.",
    },
    DocumentExpirationWarning: {
      UploadNewDocument: "Nahrať nový doklad",
      UploadSuccess: "Doklad bol úspešne nahraný. Čaká na overenie.",
      AdminWarningTitle: "Platnosť dokladu používateľa čoskoro vyprší",
      AdminWarningMessage:
        "Platnosť dokladu totožnosti tohto používateľa vyprší {{date}}.",
      AdminExpiredTitle: "Platnosť dokladu používateľa vypršala",
      AdminExpiredMessage:
        "Platnosť dokladu totožnosti tohto používateľa vypršala. Používateľ má obmedzený prístup.",
      WarningPrimaryTitle: "Platnosť dokladu totožnosti čoskoro vyprší",
      WarningPrimaryMessage:
        "Platnosť vášho dokladu totožnosti vyprší {{date}}.",
      ExpiredPrimaryTitle: "Platnosť dokladu totožnosti vypršala",
      ExpiredPrimaryMessage: "Platnosť vášho dokladu totožnosti vypršala.",
      WarningSecondaryTitle: "Platnosť druhého dokladu čoskoro vyprší",
      WarningSecondaryMessage:
        "Platnosť vášho druhého dokladu vyprší {{date}}.",
      ExpiredSecondaryTitle: "Platnosť druhého dokladu vypršala",
      ExpiredSecondaryMessage: "Platnosť vášho druhého dokladu vypršala.",
      AdminWarningSecondaryTitle:
        "Platnosť druhého dokladu používateľa čoskoro vyprší",
      AdminWarningSecondaryMessage:
        "Platnosť druhého dokladu tohto používateľa vyprší {{date}}.",
      AdminExpiredSecondaryTitle:
        "Platnosť druhého dokladu používateľa vypršala",
      AdminExpiredSecondaryMessage:
        "Platnosť druhého dokladu tohto používateľa vypršala.",
      SecondDocumentValidTo: "Platnosť druhého dokladu do",
      AdminNotificationExpiredTitle: "Používateľovi vypršal doklad",
      AdminNotificationExpiredMessage:
        "Platnosť dokladu totožnosti používateľa {{user}} vypršala.",
    },
    RelatedPartyDocumentExpiration: {
      Title: "Doklady súvisiacich osôb vyžadujú pozornosť",
      WarningMessage:
        "{{name}} ({{relation}}) — doklad totožnosti vyprší {{date}}.",
      ExpiredMessage: "{{name}} ({{relation}}) — doklad totožnosti vypršal.",
      UpdateDocuments: "Aktualizovať doklady",
    },
    MooneLitePopup: {
      Title: "Lite účet",
      Message:
        "Váš účet funguje v obmedzenom režime Lite. Aby ste mohli využívať {{appName}} naplno, je nutné mať pripojený aspoň jeden bankový účet a dokončiť registráciu doplnením Vašich osobných údajov a overením Vášho dokladu totožnosti.",
      BankVerificationMessage:
        "Vaše osobné údaje a doklad totožnosti už máme. Aby ste mohli využívať {{appName}} naplno, zostáva pripojiť a overiť Váš bankový účet.",
      CompleteRegistrationButton: "Dokončiť registráciu",
      ConnectBankAccountButton: "Pripojiť bankový účet",
      LimitExceeded:
        "Vyčerpali ste limit pre používanie {{appName}} Lite. Ak chcete pokračovať v používaní {{appName}}, je nutné dokončiť registráciu doplnením Vašich osobných údajov a overením Vášho dokladu totožnosti.",
      RestrictionList: {
        NoPeerToPeerPayments: "Platby môžete poslať len obchodníkom",
        NoBalance: "Nevidíte zostatky na účtoch",
        NoIncomingPayments: "Nemôžete prijímať platby",
        NoLoyaltyPoints: "Nezískavate bonusové body Stardust",
        MaxPaymentLimit:
          "Maximálna výška odchádzajúcej platby je 1000 EUR (alebo ekvivalent v Kč)",
        MaxTransactionsLimit:
          "Pri prekročení stanoveného limitu transakcií dôjde k automatickému pozastaveniu služieb.",
      },
    },
    SetupChecklist: {
      Title: "Dokončenie registrácie",
      Subtitle: "Dokončite nasledujúce kroky a využívajte {{appName}} naplno.",
      LiteSubtitle:
        "Používate {{appName}} Lite — dokončite nasledujúce kroky, získajte Full {{appName}} a využívajte aplikáciu naplno.",
      MerchantTitle: "Dokončenie nastavenia",
      MerchantSubtitle:
        "Dokončite nasledujúce kroky a prijímajte platby s {{appName}}.",
      StepsCompleted: "Dokončených {{completed}} z {{total}} krokov",
      Start: "Začať",
      InReview: "Overuje sa",
      Steps: {
        ConnectBank: {
          Title: "Pripojte bankový účet",
          Description:
            "Pridajte svoj bankový účet, aby ste mohli odosielať platby.",
          Action: "Pripojiť účet",
        },
        SetPrimaryAccount: {
          Title: "Nastavte hlavný bankový účet",
          Description:
            "Pre odchádzajúce platby, rýchle platby a príjem platieb.",
          Action: "Zvoliť hlavný účet",
          BlockedDescription:
            "Hlavný účet budete môcť zvoliť, hneď ako bude vaša totožnosť overená.",
        },
        VerifyIdentity: {
          Title: "Overte svoju totožnosť",
          Description: "Odomkne zostatky, prichádzajúce platby a Stardust",
          Action: "Overiť totožnosť",
        },
      },
    },
    Bitcoin: "Bitcoin",
    IBAN: "IBAN",
    Maximum: "maximum",
    SAT: "SAT",
    Or: "alebo",
    RateConfirmation: "Potvrdenie kurzu",

    Account: {
      DeactivateUser: {
        Title: "Týmto krokom deaktivujete svoj {{appName}} účet",
        Description:
          "Váš účet bude deaktivovaný a už se nebudete môcť do účtu dále přihlásit.",
        Confirmation:
          "Naozaj chcete účet deaktivovať? Deaktiváciou strátite prístup k Vašemu {{appName}} účtu.",
        DeactivateButton: "Deaktivovať účet",
        SuccessMessage: "Účet bol úspešne deaktivovaný.",
        InfoSection: {
          Title: "Čo znamená deaktivácia účtu?",
          Paragraph1:
            "Deaktiváciou účtu okamžite stratíte prístup do aplikácie {{appName}} (prihlásenie, platby, licencie, správa účtov) a zastavia sa všetky prebiehajúce procesy, vrátane vyplácania cashbacku, settlementov a affiliate provízií.",
          Paragraph2:
            "Vaše dáta a história transakcií však v systéme zostávajú. Podľa pravidiel ČNB a zákona proti praniu špinavých peňazí (AML) máme povinnosť tieto údaje archivovať po dobu 10 rokov od ukončenia spolupráce na účely prípadnej kontroly úradov.",
        },
      },
      AccountTab: "Nastavenia",
      PublicInformationTab: "Profil",
      Products: "Produkty",
      Facilities: "Prevádzky",
      ContactPersons: "Kontaktné osoby",
      NoRoleAssignedError:
        "Nastala chyba - používateľ nemá priradenú žiadnu rolu.",
      Primary: "Primárny",
      VerificationAccount: "Overovací účet",
      AccountOwner: "Majiteľ účtu",
      ConnectionDate: "Dátum pripojenia",
      ManualVerificationRequired: "Tento účet je nutné overiť manuálne",
      ActivateAccount: "Aktivovať",
      RejectAccount: "Zamietnuť",
      AccountActivationConfirm:
        "Naozaj chcete tento účet aktivovať?\n\nTáto akcia je nevratná.",
      AccountRejectionConfirm:
        "Naozaj chcete tento účet zamietnuť?\n\nTáto akcia je nevratná.",
      TerminalDocuments: "Podklady pre terminál",
      TerminalDocumentsFailed:
        "Údaje o podkladoch pre terminál sa nepodarilo načítať.",
      MerchantFacilitiesFailed: "Údaje o prevádzkach sa nepodarilo načítať.",
      RelatedParties: "Súvisiace osoby",
      RelatedPartySaved: "Uloženie údajov súvisiacej osoby prebehlo úspešne",
      RelatedPartyError:
        "Pri ukladaní údajov súvisiacej osoby sa vyskytla chyba",
      NoDocumentsForPerson:
        "Pre túto osobu neevidujeme žiadne nahrané doklady.",
      VerificationSaved: "Uloženie údajov overenia prebehlo úspešne",
      VerificationError: "Pri ukladaní údajov overenia sa vyskytla chyba",
      GeneralInformation: "Obecné údaje",
      Verification: "Overenie",
      Company: "Spoločnosť",
      Declaration: "Prehlásenie",
      PersonalInformation: "Informácie o Vás",
      CompanyName: "Názov spoločnosti",
      TaxNumber: "DIČ",
      TaxResidence: "Daňová rezidencia",
      BusinessSubject: "Predmet podnikania",
      SpecifyBusinessSubject: "Upresnite predmet podnikania",
      IncomeSource: "Zdroj príjmov",
      LegacyIncomeSource: "Predchádzajúci zdroj príjmov",
      SpecifyIncomeSource: "Upresnite zdroj príjmov",
      ExpectedMonthlyVolume: "Očakávaný mesačný objem",
      AverageTransactionValue: "Priemerná hodnota jednej transakcie",
      PoliticallyExposed: "Politicky exponovaná osoba",
      NonEUPermanentResidence:
        "Mám aktuálne (ke dni registrácie) bydlisko mimo EU po dobu dlhšiu než 12 mesiacov",
      NonEUNationality: "Som štátnym príslušníkom inej krajiny mimo EÚ",
      StreetNumber: "Súpisné číslo",
      OrientationNumber: "Orientančné číslo",
      PostalCode: "PSČ",
      DocumentNumber: "Číslo dokladu",
      BankAccount: "Bankový účet",
      PartyError: "Pri ukladaní údajov osoby sa vyskytla chyba",
      VatRegistration: "Registrácia k DPH",
      VatNumberRestoredByRegistry:
        "Register DPH potvrdil IČ DPH {{vatNumber}}, preto zostáva uložené — register je zdrojom pravdy.",
      VatStatusNotVerifiedHint:
        "Stav v registri DPH zatiaľ nie je overený. IČ DPH môžete doplniť kedykoľvek.",
      PersonalDataChangeNotification:
        "V prípade potreby zmeny osobných údajov zašlite prosím nové údaje na info@mo.one.",
      SecondDocumentUploadError: "Nepodarilo sa nahrať druhý doklad",
      SecondDocumentUploadSuccess:
        "Druhý doklad bol úspešne nahraný a spracovaný",
      FirstDocumentUploadError: "Nepodarilo sa nahrať doklad",
      FirstDocumentUploadSuccess: "Doklad bol úspešne nahraný a spracovaný",
      FirstDocumentUpload: {
        UploadButton: "Nahrať doklad",
        FileDescription: "Kliknite sem pre nahranie alebo odfotenie",
      },
      SecondDocumentUpload: {
        Title: "Druhý doklad",
        Description:
          "Druhým dokladom môže byť vodičský preukaz alebo cestovný pas.",
        UploadButton: "Nahrať druhý doklad",
        FileLabel: "Predná strana druhého dokladu",
        FileDescription: "Kliknite sem pre nahranie alebo odfotenie",
      },
    },
    Forms: {
      Validation: {
        InvalidEmail: "E-mail nie je platný",
        PasswordMinLength: "Heslo musí mít alespoň 8 znakov",
        PasswordLowercase: "Heslo musí obsahovat alespoň jedno malé písmeno",
        PasswordUppercase: "Heslo musí obsahovat alespoň jedno veľké písmeno",
        PasswordNumber: "Heslo musí obsahovať alespoň jedno číslo",
        TermsAgreement: "Musíte súhlasiť s obch. podmienkami",
        UserAlreadyExists: "Používateľ už {{appName}} používa.",
        InvitationAlreadySent: "Na tento e-mail ste už poslali pozvánku.",
        InvitationError: "Pri pozývaní sa vyskytla chyba.",
      },
    },
    Merchant: {
      Logo: {
        FacilityTitle: "Logo prevádzky",
        Hint: "Podporované formáty: PNG, JPEG, WebP, SVG (max. 2 MB). Odporúčame tmavé logo na bielom alebo priehľadnom pozadí.",
        FileTooLarge: "Súbor je príliš veľký (max. 2 MB)",
        InvalidFileType: "Nepodporovaný typ súboru",
        UploadSuccess: "Logo bolo nahraté",
        UploadError: "Nahranie loga sa nepodarilo",
        DeleteSuccess: "Logo bolo zmazané",
        DeleteError: "Zmazanie loga sa nepodarilo",
      },
      Avatar: {
        Title: "Avatar obchodníka",
        Hint: "Podporované formáty: PNG, JPEG, WebP (max. 2 MB). Avatar sa zobrazuje ako obrázok obchodníka aj v chate.",
        RemoveConfirm: "Odstrániť avatar obchodníka?",
        LockedAfterOnboardingHint:
          "Avatar obchodníka môžete meniť iba počas jeho onboardingu. Obchodník si ho môže kedykoľvek zmeniť vo svojom účte.",
        UploadSuccess: "Avatar obchodníka bol uložený",
        UploadError: "Nahranie avatara obchodníka zlyhalo",
        DeleteSuccess: "Avatar obchodníka bol odstránený",
        DeleteError: "Odstránenie avatara obchodníka zlyhalo",
      },
      Pricings: {
        PricingSettingError: "Chyba - Nepodarilo sa nastaviť cenník",
        PricingChangeError: "Chyba - Nepodarilo sa zmeniť cenník",
        LoadingError: "Cenníky poplatkov sa nepodarilo načítať.",
        DirectPaymentError:
          "Poplatok priamej platby sa nepodarilo načítať, kontaktujte prosím administrátora.",
        SelectPricingLabel: "Vyberte cenník",
        FeeWithFee: "{{totalFee}}%",
        FeeWithCategoryAndFee: "{{categoryName}} {{totalFee}}%",
        FeeWithFeeAndAssignedCount:
          "{{totalFee}}% - {{assignedCount}}× priradené",
        FeeWithCategoryFeeAndAssignedCount:
          "{{categoryName}} {{totalFee}}% - {{assignedCount}}× priradené",
        CategoryNames: {
          Partner: "Partner",
          Prime: "Prime",
          Standard: "Standard",
          Individual: "Individuálny",
        },
      },
      BeneficialOwners: {
        BeneficialOwnerDetail: "Detail skutočného vlastníka",
        AddBeneficialOwner: "+ Pridať skutočného vlastníka",
        NewBeneficialOwner: "Nový skutočný vlastník",
        Title: "Skutoční vlastníci",
        LoadingError:
          "Chyba - Nepodarilo sa načítať údaje o skutočných vlastníkoch",
        NoBeneficialOwners: "Nie je pridaný žiadny skutočný vlastník",
        Form: {
          DeleteConfirmation:
            "Naozaj chcete odstrániť skutočného vlastníka {{name}}?",
          AddSuccess: "Vlastník bol úspešne pridaný",
          AddError: "Chyba - Nepodarilo sa pridať vlastníka",
          UpdateSuccess: "Vlastník bol úspešne upravený",
          UpdateError: "Chyba - Nepodarilo sa upraviť vlastníka",
          Legend: "Skutočný vlastník",
        },
      },
      LoadingError: "Chyba - Nepodarilo sa načítať údaje o obchodníkovi",
      PaymentFailed: "Údaje sa nepodarilo načítať.",
      AccountLoadingError: "Chyba - Nepodarilo sa načítať Vaše účty",
      PayPoints: {
        NoBankAccountConnectedWarning: {
          title: "Nenájdený bankový účet",
          linkPretext: "Platby na paypoint môžete vytvárať až po",
          linkText: "pripojení bankového účtu.",
        },
        NoProductAssigned: "Nemáte priradený žiadny produkt.",
        NoPaypointProduct:
          "Nemáte priradený žiadny produkt umožňujúci vytvorenie paypointu.",
      },
      ContactPersons: {
        Title: "Kontaktné osoby",
        LoadingError: "Chyba - Nepodarilo sa načítať kontaktné osoby",
        DeleteSuccess: "Kontaktná osoba bola úspešne odstránená",
        DeleteError: "Chyba - Nepodarilo sa odstrániť kontaktnú osobu",
        DeleteConfirmation: "Naozaj chcete odstrániť kontaktnú osobu {{name}}?",
        AddContactPerson: "+ Pridať kontaktnú osobu",
        NewContactPerson: "Nová kontaktná osoba",
        ContactPersonDetail: "Detail kontaktnej osoby",
        NoContactPersons: "Nie je pridaná žiadna kontaktná osoba.",
        Form: {
          AddSuccess: "Kontaktná osoba bola úspešne pridaná",
          AddError: "Chyba - Nepodarilo sa pridať kontaktnú osobu",
          UpdateSuccess: "Kontaktná osoba bola úspešne upravená",
          UpdateError: "Chyba - Nepodarilo sa upraviť kontaktnú osobu",
          Legend: "Kontaktná osoba",
        },
      },
      Facilities: {
        Title: "Prevádzky",
        LoadingError: "Údaje o prevádzkach sa nepodarilo načítať.",
        DeleteSuccess: "Prevádzka bola úspešne odstránená",
        DeleteError: "Chyba - Nepodarilo sa odstrániť prevádzku",
        DeleteConfirmation: "Naozaj chcete odstrániť prevádzku {{name}}?",
        AddFacility: "+ Pridať prevádzku",
        NewFacility: "Nová prevádzka",
        EditFacility: "Upraviť prevádzku",
        FacilityDetail: "Detail prevádzky",
        NoFacilities: "Nie je pridaná žiadna prevádzka.",
        NoAddress: "Žiadna adresa",
        Incomplete: "Nedokončené",
        NoPhotos: "Prevádzka nemá nahrané žiadne fotografie.",
        PhotosLoadingError: "Fotografie prevádzky sa nepodarilo načítať.",
        Form: {
          AddSuccess: "Prevádzka bola úspešne pridaná",
          AddError: "Chyba - Nepodarilo sa pridať prevádzku",
          UpdateSuccess: "Prevádzka bola úspešne upravená",
          UpdateError: "Chyba - Nepodarilo sa upraviť prevádzku",
          PhotoUploadSuccess: "Fotografie boli úspešne nahrané",
          PhotoUploadError: "Chyba - Nepodarilo sa nahrať fotografie",
          PhotoTooLarge: "Fotografia je príliš veľká (max. {{maxSizeMb}} MB).",
          PhotoInvalidType:
            "Nepodporovaný typ súboru. Použite JPEG, PNG alebo WebP.",
          PhotosNotSaved:
            "Prevádzka bola uložená, ale fotografie sa nenahrali. Opravte označenú fotografiu a uložte znovu.",
          PhotosDescription:
            "Nahrajte fotografie vašej prevádzky. Tieto fotografie budú viditeľné pre zákazníkov. JPEG, PNG alebo WebP, max. {{maxSizeMb}} MB na fotografiu.",
          UploadPhotos: "Nahrať fotografie",
          PhotoSelected: "Vybraný súbor: {{name}}",
          PhotoUploadButton: "Nahrať",
          PhotoChangeButton: "Zmeniť",
          PhotoDeleteButton: "Zmazať",
          Legend: {
            BasicInformation: "Základné informácie",
            Contact: "Kontakt",
            OpeningHours: "Otváracie hodiny",
            Address: "Adresa",
            Turnover: "Obrat",
            Terminals: "Terminály",
            PublicFacilityInfo: "Informácie o verejnej prevádzke",
            DetailedOpeningHours: "Detailné otváracie hodiny",
            Photos: "Fotografie prevádzky",
          },
          RequiredSection: "Povinné údaje",
          OptionalSection: "Nepovinné údaje",
          OptionalSectionDescription:
            "Obchodník tieto údaje doplní pri svojej registrácii. Pokiaľ máte tieto informácie k dispozícii, môžete ich predvyplniť.",
          PublicFacilityDescription:
            "Verejné prevádzky vyžadujú ďalšie informácie. Vyplňte ich prosím nižšie.",
          IsPublicHelpText:
            'Toto umožní zákazníkom vidieť vašu prevádzku v zozname "kde platiť".',
          UseRegisteredAddress: "Zhodná s adresou sídla",
          PrefillContact: "Predvyplniť kontakt z",
          NoName: "Bez mena",
          Validation: {
            CategoryRequiredWhenPublic:
              "Pre verejnú prevádzku je vyžadovaná aspoň jedna kategória",
          },
          Fields: {
            Name: "Názov",
            ProvidedServices: "Poskytované služby",
            ResponsiblePerson: "Zodpovedná osoba",
            Phone: "Telefón",
            Email: "E-mail",
            IsPublic: "Chcem aby táto prevádzka bola verejná",
            Category: "Kategória",
            OpeningHoursFrom: "Od",
            OpeningHoursTo: "Do",
            Address: {
              Street: "Ulica",
              StreetNumber: "Súpisné číslo",
              OrientationNumber: "Orientančné číslo",
              PostalCode: "PSČ",
              Municipality: "Obec",
              District: "Kraj",
            },
            WeekDays: {
              Monday: "Pondelok",
              Tuesday: "Utorok",
              Wednesday: "Streda",
              Thursday: "Štvrtok",
              Friday: "Piatok",
              Saturday: "Sobota",
              Sunday: "Nedeľa",
            },
            YearlyTurnover: "Celkový obrat za posledný rok",
            RealCardTurnover:
              "Skutočný obrat prostredníctvom platobných kariet za posledný rok",
            AverageTransactionValue: "Priemerná výška jednej transakcie",
            EstimatedTurnover: "Predpokladaný celkový obrat",
            EstimatedTurnoverHelperText:
              "Prosím vyplňte toto pole iba v prípade, že ide o novú spoločnosť",
            TerminalCount: "Počet fyzických terminálov",
            TerminalCountHelperText: "Fyzické terminály nezahŕňajú SoftPOS.",
            SoftPosCount: "Počet SoftPOS",
            SoftPosCountHelperText:
              "Platobná aplikácia v telefóne. Nerezervuje sa žiadny fyzický terminál.",
            Description: "O nás",
            PhotoOutside: "Fotografia exteriéru",
            PhotoInside: "Fotografia interiéru",
          },
          OpeningHours: {
            Title: "Otváracie hodiny",
            ClosedAllDay: "Zatvorené celý deň",
            OpenAllDay: "Otvorené 24 hodín",
            AddTimeRange: "Pridať časový rozsah",
            DeleteTimeRange: "Odstrániť časový rozsah",
            From: "Od",
            To: "Do",
            BulkEdit: "Upravit všetky",
            ExitBulkEdit: "Ukončiť hromadnú úpravu",
            ApplyToSelected: "Použiť na vybrané dni",
            SelectDays: "Vyberte dni",
            QuickSelectTitle: "Rýchly výber",
            Cancel: "Zrušiť",
            Save: "Uložiť",
            TimeRange: "Od - Do",
            CurrentHours: "Aktuálne otváracie hodiny",
            ShowDetailedEdit: "Upraviť jednotlivé dni",
            HideDetailedEdit: "Skryť úpravu jednotlivých dní",
            QuickSelect: {
              Weekdays: "Po-Pia",
              AllWeek: "Po-Ne",
              Weekend: "Víkend",
            },
            Validation: {
              CannotBeBothOpenAndClosed:
                "Nemôže byť súčasne otvorené aj zatvorené celý deň",
              InvalidTimeFormat: "Neplatný formát času. Očakáva sa HH:MM:SS",
              OpeningTimeBeforeClosingTime:
                "Čas otvorenia musí byť pred časom zatvorenia",
            },
          },
        },
      },
      OrbitL: {
        Title: "Platobné terminály",
        StatusLabel: "Stav objednávky",
        RefreshTooltip: "Aktualizovať stav",
        Tariff: {
          Label: "Cenník",
          Pos1Cz: "Cenník 1 — 0,49 % MIF++",
          Pos2Cz: "Cenník 2 — 0,41 % MIF++",
          Pos3Cz: "Cenník 3 — 0,35 % MIF++",
          Pos4Cz: "Cenník 4 — 0,29 % MIF++",
        },
        Financing: {
          Label: "Financovanie terminálu",
          Legione: "Terminál financovaný Legi.one",
          Hunter: "Terminál financovaný Hunterom",
        },
        HunterCapacity: {
          AvailableHelper: "Hunter má k dispozícii {{count}} terminálov",
          ExceedsError:
            "Počet terminálov ({{requested}}) prekračuje dostupnú kapacitu huntera ({{available}}).",
        },
        Progress: {
          Steps: {
            Completion: "Doplnenie údajov",
            Signing: "Podpis dokumentov",
            Processing: "Spracovanie",
            Dispatch: "Expedícia terminálov",
            DispatchSoftPos: "Aktivácia SoftPOS",
            Done: "Dokončené",
          },
        },
        Checklist: {
          Heading: "Kontrolný zoznam požiadaviek",
          CompletionSuccess:
            "Všetky požiadavky sú splnené. Môžete pokračovať k stiahnutiu zmluvy.",
          ToCompleteSection: "Na doplnenie",
          GoToSettingsLink: "Prejsť do nastavení",
          Items: {
            BasicInfo: "Základné údaje obchodníka",
            FacilityInfo: "Informácie o prevádzke",
            BankAccountInfo: "Bankový účet pre výplatu",
            ExecutiveInfo: "Údaje štatutárneho zástupcu",
            ExecutiveInfoSelfEmployed: "Vaše osobné údaje",
            ExecutiveDocuments: "Doklady totožnosti zástupcu",
            ExecutiveDocumentsSelfEmployed: "Vaše doklady totožnosti",
            TerminalAssignment: "Priradenie terminálov k prevádzkam",
          },
          Validation: {
            BasicInfo: "Doplňte prosím základné údaje obchodníka",
            FacilityInfo: "Doplňte prosím informácie o prevádzke",
            BankAccountInfo: "Pridajte alebo overte bankový účet pre výplatu",
            ExecutiveInfo: "Doplňte prosím údaje štatutárneho zástupcu",
            ExecutiveInfoSelfEmployed: "Doplňte prosím vaše osobné údaje",
            ExecutiveDocuments: "Nahrajte prosím doklady totožnosti zástupcu",
            ExecutiveDocumentsSelfEmployed:
              "Nahrajte prosím vaše doklady totožnosti",
            TerminalAssignment:
              "Terminály nie sú plne priradené ku všetkým prevádzkam",
          },
          BankReconnect: {
            Explanation:
              "Bankový účet máte pridaný, ale chýba overenie jeho vlastníctva. Obnovte prosím pripojenie k banke – prihlásite sa do internetového bankovníctva a vrátite sa späť.",
            Button: "Obnoviť pripojenie banky",
          },
          MissingFields: {
            MissingExecutive: "nie je evidovaný žiadny štatutárny zástupca",
            PrimaryBankAccount:
              "nie je nastavený primárny bankový účet na výplatu",
            BankVerificationAudit: "chýba overenie vlastníctva bankového účtu",
            BirthDate: "dátum narodenia",
            Email: "e-mail",
            Phone: "telefón",
            PermanentAddress: "miesto bydliska",
            PermanentAddressStreet: "ulica alebo číslo domu",
            PermanentAddressMunicipality: "obec bydliska",
            PermanentAddressPostalCode: "PSČ bydliska",
            Documents: "doklady totožnosti",
            FirstDocumentNumber: "číslo prvého dokladu",
            FirstDocumentValidity: "platnosť prvého dokladu",
            FirstDocumentPhotos: "fotografie prvého dokladu",
            SecondDocumentNumber: "číslo druhého dokladu",
            SecondDocumentValidity: "platnosť druhého dokladu",
            SecondDocumentPhotos: "fotografie druhého dokladu",
          },
        },
        Rejection: {
          Title: "Spracovateľ vrátil doklady na opravu",
          Intro:
            "U nižšie uvedených dokladov je potrebné vykonať opravu. Doplňte ich v nastaveniach a my objednávku odošleme znova.",
          ContractGroup: "Zmluva a firemné údaje",
          DocumentLabel: "{{type}} č. {{number}}",
          DocumentTypes: {
            IdCard: "Občiansky preukaz",
            Passport: "Pas",
            DriverLicense: "Vodičský preukaz",
            OtherDocument: "Ostatný dokument",
          },
        },
        Phase: {
          RequiresCompletion: "Vyžaduje doplnenie",
          ReadyToDownloadContract: "Pripravené na stiahnutie",
          ContractDownloaded: "Zmluva stiahnutá",
          SubmittedToComgate: "Odoslané na spracovanie",
          ProcessingByComgate: "Spracovávame",
          TerminalDispatched: "Terminály vyexpedované",
          Completed: "Dokončené",
        },
        FinancingModel: {
          Hunter: "Hunter",
          Legione: "LEGI.ONE",
        },
        Messages: {
          LoadStatusError: "Nepodarilo sa načítať stav objednávky Orbit L",
          Processing:
            "Vaša objednávka sa spracováva. O ďalšom postupe vás budeme informovať emailom.",
          CompletedSuccess:
            "Objednávka je dokončená. Terminály boli odovzdané a sú aktívne.",
        },
        Contract: {
          DocumentsHeading: "Zmluvné dokumenty",
          LoanTitle: "Zmluva o výpožičke terminálu",
          LoanFileName: "Zmluva_o_vypozicke_terminalu",
          PaymentServicesTitle: "Zmluva o platobných službách",
          PaymentServicesFileName: "Zmluva_o_platobnych_sluzbach",
          DownloadedAt: "Zmluva bola stiahnutá dňa {{date}}",
          DownloadButton: "Stiahnuť zmluvu",
          DownloadAgainButton: "Stiahnuť zmluvu znova",
          AcceptanceLabel:
            'Potvrdzujem, že som si prečítal/a obe zmluvy a súhlasím s ich podmienkami. Kliknutím na tlačidlo "Záväzne objednať" zmluvy elektronicky podpisujem.',
          SubmitButton: "Záväzne objednať kartové služby",
          SubmittingButton: "Odosielam...",
          SubmitNote:
            "Po odoslaní objednávky spracujeme vašu žiadosť. O ďalšom postupe vás budeme informovať emailom.",
          DownloadSuccess: "Zmluva bola úspešne stiahnutá",
          DownloadError: "Stiahnutie zmluvy zlyhalo",
          SubmitSuccess: "Objednávka bola úspešne odoslaná na spracovanie.",
          SubmitError: "Odoslanie objednávky Orbit L zlyhalo: {{error}}",
          SubmitErrorGeneric: "Odoslanie objednávky zlyhalo",
        },
        Handover: {
          DispatchedNoData:
            "Terminály boli vyexpedované. Informácie o termináloch budú doplnené automaticky po aktualizácii stavu.",
          Title: "Odovzdanie terminálov",
          DispatchedReady:
            "Vaše terminály boli vyexpedované a sú pripravené na aktiváciu.",
          TableTID: "TID (Terminal ID)",
          TableSerialNumber: "Sériové číslo",
          TableModel: "Model",
          Note: "Po potvrdení odovzdania budú terminály automaticky aktivované ako platobné miesta (PayPoints) vo vašom účte.",
          ConfirmButton: "Potvrdiť prijatie terminálov",
          ConfirmingButton: "Potvrdzujem...",
          ConfirmSuccess: "Odovzdanie terminálov bolo úspešne potvrdené",
          ConfirmError: "Potvrdenie odovzdania terminálov zlyhalo: {{error}}",
          ConfirmErrorGeneric: "Potvrdenie odovzdania zlyhalo",
        },
        TerminalSelection: {
          Title: "Výber terminálov",
          SelectionCount: "{{selected}} z {{required}} terminálov vybraných",
          NoTerminalsAvailable:
            "Nemáte k dispozícii žiadne terminály na priradenie",
          StockExceeded:
            "Celkový počet terminálov ({{total}}) presahuje dostupný sklad ({{available}})",
          SerialNumber: "SN",
          HardwareModel: "Model",
        },
        FacilityTerminals: {
          Title: "Priradenie terminálov k prevádzkam",
          TerminalCountLabel: "Počet fyzických terminálov",
          TerminalCountHelperText: "Fyzické terminály nezahŕňajú SoftPOS.",
          SoftPosCountLabel: "Počet SoftPOS",
          SoftPosCountHelperText:
            "Platobná aplikácia v telefóne, bez fyzického terminálu.",
          SoftPosRequestHelperText:
            "SoftPOS zatiaľ nemáte. Zadajte počet a odošlite žiadosť, po potvrdení podporou sa SoftPOS aktivuje.",
          SoftPosStatus: "SoftPOS: {{count}}",
          TerminalStatus: "{{assigned}}/{{total}} priradených",
          NoTerminalsConfigured: "Terminály nenastavené",
          NoAddress: "Žiadna adresa",
          FullyReserved: "Všetky terminály sú priradené",
          SaveButton: "Uložiť terminály",
          Saving: "Ukladám...",
          SaveSuccess: "Terminály boli úspešne priradené",
          SaveError: "Priradenie terminálov zlyhalo",
          InsufficientStock:
            "Nedostatočný počet terminálov na sklade. Kontaktujte podporu.",
          CountsLocked:
            "Počty terminálov už nie je možné meniť priamo, objednávka je v Comgate. Pošlite žiadosť o zmenu počtu, ktorú vybaví podpora.",
          LoadError: "Nepodarilo sa načítať údaje o termináloch",
          AssignedTerminals: "Priradené terminály",
        },
        TerminalCountChange: {
          NotificationTitle: "Žiadosť o zmenu počtu terminálov",
          NotificationMessage:
            "{{company}} žiada o zmenu počtu terminálov z {{from}} na {{to}}.",
          LockedHint:
            "Objednávka je už v Comgate, počet terminálov preto nie je možné zmeniť priamo. Pošlite žiadosť podpore.",
          RequestButton: "Požiadať o zmenu",
          ModalTitle: "Žiadosť o zmenu počtu terminálov",
          ModalDescription:
            "Po odoslaní objednávky do Comgate už počet terminálov nie je možné zmeniť automaticky. Odoslaním vytvoríte žiadosť pre našu podporu, ktorá zmenu dohodne s Comgate a ozve sa vám.",
          ModalSummaryHeading: "Súhrn zmeny",
          ModalFacilityChange: "{{facility}}: {{from}} → {{to}}",
          ModalTotal: "Celkom: {{from}} → {{to}}",
          ModalFacilitySoftPosChange:
            "{{facility}} (SoftPOS): {{from}} → {{to}}",
          ModalSoftPosTotal: "SoftPOS spolu: {{from}} → {{to}}",
          ModalNoteLabel: "Poznámka pre podporu (nepovinné)",
          ModalNotePlaceholder: "Napr. otvárame novú prevádzku 1. 9.",
          ModalConfirm: "Odoslať žiadosť",
          ModalCancel: "Zrušiť",
          PendingTitle: "Žiadosť o zmenu počtu terminálov bola odoslaná",
          PendingMessage:
            "Žiadosť o zmenu počtu terminálov z {{from}} na {{to}} bola odoslaná podpore. Ozveme sa vám, len čo zmenu s Comgate dohodneme.",
          PendingNote: "Vaša poznámka: {{note}}",
          PendingSoftPosMessage: "SoftPOS licencie: {{from}} → {{to}}.",
          RequestSuccess: "Žiadosť bola odoslaná podpore",
          RequestError: "Žiadosť sa nepodarilo odoslať",
          RequestConflictError:
            "Už máte otvorenú žiadosť o zmenu počtu terminálov. Vyčkajte na jej vyriešenie.",
        },
      },
      TerminalContracts: {
        Title: "Podklady pre terminál",
        LoadingError: "Údaje o podkladoch pre terminál sa nepodarilo načítať.",
        NoTerminalContracts: "Nie je pridaný žiadny podklad pre terminál.",
        AddSuccess: "Podklady pre terminál boli úspešne pridané",
        AddError: "Chyba - Nepodarilo sa pridať podklady pre terminál",
        UpdateSuccess: "Podklady pre terminál boli úspešne upravené",
        UpdateError: "Chyba - Nepodarilo sa upraviť podklady pre terminál",
        DeleteSuccess: "Podklady pre terminál boli úspešne odstránené",
        DeleteError: "Chyba - Nepodarilo sa odstrániť podklady pre terminál",
        DeleteConfirmation:
          "Naozaj chcete odstrániť podklad pre zmluvu {{type}}?",
        AddButtonText: "+ Vytvoriť nový podklad pre zmluvu k terminálu",
        NewContractDialogTitle: "Nový podklad pre zmluvu k terminálu",
        EditContractDialogTitle: "Upraviť podklad pre zmluvu k terminálu",
        ViewContractDialogTitle: "Detail podkladu pre zmluvu k terminálu",
        ProductType: {
          UCB: "Orbit M - Fyzický terminál bez tlačiarne (Android)",
          COMGATE: "Orbit L - Fyzický terminál s tlačiarňou (Android)",
          ELCOM: "Orbit ELCOM - Terminál ELCOM",
        },
        Form: {
          Fields: {
            Type: "Typ",
            GprsCount: "Počet GPRS terminálov",
            TerminalCount: "Počet fyzických terminálov",
            TerminalCountHelperText: "Fyzické terminály nezahŕňajú SoftPOS.",
            SoftPosCount: "Počet SoftPOS",
            CountsFromFacilitiesHint:
              "Súčet za prevádzky; upravuje sa vo formulári prevádzky.",
            Currencies: "Meny",
            Tariff: "Tarif",
            PayoutIBAN: "IBAN pre výplaty",
            PayoutBIC: "BIC pre výplaty",
            PayoutCurrency: "Mena výplat",
            PayoutAccountNumber: "Číslo účtu pre výplaty",
          },
        },
        Comgate: {
          SubmitButton: "Odoslať do Comgate",
          Submitting: "Odosielanie...",
          SubmitConfirmation:
            "Táto akcia vygeneruje zmluvu o pôžičke, automaticky ju prijme a odošle údaje obchodníka do Comgate. Pokračovať?",
          SubmitSuccess: "Úspešne odoslané do Comgate. MID: {{mid}}",
          SubmitError:
            "Nepodarilo sa odoslať do Comgate. Skúste to prosím znova.",
          SubmitViaOrbitL:
            "Na odoslanie zmluvy do Comgate použite Orbit L onboarding.",
          StatusLabel: "Stav Comgate",
          Statuses: {
            REQUESTED: "Požadované",
            PROCESSING: "Spracováva sa",
            WAITING_FOR_DOCUMENTS: "Čaká sa na dokumenty",
            WAITING_FOR_AUTHORIZATION_PAYMENT: "Čaká sa na autorizačnú platbu",
            ERRORS_IN_DOCUMENTS: "Chyby v dokumentoch",
            ERROR_ACTION_PENDING: "Chyba – čaká sa na akciu",
            REJECTED: "Zamietnuté",
            ASSOCIATION_REGISTERING: "Registrácia u asociácie",
            READY: "Pripravené",
          },
        },
      },
      AppProducts: {
        Title: "Produkty",
        LoadingError: "Produkty sa nepodarilo načítať.",
        NoProducts: "Nie je pridaný žiadny produkt.",
        Form: {
          AddError: "Chyba - Nepodarilo sa pridať produkt",
          AddErrorCountsLocked:
            "Objednávka už je v Comgate, produkt preto nie je možné pridať priamo. Pošlite žiadosť o zmenu počtu terminálov, ktorú vybaví podpora.",
          RemoveError: "Chyba - Nepodarilo sa odstrániť produkt",
          Prerequisites: {
            Title: "Podmienky pre aktiváciu produktu",
            FacilityAdded: "Vyplnená prevádzka",
            FacilityPhotos: "Fotografie prevádzky (exteriér + interiér)",
          },
        },
        UnknownProduct: "Neznámy produkt",
        Products: {
          OrbitS: "Orbit S",
          OrbitM: "Orbit M",
          OrbitL: "Orbit L",
          SoftPos: "SoftPOS",
        },
        ProductDescriptions: {
          OrbitS: "Žiadny fyzický terminál, 3 NFC kartičky",
          OrbitM: "Orbit M - Fyzický terminál bez tlačiarne (Android)",
          OrbitL: "Orbit L - Fyzický terminál s tlačiarňou (Android)",
          SoftPos:
            "SoftPOS - Platobná aplikácia v telefóne, bez fyzického terminálu",
        },
        ProductAccordion: {
          Active: "Aktívny",
          Activate: "Aktivovať produkt",
          Deactivate: "Deaktivovať",
          Preview: "Pripravujeme",
          Default: "Východzí",
          ProductNotActivated: "Tento produkt nebol aktivovaný",
          SoftPosViaChangeRequest:
            "Objednávka terminálov už je v Comgate. SoftPOS pridáte na karte Orbit L: pri prevádzke zadajte počet SoftPOS a odošlite žiadosť o zmenu počtu. Po potvrdení podporou sa SoftPOS aktivuje.",
          SoftPosContactSupport:
            "Objednávka terminálov už je v Comgate. Pre pridanie SoftPOS kontaktujte podporu.",
          FeeWithPricing: "Poplatok: {{totalFee}}% | {{productName}}",
          FeeWithCategoryAndPricing:
            "{{categoryName}} | Poplatok: {{totalFee}}% | {{productName}}",
          IndividualPricing: "Individuálny cenník",
        },
      },
    },
    ProfilePhoto: {
      ChangeAction: "Zmeniť fotku",
      RemoveAction: "Odstrániť fotku",
      CropDialogTitle: "Orežte fotku",
      ZoomLabel: "Priblíženie",
      CropSave: "Uložiť",
      CropCancel: "Zrušiť",
      FileTooLarge: "Súbor je príliš veľký (max. 2 MB)",
      InvalidFileType:
        "Nepodporovaný typ súboru. Použite PNG, JPEG alebo WebP.",
    },
    UserAccount: {
      ProfilePhoto: {
        Hint: "Podporované formáty: PNG, JPEG, WebP (max. 2 MB)",
        RemoveConfirm: "Naozaj odstrániť profilovú fotku?",
        UploadSuccess: "Profilová fotka bola uložená",
        UploadError: "Nahranie profilovej fotky zlyhalo",
        DeleteSuccess: "Profilová fotka bola odstránená",
        DeleteError: "Odstránenie profilovej fotky zlyhalo",
      },
      ChangePassword: {
        SectionTitle: "Heslo",
        OpenAction: "Zmeniť heslo",
        DialogTitle: "Zmena hesla",
        OldPasswordLabel: "Súčasné heslo",
        NewPasswordLabel: "Nové heslo",
        NewPasswordConfirmLabel: "Potvrdenie nového hesla",
        Submit: "Zmeniť heslo",
        Cancel: "Zrušiť",
        Success: "Heslo bolo zmenené. Prihláste sa prosím znova novým heslom.",
        NewMustDiffer: "Nové heslo sa musí líšiť od súčasného.",
        WrongOldPassword: "Súčasné heslo nie je správne.",
        GenericError: "Zmena hesla zlyhala. Skúste to prosím znova.",
        RateLimitError:
          "Príliš veľa pokusov. Počkajte chvíľu a skúste to znova.",
      },
    },
    Onboarding: {
      LogoutButtonLabel: "Opustiť registráciu",
      LicensePaymentReceived: "Platba prijatá",
      LicensePaymentProcessing: "Platbu spracovávame",
      SSO: {
        MerchantDescription:
          "Ako obchodník môžete prijímať platby od svojich zákazníků s nižšími poplatky a využívať bezkontaktné paypointy.",
        CustomerDescription:
          "Ako používateľ môžete posielať priame platby, platiť za svoje nákupy a zbierať Stardust body.",
        HunterDescription:
          "Ako hunter môžete získať Legione licenciu, spravovať svojich obchodníkov a získavať provízie z ich transakcií",
        Merchant: "Obchodník",
        Customer: "Používateľ",
        FirstLogin:
          "Keďže ide o Vaše prvé prihlásenie, potrebujeme zistiť, či sa k nám registrujete ako Používateľ, Obchodník alebo Hunter.",
      },
    },
    Shared: {
      Filters: {
        Title: "Filtre",
        TimePeriod: "Obdobie",
        TimePeriodLabels: {
          day: "Dnes",
          week: "Tento týždeň",
          month: "Tento mesiac",
          custom: "Vlastné",
        },
        Unlimited: "Neobmedzeno",
        DateFrom: "Od",
        DateTo: "Do",
        DateRange: "Rozsah dátumov",
        PayPoint: "PayPoint",
        AllPayPoints: "Všetky PayPointy",
        Employee: "Zamestnanec",
        AllEmployees: "Všetci zamestnanci",
        Status: "Stav",
        AllStatuses: "Všetky stavy",
        Apply: "Použiť",
        Reset: "Zrušiť filtre",
        RefundOrCancellation: "Refund alebo storno",
        ShowOnlyRefundsAndCancellations: "Iba refundácie a storná",
      },
      NotificationTypeSelect: {
        SelectNotificationType: "Vyberte typ notifikácie",
      },
      CodeListAutocomplete: {
        Placeholder: "Vybrať možnosti",
        SelectAll: "Vybrať všetky",
      },
      Carousel: {
        ScrollLeft: "predchádzajúci",
        ScrollRight: "ďalší",
      },
      Progress: {
        AriaLabel: "Postup",
      },
      Dropdown: {
        NoOptions: "Žiadne dostupné položky",
      },
      PoliticallyExposedDescription: `Politicky exponovaná osoba (PEP) je osoba, ktorá zastáva alebo v nedávnej minulosti zastávala významnú verejnú funkciu, ako napríklad prezident, premiér, minister, veľvyslanec, sudca najvyššieho súdu, vyšší armádny dôstojník alebo člen parlamentu. K politicky exponovaným osobám sa môžu radiť aj ich blízki rodinní príslušníci alebo blízki spolupracovníci.
      Zákonnú definíciu PEP nájdete v ust. § 4 ods. 5 zákona č. 253/2008 Zb., o niektorých opatreniach proti legalizácii výnosov z trestnej činnosti a financovaniu terorizmu.`,
      DownloadPartyIdentificationsButtonLabel: "Stiahnuť doklady",
      Payments: {
        Amount: "Suma",
        VariableSymbol: "Variabilný symbol",
        Note: "Poznámka",
      },
      SettlementPeriodSelector: {
        Placeholder: "Vyberte obdobie",
        NoSettlementPeriods:
          "V tejto chvíli nie je dostupná žiadna uzávierka na stiahnutie.",
      },
      BankingAccountSelector: {
        NoBankAccounts: "Nemáte pripojený žiadny bankový účet.",
        ConnectBankAccount: "Pripojenie účtu",
      },
      CardsList: {
        View: "Zobraziť",
        Edit: "Upraviť",
        Delete: "Zmazať",
        Download: "Stiahnuť",
      },
      HunterAutocomplete: {
        SearchHunter: "Vyberte ďalšieho Huntera",
        SearchHunterPlaceholder: "Zadajte meno alebo ID licencie",
        SearchHunterMinLength: "Zadajte aspoň 2 znaky pre vyhľadávanie",
        SearchHunterNoResults: "Žiadni huntri neboli nájdení",
      },
      MerchantUserAutocomplete: {
        Placeholder: "Názov alebo IČO",
        MinLength: "Zadajte aspoň 2 znaky pre vyhľadávanie",
        NoResults: "Žiadni obchodníci neboli nájdení",
      },
      AddressAutocomplete: {
        MinLength: "Zadajte aspoň 3 znaky pre vyhľadávanie",
        NoResults: "Žiadna adresa sa nenašla",
        Error:
          "Vyhľadávanie adries je momentálne nedostupné, zadajte adresu ručne",
      },
      AddressInput: {
        SearchLabel: "Adresa z evidencie",
        EnterManually: "Zadať adresu ručne",
        SearchInRegistry: "Vyhľadať adresu v evidencii",
        NotInRegistry:
          "Túto adresu sa nepodarilo nájsť v evidencii adries, skontrolujte ju prosím.",
        HasErrors: "Adresa nie je úplná alebo obsahuje chyby, skontrolujte ju.",
        UncommittedQuery:
          "Pre úpravu vyberte adresu z ponuky – samotné prepísanie textu adresu nezmení.",
      },
      HunterList: {
        MainHunterCard: {
          YourCommission: "Vaša provízia",
        },
      },
    },
    Transactions: {
      Tabs: {
        Transfers: "Prevody",
        Cards: "Karty",
        AriaLabel: "Typ transakcie",
      },
      Title: "Transakcie",
      LoadMore: "Načítať ďalšie",
      Export: "Exportovať transakcie",
      NoTransactions: "Zatiaľ nebola vykonaná žiadna transakcia.",
      PendingRefunds: "Inverzné platby ke schváleniu",
      MerchantDetailTransactionFees: {
        Title: "Náklady na transakcie tento mesiac",
      },
      TransactionPaymentOptions: {
        DirectPaymentButton: "Priama platba",
        ShowPaymentDataButton: "Zobraziť platobné údaje",
      },
      Filters: {
        Direction: "Smer",
        AllDirections: "Všetky smery",
      },
      Summary: {
        Revenue: {
          day: "Denná tržba",
          week: "Týždenná tržba",
          month: "Mesačná tržba",
          custom: "Tržba za obdobie",
        },
        UnlimitedRevenue: "Celková tržba",
        FilteredRevenue: "Tržba podľa filtrov",
        FilterSuffix: "podľa filtrov",
      },
      Search: {
        Placeholder: "Hľadať podľa ID...",
      },
      ExportActions: {
        Download: "Stiahnuť",
        Email: "Odoslať na e-mail",
      },
      ExportDrawer: {
        ExportSelectionPdf: "Export podľa filtrov (.pdf)",
        ExportSelectionXlsx: "Export podľa filtrov (.xlsx)",
        ExportSelectionCsv: "Export podľa filtrov (.csv)",
        ExportTodayRevenueCsv: "Export dnešnej tržby (.csv)",
        SendToEmail: "Odoslať na e-mail (PDF + XLSX)",
        EmailAddress: "E-mailová adresa",
        EnterEmailAddress: "Zadajte e-mailovú adresu",
        Send: "Odoslať",
        Cancel: "Zrušiť",
        EmailSentSuccess: "Export bol odoslaný na váš e-mail",
        EmailSentError: "Nepodarilo sa odoslať export na e-mail",
      },
      Direction: {
        Incoming: "Prichádzajúce",
        Outgoing: "Odchádzajúce",
        IncomingRefund: "Prichádzajúce vrátenie",
        OutgoingRefund: "Odchádzajúce vrátenie",
      },
    },
    CardTransactions: {
      Title: "Kartové transakcie",
      LoadMore: "Načítať ďalšie",
      NoCardTransactions: "Zatiaľ žiadne kartové transakcie",
      Columns: {
        DateTime: "Dátum a čas",
        Terminal: "Terminál",
        Operator: "Obsluha",
        Amount: "Suma",
        Status: "Stav",
        CardBrand: "Karta",
        Pan: "Číslo karty",
        Refund: "Refundácia/storno",
      },
      Status: {
        Approved: "Schválené",
        Rejected: "Zamietnuté",
        Canceled: "Zrušené",
        Pending: "Prebieha",
        Unknown: "Neznámy",
      },
      Direction: {
        Sale: "Platba",
        Refund: "Refundácia",
        Cancellation: "Storno",
        Adjustment: "Korekcia",
      },
      Summary: {
        NetAmount: "Čistý obrat",
        Sales: "Tržby",
        SalesCount: "Počet platieb: {{count}}",
        Refunds: "Refundácie",
        RefundsCount: "Počet refundácií: {{count}}",
      },
      Export: {
        Download: "Stiahnuť",
        Email: "Odoslať na e-mail",
        ExportPdf: "Export podľa filtrov (.pdf)",
        ExportXlsx: "Export podľa filtrov (.xlsx)",
        ExportCsv: "Export podľa filtrov (.csv)",
        SendToEmail: "Odoslať na e-mail (PDF + XLSX)",
        EmailAddress: "E-mailová adresa",
        EnterEmailAddress: "Zadajte e-mailovú adresu",
        Send: "Odoslať",
        Cancel: "Zrušiť",
        EmailSentSuccess: "Export bol odoslaný na váš e-mail",
        EmailSentError: "Nepodarilo sa odoslať export na e-mail",
        DownloadError: "Nepodarilo sa stiahnuť export",
      },
    },
    Sell: {
      OfferValid: "Ponuka platí ešte {{seconds}}s",
    },
    Affiliate: {
      LeadStatus: {
        AnonymousPaymentPerformed: "Prvá platba",
        Invited: "Pozvaných",
        Registered: "Registrovaných",
        Completed: "Dokončených",
        CompletedRewardSent: "Dokončených",
        CompletedRewardApplied: "Dokončených",
        Withdrawn: "Odstúpených",
      },
      ThanksToYou: {
        Participation: {
          Title: "Účasť v programe Vďaka Tebe!",
          OptedInStatus:
            "Zúčastňujete sa programu Vďaka Tebe! a získavate odmeny za odporúčania.",
          OptOutButton: "Odhlásiť sa z programu",
          OptOutDialogTitle: "Odhlásiť sa z programu Vďaka Tebe!",
          OptOutDialogIrreversible:
            "Odhlásenie je nezvratné. Do programu sa už nebudete môcť vrátiť.",
          OptOutDialogLoseTitle: "Prídete o",
          OptOutDialogLoseReferrals:
            "Všetky doterajšie odporúčania a odmeny z nich",
          OptOutDialogLoseInviter: "Väzbu na toho, kto vás pozval",
          OptOutDialogKeepTitle: "Zostane vám",
          OptOutDialogKeepRewards: "Odmeny, ktoré vám už vznikli",
          OptOutDialogKeepAccount: "Účet a všetky ostatné funkcie {{appName}}",
          OptOutDialogEmailNote:
            "Pošleme vám e-mail na {{email}}, odhlásenie dokončíte kliknutím na odkaz v ňom.",
          OptOutDialogConfirm: "Poslať potvrdzovací e-mail",
          EmailSent:
            "Poslali sme potvrdzovací e-mail na {{email}}. Odhlásenie dokončíte kliknutím na odkaz v e-maile, platí do {{expiresAt}}. Kým na odkaz nekliknete, zostávate v programe.",
          ResendButton: "Poslať e-mail znova",
          EmailSentToast: "Potvrdzovací e-mail je na ceste.",
          EmailSendError:
            "Potvrdzovací e-mail sa nepodarilo odoslať. Skúste to prosím o chvíľu znova.",
          EmailCooldownError:
            "Potvrdzovací e-mail sme vám poslali pred chvíľou. Skúste to znova o minútu.",
        },
        Join: {
          Title: "Programu Vďaka Tebe! sa nezúčastňujete",
          Text: "Pri registrácii ste účasť v programe odmietli. Po prihlásení môžete pozývať priateľov a získavať odmeny z ich platieb. Skoršie pozvánky a odporúčania sa neobnovia.",
          Button: "Prihlásiť sa do programu",
          JoinedToast: "Prihlásili ste sa do programu Vďaka Tebe!",
        },
        Withdrawn: {
          Title: "Program Vďaka Tebe!",
          Text: "Z programu Vďaka Tebe! ste natrvalo odstúpili. Odmeny, ktoré vám už vznikli, vám zostávajú. Znova sa do programu prihlásiť nie je možné.",
          PayoutBalance: "Zostáva na výplatu: {{amount}}",
        },
        WithdrawalPage: {
          Title: "Odhlásenie z programu Vďaka Tebe!",
          Prompt:
            "Kliknutím potvrdíte trvalé odhlásenie z programu Vďaka Tebe!. Prídete o všetky odporúčania aj väzbu na toho, kto vás pozval; odmeny, ktoré vám už vznikli, vám zostávajú.",
          ConfirmButton: "Potvrdiť odhlásenie",
          Success: {
            Title: "Odhlásenie dokončené",
            Text: "Z programu Vďaka Tebe! ste sa natrvalo odhlásili. Odmeny, ktoré vám už vznikli, vám zostávajú.",
          },
          AlreadyWithdrawn: {
            Title: "Už ste odhlásení",
            Text: "Odhlásenie z programu Vďaka Tebe! už prebehlo. Nemusíte nič ďalšie robiť.",
          },
          Expired: {
            Title: "Odkaz už neplatí",
            Text: "Platnosť odkazu vypršala, alebo sme vám medzitým poslali novší. Ak sa chcete odhlásiť, vyžiadajte si v sekcii Vďaka Tebe! nový e-mail.",
          },
          Error: {
            Title: "Odhlásenie sa nepodarilo",
            Text: "Odhlásenie sa nepodarilo dokončiť. Skúste odkaz otvoriť znova, alebo si v sekcii Vďaka Tebe! vyžiadajte nový e-mail.",
          },
          ContinueButton: "Pokračovať do aplikácie",
          OpenSectionButton: "Otvoriť sekciu Vďaka Tebe!",
        },
      },
      AffiliateStats: {
        Invited: "Pozvaní používatelia",
        Registered: "Registrovaní používatelia",
        WithActiveLicense: "S aktivnou licencí",
        AnonymousPayment: "Prvá platba s {{appName}}",
      },
      AffiliateLink: {
        Title: "Váš affiliate odkaz",
        LoadingError: "Váš affiliate kód sa nepodarilo získať.",
        CopyLink: "Kopírovať odkaz",
        LinkCopied: "Skopírované!",
        ShareButton: {
          Title: "{{appName}}",
          Text: "Pozvánka do {{appName}}",
        },
      },
      AffiliateLinkWithActions: {
        InviteFriend: "Pozvať priateľa",
        ShareButton: "Zdieľať",
        EmailButton: "Poslať na e-mail",
        QrButton: "Zobraziť QR",
        QrCodeFileName: "Affiliate QR kód",
        QrInstructions:
          "Zobrazte tento QR kód priateľovi, ktorého chcete pozvať do {{appName}}",
        LinkTypeToggle: {
          Title: "Vyberte cieľ odkazu",
          Registration: "Priama registrácia",
          MooneInfo: "Cez {{appName}} web",
        },
      },
      CodeField: {
        SectionTitle: "Odporúčanie",
        Label: "Affiliate kód",
        Placeholder: "Vyplňte, ak vás niekto odporučil",
        Verified: "Kód je platný.",
        RecommendedBy: "Odporučil(a) vás: {{name}}",
        Locked: "Affiliate je už aktívny a nedá sa zmeniť.",
        LockedBy:
          "Affiliate je už aktívny a nedá sa zmeniť. Odporučil(a) vás: {{name}}",
        ApplyFailed:
          "Affiliate kód sa nepodarilo uložiť, registrácia pokračuje bez neho.",
        Error: {
          AffiliateCodeNotFound: "Tento kód neexistuje.",
          AffiliateCodeOwn: "Vlastný kód nie je možné použiť.",
          AffiliateCodeNotApplicable:
            "Tento kód nie je možné použiť pre túto registráciu.",
          AffiliateReferrerAlreadySet: "Affiliate je už aktívny.",
          AffiliateReferrerTooLate: "Affiliate kód už nie je možné pridať.",
          TooManyRequests: "Príliš veľa pokusov, skúste to prosím o chvíľu.",
          Unavailable: "Kód sa nepodarilo overiť, skúste to prosím znova.",
          Unverified: "Kód overte alebo ho vymažte.",
        },
      },
      LeadInvitation: {
        NewInvitation: "Nová pozvánka",
        FriendInvited: "Ďakujeme. Váš priateľ bol úspešne pozvaný.",
        UserAlreadyExists:
          "Používateľ s týmto e-mailom už {{appName}} používa.",
        InvitationAlreadySent: "Pozvánka už bola na tento email odoslaná.",
        GeneralError: "Pri odosielaní pozvánky sa vyskytla chyba.",
        SendInvitation: {
          Hunter: "Odoslať pozvánku huntera",
          Customer: "Odoslať pozvánku",
          Merchant: "Odoslať pozvánku obchodníka",
        },
      },
      UserAffiliate: {
        MooneLiteWarning:
          "Pre vyplácanie odmen z programu Vďaka Tebe! je nutné dokončiť registráciu a počkať na overenie Vášho účtu.",
        Title: "Vďaka Tebe!",
        Subtitle: "Platby, ktoré Ti zarábajú.",
        TermsLinkUrl:
          "https://legi.one/assets/cesta/Affiliate_Hunters_Rulers_11-2024.pdf",
        Description:
          "Zdieľaj svoj kód, priveď priateľov a získaj percentá z ich platieb u obchodníkov. Čím viac ľudí pozveš, tým vyššie budú tvoje odmeny. Zarábaj z platieb dlhodobo ako banky a kartové spoločnosti.",
        HowItWorksTitle: "Ako to funguje:",
        HowItWorks:
          "• Over svoj účet v {{appName}}.<newline/>• Zdieľaj svoj affiliate kód s priateľmi.<newline/>• Získavaj odmeny - zakaždým, keď Tvoje odporúčanie zaplatí u obchodníkov, získavaš podiel z ich útraty.",
        Rewards:
          "💡 Odmeny sa pripisujú automaticky, Ty len sleduješ, ako rastie Tvoj pasívny príjem.",
        TermsLinkPretext: "📄 Viac informácií nájdeš v Podmienkach programu",
        TermsLink: "„Vďaka Tebe!“",
        YourAffiliateLink: "Váš affiliate odkaz",
        Tabs: {
          Customer: "Používatelia",
          Campaigns: "Kampane",
        },
      },
      HunterAffiliate: {
        Title: "Staň sa legendou & zarábaj dlhodobo! 🚀",
        TermsLinkUrl:
          "https://legi.one/assets/cesta/Affiliate_Hunters_Rulers_11-2024.pdf",
        Description:
          "Pozvi svojich známych do Legi.one a získaj 10% províziu za každého nového huntera! Ale tým to nekončí - pokiaľ budú úspešní, získaš dlhodobé provízie z ich jedného obchodu a o druhý sa s tebou podelí o 50 %. Tebe sa zároveň navýši provízia z časti Tvojich obchodov.",
        InviteNow:
          "Zdieľaj svoj affiliate kód teraz a aktívne si buduj pasívny príjem!",
        TermsLinkPretext: "Potrebuješ viac informácií? Pozri sa na kompletné",
        YourAffiliateLink: "Váš affiliate odkaz",
        TermsLink: "Podmienky affiliate programu",
        Tabs: {
          Hunter: "Hunter",
          Customer: "Používateľ",
          Merchant: "Obchodník",
          Campaigns: "Kampane",
        },
        MerchantLicenseSelector: {
          Label: "Predvolená licencia pre obchodníka",
        },
        InviteExistingUser: {
          Title: "Pozývaš existujúceho používateľa Mo.one?",
          Description:
            "Ak chceš pozvať niekoho, kto už účet Mo.one má, použi registráciu nového obchodníka. Keď na konci zadáš jeho e-mail, formulár rozpozná existujúci účet a pošle pozvánku rovno do schránky v aplikácii — namiesto toho, aby ho znova hnal celou registráciou.",
          ButtonLabel: "Pozvať existujúceho používateľa ako obchodníka",
        },
      },
      MerchantAffiliate: {
        Title: "Pozvi obchodníkov & získať odmeny! 🚀",
        TermsLinkUrl:
          "https://legi.one/assets/cesta/Affiliate_Hunters_Rulers_11-2024.pdf",
        Description:
          "Pozvi svojich priateľov do {{appName}} a získať odmeny za každého nového používateľa! Zdieľaj výhody našej platformy a buduj svoju sieť pri zarábaní.",
        InviteNow:
          "Zdieľaj svoj affiliate kód teraz a aktívne si buduj pasívny príjem!",
        YourAffiliateLink: "Váš affiliate odkaz",
        TermsLinkPretext: "Potrebuješ viac informácií? Podívať sa na kompletné",
        TermsLink: "Podmienky affiliate programu obchodníkov",
        Tabs: {
          Customer: "Používatelia",
          Campaigns: "Kampane",
        },
      },
      Earnings: {
        Title: "Vaše zárobky",
        TotalRegisteredUsers: "Registrovaní používatelia",
        TierBreakdown: "T1: {{t1}}, T2: {{t2}}, T3: {{t3}}",
        CurrentPayout: "Na výplatu",
        TotalEarned: "Celkom zarobené",
        RegisteredUsersHint:
          "Celkový počet používateľov, ktorí sa registrovali do {{appName}} cez váš affiliate odkaz.<newline/><newline/><bold>Rozloženie podľa úrovní:</bold><newline/>T1 (0,03%): {{t1}} používateľov<newline/>T2 (0,02%): {{t2}} používateľov<newline/>T3 (0,01%): {{t3}} používateľov",
        PayoutHint:
          "Suma, ktorá je aktuálne k dispozícii na výplatu z vašich affiliate odmien.",
        TotalEarnedHint:
          "Celková suma všetkých affiliate odmien, ktoré ste získali z transakcií pozvaných používateľov.",
        CombinedPayoutHint:
          "Súčet odmien na výplatu zo Stardust programu a affiliate programu Díky Tobě.",
        CombinedTotalEarnedHint:
          "Súčet všetkých odmien zo Stardust programu a affiliate programu Díky Tobě.",
        CombinedValorPayoutHint:
          "Súčet odmien na výplatu z Valor programu a affiliate programu Díky Tobě.",
        CombinedValorTotalEarnedHint:
          "Súčet všetkých odmien z Valor programu a affiliate programu Díky Tobě.",
      },
      Campaigns: {
        SelectCampaign: "Vyberte kampaň",
        SelectCampaignPlaceholder: "Vyberte kampaň z ponuky",
        SelectCampaignDescription:
          "Vyberte kampaň pre zobrazenie detailov a affiliate odkazu.",
        Validity: "Platnosť:",
      },
      AnonymousPayer: "Platba anonymného zákazníka",
    },
    Coinback: {
      Commission: "až {{commission}}",
    },
    Settlements: {
      SettlementStatus: {
        Paid: "Zaplatené",
        Unpaid: "Čaká na zaplatenie",
        Overdue: "Po splatnosti",
      },
      TotalEarnings: "Celkový zárobok za transakcie",
      CardEarnings: "Provízie z kartových transakcií za obdobie",
      TransactionCosts: "Náklady na transakcie",
      SettlementCount: "Vyúčtovanie {{count}} z {{total}}",
      NoSettlementsFound: "Žiadne vyúčtovania neboli nájdené.",
      LoadingError: "Pri načítaní vyúčtovania sa vyskytla chyba.",
      SettlementControls: {
        Filter: {
          Title: "Filter",
          All: "Všetky ({{total}})",
          Paid: "Zaplatené ({{paid}})",
          Unpaid: "Nezaplatené ({{unpaid}})",
          Overdue: "Po splatnosti ({{overdue}})",
        },
        Sort: {
          Title: "Zoradiť podľa",
          DateDesc: "Dátum (najnovšie)",
          DateAsc: "Dátum (najstaršie)",
          AmountDesc: "Suma (najvyššia)",
          AmountAsc: "Suma (najnižšia)",
        },
      },
      SettlementList: {
        UpdateStatusSuccess: "Vyúčtovanie bolo označené ako zaplatené",
        UpdateStatusError:
          "Pri označení vyúčtovania ako zaplatené sa vyskytla chyba",
        DownloadReportError: "Pri sťahovaní vyúčtovania sa vyskytla chyba",
        DownloadReportFilePrefix: "vyuctovanie_poplatkov_",
        SettlementPeriod: "Obdobie",
        SettlementDate: "Dátum vyúčtovania",
        DueDate: "Dátum splatnosti",
        Amount: "Suma",
        Status: "Stav",
        Actions: "Akcie",
        DownloadReport: "Stiahnuť vyúčtovanie",
        MarkAsPaid: "Označiť ako zaplatené",
        Pay: "Zaplatiť",
        SettlementStatusTooltip:
          "Stav zaplatenia vyúčtovania kontrolujeme každé 2 hodiny medzi 8:00 a 22:00.",
        SettlementTypeHunterCommissionFunding: "Financovanie hunter provízií",
        SettlementTypeDefault: "Vyúčtovanie",
        DownloadInvoice: "Stiahnuť faktúru",
        DownloadInvoiceError: "Chyba pri sťahovaní faktúry",
        InvoiceFilePrefix: "faktura_",
        RegenerateInvoice: "Pregenerovať faktúru",
        RegenerateInvoiceSuccess: "Faktúra bola pregenerovaná",
        RegenerateInvoiceError: "Pri pregenerovaní faktúry sa vyskytla chyba",
      },
      SettlementDownloadButton: {
        Title: "Vyúčtovanie",
        Downloading: "Sťahovanie...",
        Download: "Stiahnuť",
        RegionPlaceholder: "Vyberte trh",
        Regions: {
          CZ: "Česko (CZK)",
          SK: "Slovensko (EUR)",
        },
      },
    },
  },
  Coinback: {
    NoEshopsFound: "Žiadne eshopy neboli nájdené",
    Eshops: "Eshopy",
  },
  FormLabels: {
    AccountType: "Typ účtu pre prevod",
    TransferAccountType: "Typ účtu pre prevod",
    RecipientIBAN: "IBAN príjemcu",
    Amount: "Suma",
  },
  AML: {
    BasicInfo: "Základné informácie",
    CompanyName: "Názov subjektu",
    FirstName: "Meno",
    LastName: "Priezvisko",
    CompanyNumber: "IČO",
    TaxNumber: "DIČ",
    PersonalNumber: "Rodné číslo",
    BirthDate: "Dátum narodenia",
    BirthPlace: "Miesto narodenia",
    Nationality: "Národnosť",
    Gender: "Pohlavie",
    Phone: "Telefón",
    Email: "E-mail",
    Unknown: "Neznáme",
    Documents: "Doklady",
    DocumentNumber: "Číslo dokladu",
    DocumentIssuer: "Doklad vydal",
    DocumentValidity: "Platnosť dokladu",
    DocumentType: "Typ dokladu",
    NoDocuments: "Pre túto osobu neevidujeme žiadne nahrané doklady.",
    IdentificationImageType: {
      FirstIDCardFrontSide: "Predná strana preukazu totožnosti",
      FirstIDCardBackSide: "Zadná strana preukazu totožnosti",
      SecondIDCardFrontSide: "Predná strana druhého preukazu totožnosti",
      SecondIDCardBackSide: "Zadná strana druhého preukazu totožnosti",
    },
    PdfUploaded: "Používateľ nahral PDF súbor.",
    OpenPdf: "Otvoriť PDF",
    ActingPerson: "Konajúca osoba",
    BeneficialOwners: "Skutoční vlastníci",
    UboUnknownAlert: "Obchodník označil skutočných vlastníkov ako neznámych",
    Loading: "Načítavanie...",
  },
  PersonalInfo: {
    ConfirmDataRequest: "Boli údaje vyššie prečítané správne?",
    FillMissingData: "Doplňte chýbajúce, alebo opravte nesprávne údaje",
    DataConfirmationMessage:
      "Prosíme potvrďte aj správnosť údajov o preukaze totožnosti.",
  },
  TableHeaders: {
    Verification: "Overenie",
    Login: "Login",
    Role: "Rola",
    Status: "Stav",
    FirstName: "Meno",
    LastName: "Priezvisko",
    Company: "Spoločnosť",
    ClientIdentifier: "ID",
    DateCreated: "Dátum vytvorenia",
    PaymentReference: "Var. s. platby licencie",
    Version: "Verzia {{appName}}",
    Settlement: "Vyúčtovanie",
    Admin: "Admin",
  },
  Nfc: {
    NfcCard: "NFC karta",
    InvalidNfcCardNoFormat: "Formát identifikátoru nie je správny!",
    NfcCardNo: "Identifikátor NFC karty:",
    CopyNfcCardNo: "Kopírovať identifikátor karty",
    CopyNfcCardNoSuccess: "Identifikátor karty bol skopírovaný",
    CardNotAssigned: "Karta nie je pripojená k žiadnemu paypointu",
    AssignToPaypoint: "Pripojiť k paypointu",
    SelectPaypoint: "Vyberte paypoint, ktorému chcete kartu pripojiť",
    CardOverwriteConfirmation:
      "Paypoint {{name}} už má pripojenú inú NFC kartu. Chcete ju nahradiť touto?",
    CardAssignedSuccessfully: "NFC karta bola úspešne pripojená",
    CardAssignmentFailed: "Chyba - NFC karta sa nepodarilo pripojiť",
    CardAssignmentFailedFormatError:
      "Chyba - Identifikátor NFC karty je v nesprávnom formáte",
    Redirecting: "Prebieha automatické presmerovanie.",
    RedirectFallbackHint:
      "Ak nebudete presmerovaní do 10 sekúnd, kliknite na tlačidlo nižšie.",
    RedirectManually: "Presmerovať ručne",
    RedirectNotConfigured:
      "Tento NFC štítok zatiaľ nemá nastavenú adresu. Obráťte sa, prosím, na obsluhu.",
    SelectMerchant: "Vyberte obchodníka, ktorému chcete kartu pripojiť",
  },
  ExternalIntegrations: {
    Title: "Externé integrácie",
    Description:
      "Prijímajte platby cez {{appName}} vo svojom e-shope. Stiahnite si plugin pre svoju platformu a postupujte podľa priloženej dokumentácie.",
    DownloadPlugin: "Stiahnuť ZIP",
    DownloadDocumentation: "Stiahnuť dokumentáciu (PDF)",
    WooCommerce: {
      Name: "WooCommerce",
      Description: "Platobný plugin pre WordPress / WooCommerce.",
      PluginUrl: "/content/integrations/moone-payments-for-woocommerce.zip",
      DocumentationUrl:
        "/content/integrations/Mo.one-Payments-WooCommerce-SK.pdf",
    },
    PrestaShop: {
      Name: "PrestaShop",
      Description: "Platobný modul pre PrestaShop.",
      PluginUrl: "/content/integrations/moonepayments-for-prestashop.zip",
      DocumentationUrl:
        "/content/integrations/Mo.one-Payments-PrestaShop-SK.pdf",
    },
    PaymentGateway: {
      Name: "Platobná brána",
      Description:
        "Používateľský návod k platobnej bráne: založenie brány, prístupové údaje a vrátenie platieb.",
      DocumentationUrl: "/content/integrations/Mo.one-Payment-Gateway-CS.pdf",
    },
  },
  Paypoint: {
    Paypoint: "Paypoint",
    NoPaypoint: "Žiadny paypoint",
    UnnamedPaypoint: "Nepomenovaný paypoint",
    NoPaypointPlaceholder: "Žiadny paypoint",
    AddPaypointButton: "Pridať nový paypoint",
    DownloadQRCode: "Stiahnuť QR",
    Individual: "Individuálny",
    SeeOptions: "Zobraziť možnosti",
    IndividualUnderConstruction: "Individuálne paypointy pripravujeme...",
    NewPaypoint: "Nový PayPoint",
    UpdatePaypoint: "Upraviť PayPoint",
    IdlePaypointInfo: "Na tomto Paypointe nie je žiadna aktívna transakcia.",
    BackToDashboard: "Späť na dashboard",
    LoadingError: "Chyba pri načítaní Paypointu",
    UnknownOwner: "Neznámy vlastník",
    Form: {
      Name: "Názov",
      Description: "Popis",
      Legend: {
        GeneralInfo: "Základné informácie",
        NFC: "NFC Karta",
        PaypointSettings: "Nastavenie Paypointu",
        Device: "Platobné zariadenie",
        PaypointType: "Nastavenie paypointu",
      },
      PaymentTypeLabel: "Spôsob platby",
      PaymentType: {
        Standard: {
          label: "Štandardná platba",
          tooltip: "Platbu vytvoríte zakaždým vy na pokladni.",
        },
        FixedPrice: {
          label: "Platba s fixnou sumou",
          tooltip:
            "Suma platby je vopred nastavená a zákazník ju nemôže zmeniť.",
        },
        EditablePrice: {
          label: "Platba s voliteľnou sumou",
          tooltip: "Zákazník si môže vybrať z ponuky súm alebo zadať vlastnú.",
        },
        NfcLink: {
          label: "NFC odkaz",
          tooltip:
            "Po priložení telefónu k NFC štítku sa namiesto platby otvorí zadaná adresa.",
        },
        NfcTableService: {
          label: "NFC obsluha pri stole",
          tooltip:
            "Po priložení telefónu sa otvorí stránka stola. Adresu nastavuje Mo.one Hub, tu ju nie je možné upraviť.",
        },
      },
      FixedAmountLabel: "Fixná suma",
      CurrencyLabel: "Mena",
      FixedAmountRequired: "Zadajte fixnú sumu väčšiu ako nula",
      CurrencyRequired: "Vyberte menu platobného miesta",
      TipsLabel: "Spropitné",
      TipsCheckbox: "Ponúknuť zákazníkovi spropitné",
      GatewaySettingsHint:
        "Pri e-commerce bráne riadi sumu aj spropitné e-shop pri každej platbe, preto tu tieto nastavenia nie sú dostupné.",
      RedirectUrlLabel: "Adresa (URL)",
      RedirectUrlInvalid: "Zadajte platnú adresu začínajúcu https://",
      TableServiceUrlMissing:
        "Mo.one Hub zatiaľ adresu stola nenastavil. Kým ju nenastaví, telefón po priložení nikam nepresmeruje.",
      AssignNfcCardNoConflict:
        "Táto NFC karta je už pripojená k inému paypointu",
      NfcCardNo: "Identifikátor NFC karty",
      NfcCardNoHelperText:
        "Identifikátor NFC karty je 14-miestny alfanumerický kód, ktorý je vytlačený na {{appName}} NFC karte. Ak kartu ešte nemáte pri sebe, môžete využívať paypoint virtuálne cez QR kód a pripojiť kartu neskôr.",
      Create: "Vytvoriť",
      NfcCardNoFormatError:
        "Identifikátor NFC karty musí byť v tvare XX-XX-XX-XX-XX-XX-XX",
      NameMaxLengthError: "Názov nesmie presiahnuť {{max}} znakov",
      BankAccountNotAccessible:
        "Nastavenie bankového účtu pre Vás nie je dostupné.",
      EmployeesNotAccessible:
        "Nastavenie prístupu zamestnancov pre Vás nie je dostupné.",
      Employees: "Zamestnanci s prístupom",
      PaypointAccount: "Bankový účet",
      Facility: "Provozovna",
      Type: "Typ",
      TypeNFC: "NFC",
      TypeTerminal: "Terminál",
      TypeGateway: "Platobná brána",
      TypeGatewayShort: "Brána",
      Device: {
        NoActiveDevice: "Zatiaľ nie je pripojené žiadne zariadenie",
        LinkDevice: "Pripojiť zariadenie",
        LinkDeviceTitle: "Pripojiť nové zariadenie",
        ActiveDevice: "Pripojené zariadenie",
      },
      Activation: {
        Legend: "Aktivácia SoftPOS",
        Code: "Aktivačný kód",
        HelperText:
          "Kód zadajte v aplikácii SoftPOS na zariadení. Platí pre jedno zariadenie. Pri prechode na iné zariadenie deaktivujte aplikáciu na starom, alebo požiadajte podporu o uvoľnenie kódu.",
        Copy: "Kopírovať kód",
        Copied: "Skopírované",
      },
    },
  },
  MobileApp: {
    InstallBanner: {
      Title: "Stiahnite si aplikáciu {{appName}}",
      Description: "Rýchlejší prístup priamo z plochy vášho telefónu.",
      AppStoreBadgeAlt: "Stiahnuť v App Store",
      PlayStoreBadgeAlt: "Získať na Google Play",
    },
  },
  Language: {
    Czech: "Čeština",
    Settings: "Nastavenie jazyka",
    Language: "Jazyk",
  },
  Roles: {
    AddRole: {
      Banner: {
        Hunter: "Máte pozvánku stať sa hunterom — dokončite registráciu roly.",
        Merchant:
          "Máte pozvánku stať sa obchodníkom — dokončite registráciu roly.",
        SignUpIntent: {
          Hunter:
            "Dokončite registráciu huntera, ktorú ste zvolili pri založení účtu.",
          Merchant:
            "Dokončite registráciu obchodníka, ktorú ste zvolili pri založení účtu.",
        },
        Button: "Dokončiť",
      },
      Completion: {
        Submit: "Dokončiť registráciu roly",
        Success: "Rola je aktívna.",
        Error: "Rolu sa nepodarilo dokončiť.",
      },
      PickerTitle: "Vyberte rolu, ktorú chcete k svojmu účtu pridať.",
      MigrationRequired:
        "Pridanie roly je dostupné až po dokončení migrácie účtu.",
      KycRequired:
        "Najprv prosím dokončite registráciu svojho zákazníckeho účtu (overenie totožnosti). Rolu Hunter alebo Merchant je možné pridať až potom.",
      BankVerificationRequired:
        "Najprv prosím pripojte a overte svoj bankový účet. Rolu Hunter alebo Merchant je možné pridať až potom.",
      BackOfficeAccount:
        "Interný účet (Admin, AML, onboarding) má vždy len jednu rolu — ďalšiu rolu k nemu pridať nie je možné. Na súkromné používanie Mo.one si založte samostatný účet s inou e-mailovou adresou.",
      HunterCard: {
        Title: "Hunter",
        Description: "Registrujte obchodníkov a získavajte provízie.",
        AlreadyHeld: "Rolu huntera už máte.",
      },
      MerchantCard: {
        Title: "Obchodník",
        Description: "Prijímajte platby od zákazníkov vo svojom podniku.",
      },
      HunterForm: {
        Description:
          "Zadajte IČO živnosti alebo firmy, pod ktorou budete ako hunter pôsobiť.",
      },
      MerchantForm: {
        Description:
          "Vyberte trh a zadajte IČO firmy, za ktorú budete prijímať platby.",
      },
      BankStep: {
        Connected: "Banka je pripojená — môžete pokračovať.",
      },
      Form: {
        CompanyNumber: "IČO",
        Region: "Trh",
        Submit: "Pridať rolu",
        Success: "Rola bola pridaná, prepíname kontext…",
        Error: "Rolu sa nepodarilo pridať.",
      },
    },
  },
  Social: {
    Handle: {
      Label: "Prezývka",
      Placeholder: "napr. jan.novak",
      ValidationError:
        "Prezývka musí mať 3–30 znakov: malé písmená a–z, číslice, bodku alebo podčiarkovník, a aspoň jedno písmeno.",
      Reserved: "Túto prezývku nie je možné použiť",
      Available: "Prezývka je voľná",
      Taken: "Túto prezývku už niekto používa",
      SaveError: "Prezývku sa nepodarilo uložiť. Skúste to prosím znova.",
      StepTitle: "Zvoľte si verejnú prezývku",
      StepDescription:
        "Prezývka (@handle) je vaše verejné meno v {{appName}}. Ostatní vás podľa nej nájdu.",
      StepBenefitSearch:
        "Priatelia vás ľahko nájdu vo vyhľadávaní podľa <strong>{{handle}}</strong> a Váš profil bude dostupný na adrese <strong>app.mo.one/@{{bareHandle}}</strong>",
      StepBenefitSearchHandleFallback: "@prezývky",
      StepBenefitSearchUrlFallback: "prezývka",
      StepBenefitFollows:
        "Ostatní vás môžu sledovať a posielať vám žiadosti o sledovanie",
      StepBenefitChat: "Môžete si písať správy s priateľmi aj obchodníkmi",
      StepBenefitLeaderboard:
        "V rebríčkoch Stardust a Valor sa zobrazí namiesto vášho mena",
      StepMissingWarning:
        "Bez prezývky vás ostatní nenájdu a komunitné funkcie pre vás budú nedostupné. Doplniť si ju môžete aj kedykoľvek v profile.",
      ContinueWithoutHandle: "Doplním neskôr",
      ChangeNote:
        "Zmenou prezývky sa pôvodná uvoľní a zmení sa aj adresa vášho verejného profilu.",
      MissingBannerText:
        "Nemáte nastavenú prezývku (@handle) — ostatní vás zatiaľ nemôžu nájsť.",
      MissingBannerAction: "Nastaviť",
    },
    Terms: {
      CheckboxLabel:
        "Prijímam <terms>obchodné podmienky</terms>, <chatTerms>podmienky Chatu</chatTerms> a <communityRules>pravidlá komunity</communityRules>",
      Note: "Chat je zadarmo a poskytuje ho Mo.one Digital Services s.r.o. Vypovedať ho môžete kedykoľvek v Aplikácii, ako spotrebiteľ aj do 14 dní odstúpiť e-mailom. Ako pracujeme s vašimi údajmi, opisujú <privacy>Zásady ochrany osobných údajov</privacy>. <summary>Zhrnutie zmluvy</summary> a dokumenty si stiahnite a uložte, budú sa vám hodiť aj neskôr.",
      ShowSummary: "Zhrnutie a dokumenty",
      HideSummary: "Skryť zhrnutie",
      AcceptAndContinue: "Prijať a pokračovať",
      Required:
        "Musíte prijať obchodné podmienky, podmienky Chatu a pravidlá komunity",
      Documents: {
        ContractSummary: {
          Title: "Zhrnutie zmluvy",
          Url: {
            Customer: "/content/terms/Moone-chat-contract-summary-customer.pdf",
            Merchant: "/content/terms/Moone-chat-contract-summary-business.pdf",
            Hunter: "/content/terms/Moone-chat-contract-summary-business.pdf",
          },
        },
        Terms: {
          Title: "Všeobecné obchodné podmienky",
          Url: {
            Customer: "/content/terms/Moone-chat-business-terms-customer.pdf",
            Merchant: "/content/terms/Moone-chat-business-terms-business.pdf",
            Hunter: "/content/terms/Moone-chat-business-terms-business.pdf",
          },
        },
        ChatTerms: {
          Title: "Produktové podmienky Chatu",
          Url: {
            Customer: "/content/terms/Moone-chat-terms-customer.pdf",
            Merchant: "/content/terms/Moone-chat-terms-business.pdf",
            Hunter: "/content/terms/Moone-chat-terms-business.pdf",
          },
        },
        CommunityRules: {
          Title: "Pravidlá komunity",
          Url: {
            Customer: "/content/terms/Moone-chat-community-rules.pdf",
            Merchant: "/content/terms/Moone-chat-community-rules.pdf",
            Hunter: "/content/terms/Moone-chat-community-rules.pdf",
          },
        },
        ComplaintRules: {
          Title: "Reklamačný poriadok",
          Url: {
            Customer: "/content/terms/Moone-chat-complaint-rules-customer.pdf",
            Merchant: "/content/terms/Moone-chat-complaint-rules-business.pdf",
            Hunter: "/content/terms/Moone-chat-complaint-rules-business.pdf",
          },
        },
        TechnicalTerms: {
          Title: "Technické podmienky",
          Url: {
            Customer: "/content/terms/Moone-chat-technical-terms.pdf",
            Merchant: "/content/terms/Moone-chat-technical-terms.pdf",
            Hunter: "/content/terms/Moone-chat-technical-terms.pdf",
          },
        },
        PrivacyPolicy: {
          Title: "Zásady ochrany osobných údajov",
          Url: {
            Customer: "/content/terms/Moone-chat-privacy-policy.pdf",
            Merchant: "/content/terms/Moone-chat-privacy-policy.pdf",
            Hunter: "/content/terms/Moone-chat-privacy-policy.pdf",
          },
        },
        ListLabel: "Dokumenty",
      },
      Terminate: {
        Title: "Ukončiť Chat a komunitné funkcie",
        Description:
          "Ukončením zmluvy o Chate prídete o prezývku a všetky komunitné funkcie — chat, verejný profil, vyhľadávanie a sledovanie. Vaše správy a sledovania zostanú zachované a znovu sa zobrazia, ak si neskôr zvolíte novú prezývku.",
        Action: "Ukončiť Chat a komunitné funkcie",
        ConfirmTitle: "Naozaj chcete ukončiť Chat a komunitné funkcie?",
        ConfirmText:
          "Vaša prezývka bude uvoľnená a chat, verejný profil, vyhľadávanie aj sledovanie pre vás budú nedostupné. Výpoveď je účinná okamžite. Chat môžete kedykoľvek znovu aktivovať zvolením novej prezývky a prijatím podmienok.",
        Success: "Chat a komunitné funkcie boli ukončené.",
      },
      Summary: {
        Service: {
          Label: "Služba",
          Value:
            "Posielanie správ, skupiny a zdieľanie v aplikácii {{appName}}",
        },
        Provider: {
          Label: "Poskytovateľ",
          Value:
            "Mo.one Digital Services s.r.o., IČO 245 32 819, Palackého třída 3048/124, 612 00 Brno, info@mo.one, +420 226 633 296",
        },
        Price: { Label: "Cena", Value: "Zadarmo" },
        Duration: { Label: "Trvanie", Value: "Na dobu neurčitú" },
        Termination: {
          Label: "Výpoveď",
          Value:
            "Kedykoľvek a bez udania dôvodu v Aplikácii: Môj {{appName}} › Nastavenia › Ukončiť Chat a komunitné funkcie. Účinná je, hneď ako ju potvrdíte.",
        },
        Withdrawal: {
          Label: "Odstúpenie",
          Value:
            "Ako spotrebiteľ do 14 dní bez udania dôvodu, stačí e-mail na info@mo.one",
        },
        Payments: {
          Label: "Platby",
          Value: "Poskytuje ich Mo.one a.s. podľa vašej zmluvy s ňou",
        },
        Complaints: {
          Label: "Reklamácie",
          Value:
            "Podľa reklamačného poriadku, mimosúdne na Českej obchodnej inšpekcii",
        },
        Devices: {
          Label: "Zariadenia",
          Value: "iOS 15 a novší, Android 7 a novší",
        },
        Important: {
          Label: "Dôležité",
          Value:
            "Chat neslúži na tiesňové volania. Zmluvu uzatvárate v češtine, prezývku môžete pred potvrdením opraviť.",
        },
      },
    },
    PublicProfile: {
      PrivateAccount: "Súkromný účet",
      NotFound: "Táto prezývka neexistuje.",
      Follow: "Sledovať",
      Following: "Sledujete",
      FollowBack: "Sledovať späť",
      Requested: "Žiadosť odoslaná",
      Mutual: "Vzájomne",
      ApproveRequest: "Schváliť žiadosť",
      DeleteRequest: "Vymazať žiadosť",
      MutualConfirmTitle: "Sledovať sa navzájom s @{{handle}}?",
      MutualConfirmInbox:
        "Vaše správy si budete posielať rovno do schránky, prípadná žiadosť o správu medzi vami sa prijme a budete sa môcť navzájom pridávať do skupín.",
      MutualConfirmName: "@{{handle}} tiež uvidí vaše skutočné meno.",
      SendMessage: "Poslať správu",
      SendMessageError:
        "Konverzáciu sa nepodarilo otvoriť. Skúste to prosím znova.",
      SendMessagePhoneRequired:
        "Pre odosielanie správ si overte svoje telefónne číslo.",
      MoreActions: "Ďalšie akcie",
      Block: "Zablokovať",
      BlockConfirmTitle: "Zablokovať používateľa",
      BlockConfirmDescription:
        "Zablokovaním zrušíte vzájomné sledovanie aj žiadosti o sledovanie a nebudete sa môcť znova nájsť ani spojiť. Blokovanie môžete kedykoľvek zrušiť na stránke Ľudia.",
      Report: "Nahlásiť",
    },
    People: {
      SearchPlaceholder: "Hľadať",
      SearchAllUsersPlaceholder:
        "Hľadať medzi všetkými používateľmi podľa @prezývky alebo mena",
      SearchNoResults: "Nikto sa nenašiel.",
      RequestsTitle: "Žiadosti o sledovanie",
      OutgoingTitle: "Odoslané žiadosti",
      Approve: "Schváliť",
      Delete: "Vymazať",
      CancelRequest: "Zrušiť",
      MutualTitle: "Vzájomní sledovatelia",
      NoMutuals:
        "Zatiaľ nemáte žiadnych vzájomných sledovateľov — objavia sa tu ľudia, ktorých sledujete a ktorí sledujú aj vás.",
      FollowingTitle: "Sledovaný",
      NoFollowing: "Zatiaľ nikoho nesledujete.",
      FollowersTitle: "Sledujúci",
      Tabs: {
        Mutual: "Vzájomní",
        Following: "Sledovaný",
        Followers: "Sledujúci",
      },
      NoFollowers: "Zatiaľ vás nikto nesleduje.",
      Unfollow: "Odobrať",
      BlockedTitle: "Blokovaní používatelia",
      NoBlocked: "Nikoho ste nezablokovali.",
      Unblock: "Odblokovať",
      HandleGateTitle: "Najprv si nastavte prezývku",
      HandleGateText:
        "Aby ste mohli sledovať ostatných, potrebujete prezývku (@handle) — ostatní vás podľa nej nájdu.",
      HandleGateAction: "Nastaviť prezývku",
    },
    PublicPermissions: {
      IdentityLabel: "Identita",
      IdentityVerifiedTooltip: "Identita overená",
      IdentityVerificationPendingTooltip: "Overenie identity prebieha",
      PublicProfileLabel: "Verejný profil",
      PhoneVerifiedTooltip: "Telefónne číslo overené",
      PhoneVerificationPendingTooltip: "Overenie telefónneho čísla prebieha",
      PhoneUnverifiedTooltip: "Telefónne číslo nie je overené",
      VerifyAction: "Overiť",
      BioLabel: "Bio",
      BioTooLong: "Bio môže mať najviac 160 znakov",
      BioSaveError: "Bio sa nepodarilo uložiť. Skúste to prosím znova.",
      SectionDescription:
        "S verejným profilom ostatní uvidia vaše skutočné meno a budú vás podľa neho môcť nájsť.",
      GoPublicConfirmTitle: "Zverejniť profil?",
      GoPublicConfirmRequests:
        "Všetky čakajúce žiadosti o sledovanie ({{count}}) budú schválené.",
      GoPublicConfirmMutual:
        "{{count}} z nich už sledujete, takže sa budete sledovať navzájom: ich správy vám budú chodiť rovno do schránky a budú vás môcť priamo pridávať do skupín.",
      GoPublicConfirmAction: "Zverejniť",
      GoPublicSummaryUnavailable:
        "Čakajúce žiadosti o sledovanie sa nepodarilo načítať, profil zatiaľ nie je možné zverejniť.",
    },
    Stats: {
      Mutual: "Vzájomní",
      Followers: "Sledovatelia",
      Following: "Sledovanie",
    },
  },
  Pages: {
    Titles: {
      AddRole: "Pridať rolu",
      Valor: "Valor",
      ThanksToYou: "Vďaka Tebe!",
      IncomingTransaction: "Príchodzá platba",
      OutgoingTransaction: "Odchádzajúca platba",
      UnknownTransaction: "Platba",
      Licenses: "Licencie",
      NewPayment: "Nová platba",
      MerchantOverview: "Obchodník",
      Employees: "Zamestnanci",
      LanguageSettings: "Nastavenie jazyka",
      PayPoints: "Platobné zariadenia",
      BankAccountDetail: "Bankový účet",
      SetPassword: "Nastavenie hesla",
      AmlUsers: "Používatelia",
      NotificationsManagement: "Správa notifikácií",
      NewNotification: "Nová notifikácia",
      EditNotification: "Upraviť notifikáciu",
      Settings: "Viac",
      Stardust: "Stardust",
      People: "Ľudia",
      Followers: "Sledujúci",
      BlockedUsers: "Blokovaní používatelia",
      Profile: "Profil",
      Dashboard: "Prehľad",
      BankAccounts: "Bankové účty",
      BankAccountOrder: "Poradie účtov",
      FeeCalculator: "Kalkulačka poplatkov",
      Merchants: "Obchodníci",
      Settlement: "Vyúčtovanie",
      Users: "Používatelia",
      ToBeVerified: "Na overenie",
      TransactionDetail: "Transakcia",
      TransactionsHistory: "Transakcie",
      Welcome: "Vitajte",
      User: "Používateľ",
      Withdrawal: "Výber",
      Settlements: "Vyúčtovanie",
      MerchantOpenRegistrations: "Otvorené registrácie",
      LicenseOrder: "Objednávka licencie",
      Onboarding: "Informácie o Vás",
      CompleteSSORegistration: "Dokončenie registrácie",
      CompleteCustomerOnboarding: "Dokončenie registrácie",
      LeadInvitation: "Pozvať priateľa",
      MerchantInitiatePayment: "Výber účtu",
      MerchantAcceptPayment: "Prijať platbu",
      MerchantCompleteRegistration: "Registrácia",
      MerchantNewRegistration: "Nový obchodník",
      LegalDocuments: "Dokumenty",
      Redeem: "Darčeková karta",
      AnonymousDashboard: "Prehľad",
      BankingAuthQr: "Overenie bankového účtu",
      SystemReport: "Systémový report",
      SystemControl: "Nastavenie systému",
      BankingAuth: "Overenie bankového účtu",
      UserAccount: "Môj {{appName}}",
      Help: "Nápoveda",
      ColdWallet: "Systémová peňaženka",
      MerchantSettlements: "Vyúčtovanie",
      AnonymousTransactionDetail: "Transakcia bola úspešná",
      MerchantFeeCalculator: "Kalkulačka poplatkov",
      RedeemPublic: "Darčeková karta",
      ApplicationError: "Chyba aplikácie",
      GoogleCallback: "Presmerovanie",
      Campaigns: "Kampane",
      Coupons: "Kupóny",
      Terminals: "Terminály",
      Raffle: "Žrebovanie",
      SsoClients: "SSO aplikácie",
      SsoAuthorize: "Prihlásenie do aplikácie",
      ConnectedApps: "Pripojené aplikácie",
      AdminCampaignCreate: "Vytvoriť kampaň",
      AdminCampaignEdit: "Upraviť kampaň",
      Chat: "Chat",
      Devices: "Platobné zariadenia",
      PaymentGateways: "Platobné brány",
      AwaitingEmailVerification: "Overenie e-mailu",
      BankIDRedirect: "Presmerovanie",
      Error403: "Prístup zamietnutý",
      DeactivateUser: "Zmazať účet",
      CustomerAnonymousPaymentPay: "Prihlásenie",
      Contact: "Kontakt",
      Notifications: "Notifikácie",
      Invitations: "Pozvánky",
      WhereToPay: "Kde platiť",
      RolesPermissions: "Role a oprávnenia",
      AllMerchants: "Všetci obchodníci",
      UnassignedMerchants: "Obchodníci bez huntera",
      Hunters: "Hunteri",
      HunterPortal: "Hunter Portál",
      Transfer: "Previesť peniaze",
      BatchPayments: "Hromadné platby",
      BatchPaymentDetail: "Detail hromadnej platby",
    },
    Content: {
      WhereToPay: {
        Tabs: {
          Stores: "Obchody",
          EShops: "E-shopy",
          Campaigns: "Kampane",
        },
        StoresSection: {
          CategoryLabel: "Kategória",
          CategoryPlaceholder: "Kategória",
          CategoryAccessibility: "Filtrovať podľa kategórie",
          MunicipalityLabel: "Obec",
          MunicipalityPlaceholder: "Obec",
          MunicipalityAccessibility: "Filtrovať podľa obce",
          NoStoresFound:
            "Nenašli sa žiadne obchody zodpovedajúce vybraným filtrom.",
        },
        Campaigns: {
          Title: "KAMPANE MO.ONE",
          Description:
            "Vyskúšajte si platbu s Mo.one a pomôžete dobrej veci. Vyberte si jednu z partnerských nadácií a darujte cez Mo.one ľubovoľnú sumu pre potrebné.",
          ShareLinkText: "Zdieľaj odkaz s ostatnými a pomáhaj",
          CopyLink: "Kopírovať odkaz",
          LinkCopied: "Odkaz skopírovaný",
        },
        StoreDetail: {
          NotFound: "Obchod nenájdený",
          AboutUs: {
            Title: "O NÁS",
            Address: "Adresa",
            Phone: "Telefón",
            Email: "E-mail",
          },
          OpeningHours: {
            Title: "OTVÁRACIE HODINY",
          },
        },
      },
      Stardust: {
        PointsLabel: {
          Points: "{{count}} Stardust",
          Points_one: "{{count}} Stardust",
          Points_few: "{{count}} Stardusty",
          Points_other: "{{count}} Stardustov",
        },
        Participation: {
          Title: "Účasť v programe Stardust",
          OptedInStatus: "Ste prihlásený do programu Stardust a zbierate body.",
          OptOutButton: "Odhlásiť sa z programu",
          OptOutDialogTitle: "Odhlásiť sa zo Stardust?",
          OptOutDialogText:
            "Po odhlásení vám nebudú pripisované nové body Stardust, ani za platby, ani za odporúčanie priateľov. Body a odmeny, ktoré ste už získali, vám zostávajú. Znova sa môžete prihlásiť kedykoľvek.",
          OptOutDialogConfirm: "Odhlásiť sa",
          OptedOutToast:
            "Odhlásili ste sa z programu Stardust. Body a odmeny, ktoré ste získali, vám zostávajú.",
        },
        Consent: {
          Title: "Vernostný program Stardust",
          Description:
            "Za platby a aktivitu v aplikácii zbierate body Stardust a na konci mesiaca získate podiel z balíka odmien. Účasť je dobrovoľná a kedykoľvek ju môžete zmeniť v sekcii Stardust.",
          TermsLink: "Podmienky programu Stardust",
          Confirm: "Súhlasím so zaradením do programu",
        },
        PilotDisclaimer:
          "Vernostný program Stardust je od 1.12.2025 v pilotnom režime. Budeme radi pokiaľ si Stardust vyskúšate a dáte nám spätnú väzbu pomocou tlačidla Nahlásiť chybu alebo na email info@mo.one.",
        Overview: {
          Points: {
            title: "Stardust",
            explanationHint: "Stardust",
          },
          Payout: {
            title: "Výplaty",
            explanationHint:
              'Na konci každého mesiaca sa uzatvára obdobie vernostného programu Stardust a získané peniaze sa vám pripíšu do "K výplate".<newline/><newline/> Po dosiahnutí minimálnej sumy k výplate si môžete nechať peniaze poslať na svoj účet.',
          },
          Rewards: {
            title: "Odmeny",
            explanationHint:
              "Celkový počet odmien z {{appName}} platieb pre vernostný program Stardust v aktuálnom mesiaci.",
          },
          MyShare: {
            title: "Môj podiel",
            explanationHint:
              "Tvoj aktuálny mesačný podiel na odmenách pre Stardust, jedná sa o odhadovaný podiel podľa celkového počtu Stardust a Odmien.<newline/><newline/> Reálny podiel na konci mesiaca sa môže od priebežného líšiť.",
          },
          Rules: {
            Title: "Vernostný program - všeobecné pravidlá",
            Link: "{{apiUrl}}/content/terms/Moone-stardust-general.pdf",
          },
          CurrentTerms: {
            Title: "Aktuálne platné podmienky Stardust",
            Link: "{{apiUrl}}/content/terms/Moone-stardust-monthly-july-2026.pdf",
          },
        },
        Leaderboard: {
          Title: "Stardust rebríček",
        },
        Rewards: {
          Columns: {
            PointsLabel: "Stardust",
          },
        },
      },
      Valor: {
        PointsLabel: {
          Points: "{{count}} Valor",
          Points_one: "{{count}} Valor",
          Points_few: "{{count}} Valory",
          Points_other: "{{count}} Valorov",
        },
        Overview: {
          Points: {
            title: "Valor",
            explanationHint:
              "Valor je odmenová jednotka pre Hunterov v {{appName}}. Získavate ho plnením výziev – privádzanie nových užívateľov, obchodníkov a hunterov.<newline/><newline/><bold>Na konci každého mesiaca je všetok Valor použitý na zisk podielu z balíka odmien. Na začiatku nového mesiaca všetci Hunteri začínajú s 0 Valor.</bold>",
          },
          Payout: {
            title: "Výplaty",
            explanationHint:
              'Na konci každého mesiaca sa uzatvára obdobie vernostného programu Valor a získané peniaze sa vám pripíšu do "K výplate".<newline/><newline/> Po dosiahnutí minimálnej sumy k výplate si môžete nechať peniaze poslať na svoj účet.',
          },
          Rewards: {
            title: "Odmeny",
            explanationHint:
              "Celkový počet odmien z {{appName}} pre vernostný program Valor v aktuálnom mesiaci.",
          },
          MyShare: {
            title: "Môj podiel",
            explanationHint:
              "Tvoj aktuálny mesačný podiel na odmenách pre Valor, jedná sa o odhadovaný podiel podľa celkového počtu Valor a Odmien.<newline/><newline/> Reálny podiel na konci mesiaca sa môže od priebežného líšiť.",
          },
          Rules: {
            Title: "Valor - všeobecné pravidlá",
            Link: "{{apiUrl}}/content/terms/legione-valor-general-rules.pdf",
          },
          CurrentChallenges: {
            Title: "VALOR - aktuálne platné výzvy",
            Link: "{{apiUrl}}/content/terms/legione-valor-monthly-july-2026.pdf",
          },
        },
        TeslaBanner: {
          Title: "Súťaž o Teslu!",
          Description:
            "Najúspešnejší Hunter mesiaca (s najviac Valormi) môže vyhrať Teslu na celý mesiac!",
        },
        Leaderboard: {
          Title: "Valor rebríček",
        },
        Rewards: {
          Columns: {
            PointsLabel: "Valor",
          },
        },
      },
      SetPassword: {
        CreateNewPassword: "Vytvorenie hesla",
        ResetPassword: "Reset hesla",
        Password: "Heslo",
        PasswordConfirmation: "Heslo znova",
        SetPassword: "Nastaviť heslo",
      },
      AmlUsers: {
        ExportUnderConstruction: "Funkcia exportu je stále vo vývoji...",
        ExportButton: "Exportovať",
        Error:
          "Počas načítania sa vyskytol neočakávaný problém. Skúste akciu prosím opakovať neskôr.",
        TableHeaders: {
          Verification: "Overenie",
          ClientIdentifier: "ID",
          Role: "Druh používateľa",
          FirstName: "Meno",
          LastName: "Priezvisko",
          Company: "Spoločnosť",
          PersonalNumber: "Rodné číslo",
          PartyType: "Typ osoby",
          RiskProfile: "Rizikový profil",
          DateCreated: "Dátum vytvorenia",
        },
        Detail: {
          ConnectedBankAccounts: "Pripojené bankové účty",
          RiskProfileSettings: "Nastavenie rizikového profilu",
          LoadingError: "Chyba, používateľa sa nepodarilo načítať",
          RiskProfileUpdateError: "Chyba pri aktualizacii rizikového profilu",
          RiskProfileUpdateSuccess: "Rizikový profil úspešne aktualizovaný",
          ClientIdentifier: "ID klienta",
          CopyClientIdentifier: "Kopírovať ID klienta",
          CopyClientIdentifierSuccess: "ID klienta skopírované",
        },
      },
      LicenseDetail: {
        AwaitingPayment: "Čaká na zaplatenie",
        CancelOrderConfirmation: "Naozaj chcete vybranú objednávku zrušiť?",
        LoadingError:
          "Pri načítaní údajov licencie sa vyskytla chyba, skúste to prosím neskôr.",
        Type: "Typ licencie",
        LicenseNo: "Číslo licencie",
        PaymentStatus: "Stav platby",
        WalletAddress: "Adresa peňaženky",
        Country: "Krajina",
        PaymentPendingInfo:
          "Licencia bude aktivovaná po pripísaní platby. Ak už máte zaplatené, vyčkejte na pripísanie peňazí.",
        CancelOrder: "Zrušiť objednávku",
        OrderLicense: "Objednať licenciu",
        LicenseStatus: {
          Initiated: "Platba vytvorená",
          Processing: "Prebieha spracovanie",
          Success: "Zaplatené",
          Fail: "Neúspešná",
          Cancelled: "Zrušené",
        },
      },
      LegalDocuments: {
        previousVersions: "Predchádzajúce verzie",
        Documents: {
          Hunter: {
            digitalFranchiseContract: {
              title: "Zmluva o digitálnej franšíze",
              url: "{{apiUrl}}/content/terms/legione-hunters-franchise-contract.pdf",
            },
            affiliateTerms: {
              title: "Podmienky affiliate",
              url: "{{apiUrl}}/content/terms/legione-affiliate-terms.pdf",
            },
            commissionTable: {
              title: "Provízna tabuľka",
              url: "{{apiUrl}}/content/terms/legione-provisions.pdf",
            },
            valorVigorPointRules: {
              title: "Pravidlá pre bodové hodnotenie VALOR a VIGOR",
              url: "{{apiUrl}}/content/terms/legione-valor-vigor.pdf",
            },
            valorGeneralRules: {
              title: "Valor - všeobecné pravidlá",
              url: "{{apiUrl}}/content/terms/legione-valor-general-rules.pdf",
            },
            nftCollectionRules: {
              title: "Pravidlá pre kolekciu NFT Legi.one",
              url: "{{apiUrl}}/content/terms/legione-NFT-collection.pdf",
            },
            generalFranchiseTerms: {
              title: "Všeobecné franšízové pravidlá",
              url: "{{apiUrl}}/content/terms/legione-general-franchise-terms.pdf",
            },
            dataProtectionPrinciples: {
              title: "Zásady ochrany osobných údajov",
              url: "{{apiUrl}}/content/terms/individual/Moone-memorandum.pdf",
            },
            satisfactionGuarantee: {
              title: "Záruka spokojnosti",
              url: "{{apiUrl}}/content/terms/satisfaction-guarantee.pdf",
            },
            previousAffiliateTerms: {
              title: "Podmienky affiliate platné do 28. 9. 2025",
              url: "{{apiUrl}}/content/terms/legione-affiliate-terms-28-9-2025.pdf",
            },
            previousDataProtectionPrinciples: {
              title: "Zásady ochrany osobných údajov platné do 06. 11. 2025",
              url: "{{apiUrl}}/content/terms/legione-gdpr.pdf",
            },
            previousDataProtectionPrinciples2: {
              title: "Zásady ochrany osobných údajov platné do 01. 07. 2026",
              url: "{{apiUrl}}/content/terms/archive/Moone-memorandum-01-07-2026.pdf",
            },
            previousAffiliateTerms2: {
              title: "Podmienky affiliate platné do 08. 02. 2026",
              url: "{{apiUrl}}/content/terms/legione-affiliate-terms-08-02-2026.pdf",
            },
            previousGeneralFranchiseTerms: {
              title: "Všeobecné franšízové pravidlá platné do 08. 02. 2026",
              url: "{{apiUrl}}/content/terms/legione-general-franchise-terms-08-02-2026.pdf",
            },
            previousNftCollectionRules: {
              title:
                "Pravidlá pre kolekciu NFT Legi.one platné do 08. 02. 2026",
              url: "{{apiUrl}}/content/terms/legione-NFT-collection-08-02-2026.pdf",
            },
            previousCommissionTable: {
              title: "Tabuľka provízií - predchádzajúca verzia",
              url: "{{apiUrl}}/content/terms/legione-provisions-30-04-2026.pdf",
            },
          },
          mooneLiteTerms: {
            title: "Obchodné podmienky {{appName}} Lite",
            url: "{{apiUrl}}/content/terms/Moone-moone-lite.pdf",
          },
          paymentServicesContract: {
            title: "Zmluva o poskytování platebních služeb",
            url: "{{apiUrl}}/content/terms/individual/Moone-payment-services-contract.pdf",
          },
          generalBusinessTerms: {
            title: "Všeobecné obchodné podmínky",
            url: "{{apiUrl}}/content/terms/individual/Moone-general-business-terms.pdf",
          },
          merchantTerms: {
            title: "Podmínky pro Obchodníky",
            url: "{{apiUrl}}/content/terms/individual/Moone-merchant-terms.pdf",
          },
          aisPisProductTerms: {
            title: "Produktové podmínky AIS-PIS",
            url: "{{apiUrl}}/content/terms/individual/Moone-ais-pis.pdf",
          },
          settlementManual: {
            title: "Manuál pre vyúčtovanie priamych plateb",
            url: "{{apiUrl}}/content/terms/individual/Moone-pis-settlement.pdf",
          },
          priceList: {
            Partner: {
              title: "Ceník poplatků - Partner",
              url: "{{apiUrl}}/content/pricelists/Moone-pricelist-partner-251201.pdf",
            },
            Prime: {
              title: "Ceník poplatků - Prime",
              url: "{{apiUrl}}/content/pricelists/Moone-pricelist-prime-251201.pdf",
            },
            Standard: {
              title: "Ceník poplatků",
              url: "{{apiUrl}}/content/pricelists/Moone-pricelist-standard-251201.pdf",
            },
            Individual: {
              title: "Cenník poplatkov - Špeciálny 0,49%",
              url: "{{apiUrl}}/content/pricelists/Moone-pricelist-discounted-individual.pdf",
            },
          },
          complaintRules: {
            title: "Reklamačný poriadok",
            url: "{{apiUrl}}/content/terms/individual/Moone-complaint-rules.pdf",
          },
          dataProtectionMemorandum: {
            title: "Zásady ochrany osobných údajov",
            url: "{{apiUrl}}/content/terms/individual/Moone-memorandum.pdf",
          },
          previousDataProtectionMemorandum: {
            title:
              "Informačné memorandum (ochrana osobných údajů) platné do 06. 11. 2025",
            url: "{{apiUrl}}/content/terms/archive/ZNPay-memorandum-06-11-2025.pdf",
          },
          previousDataProtectionMemorandum2: {
            title:
              "Informačné memorandum (ochrana osobných údajů) platné do 01. 07. 2026",
            url: "{{apiUrl}}/content/terms/archive/Moone-memorandum-01-07-2026.pdf",
          },
          precontractInformation: {
            title: "Předsmluvní informace",
            url: "{{apiUrl}}/content/terms/individual/Moone-single-precontract-terms.pdf",
          },
          thanksToYou: {
            title: 'Oznámenie doporučovacieho programu "Vďaka Tebe!"',
            url: "{{apiUrl}}/content/terms/individual/Moone-thanks-to-you.pdf",
          },
          previousGeneralBusinessTerms: {
            title: "Všeobecné obchodné podmínky platné do 28. 10. 2025",
            url: "{{apiUrl}}/content/terms/individual/ZNPay-general-business-terms-28-10-2025.pdf",
          },
          stardust: {
            title: "Oznámenie vernostného programu Stardust",
            url: "{{apiUrl}}/content/terms/Moone-stardust-general.pdf",
          },
          stardustCurrentTerms: {
            title: "Pravidlá - aktuálne platné výzvy (júl 2026)",
            url: "{{apiUrl}}/content/terms/Moone-stardust-monthly-july-2026.pdf",
          },
        },
      },
      Loyalty: {
        Tabs: {
          Challenges: "Výzvy",
          Leaderboard: "Vedenie",
          Rewards: "Odmien",
        },
        Challenges: {
          FeaturedChallenges: {
            Title: "Vybrané výzvy",
            AllChallenges: "Všetky výzvy",
          },
          WeeklyChallenges: {
            Title: "Týždenné výzvy",
            TimeRemaining: "Zostáva: {{days}} dní a {{hours}} hodín",
          },
          MonthlyChallenges: {
            Title: "Mesiacné výzvy",
            TimeRemaining: "Zostáva: {{days}} dní a {{hours}} hodín",
          },
          DailyChallenges: {
            Title: "Denné výzvy",
          },
          LongTermChallenges: {
            Title: "Dlhodobé výzvy",
          },
          UnlimitedChallenges: {
            Title: "Neobmedzené výzvy",
          },
          AllChallenges: {
            Title: "Všetky výzvy",
          },
        },
        Rewards: {
          Title: "Vďaka Tebe!",
          Columns: {
            Date: "Dátum",
            Activity: "Aktivita",
          },
        },
        Notification: {
          Completed: "Výzva splnená!",
        },
        Events: {
          [LoyaltyEventCode.Anniversary]: {
            title: "Výročie",
            description: "Oslav svoje výročie s {{appName}}",
          },
          [LoyaltyEventCode.HunterDailyAppOpen]: {
            title: "Denné otvorenie aplikácie",
            description: "Používateľ spustí {{appName}} aspoň raz za deň",
          },
          [LoyaltyEventCode.HunterDailyAppOpenStreak3]: {
            title: "Streak otvorenia aplikácie 3 dni",
            description: "Prihlásenie do aplikácie 3 dni za sebou",
          },
          [LoyaltyEventCode.HunterDailyAppOpenStreak5]: {
            title: "Streak otvorenia aplikácie 5 dní",
            description: "Prihlásenie do aplikácie 5 dní za sebou",
          },
          [LoyaltyEventCode.HunterDailyAppOpenStreak10]: {
            title: "Streak otvorenia aplikácie 10 dní",
            description: "Prihlásenie do aplikácie 10 dní za sebou",
          },
          [LoyaltyEventCode.HunterDailyAppOpenStreak30]: {
            title: "Streak otvorenia aplikácie 30 dní",
            description: "Prihlásenie do aplikácie 30 dní za sebou",
          },
          [LoyaltyEventCode.HunterDailyAppOpenStreak180]: {
            title: "Streak otvorenia aplikácie 180 dní",
            description: "Prihlásenie do aplikácie 180 dní za sebou",
          },
          [LoyaltyEventCode.HunterDailyAppOpenStreak365]: {
            title: "Streak otvorenia aplikácie 365 dní",
            description: "Prihlásenie do aplikácie 365 dní za sebou",
          },
          [LoyaltyEventCode.HunterReferUser]: {
            title: "Vďaka Tebe!",
            description: "Pozvanie a registrácia nového používateľa",
          },
          [LoyaltyEventCode.HunterRefer10]: {
            title: "Vďaka Tebe 10!",
            description: "Pozvanie a registrácia 10 používateľov",
          },
          [LoyaltyEventCode.HunterRefer50]: {
            title: "Vďaka Tebe 50!",
            description: "Pozvanie a registrácia 50 používateľov",
          },
          [LoyaltyEventCode.HunterRefer100]: {
            title: "Vďaka Tebe 100!",
            description: "Pozvanie a registrácia 100 používateľov",
          },
          [LoyaltyEventCode.HunterMerchantOnboarded]: {
            title: "Nový prírastok!",
            description: "Onboardovanie nového obchodníka",
          },
          [LoyaltyEventCode.HunterMerchant1]: {
            title: "Začínajúci Lovec",
            description: "Zaregistrovanie prvého obchodníka",
          },
          [LoyaltyEventCode.HunterMerchant10]: {
            title: "Skúsený Lovec",
            description: "Zaregistrovanie 10 obchodníkov",
          },
          [LoyaltyEventCode.HunterMerchant50]: {
            title: "Expertný Lovec",
            description: "Zaregistrovanie 50 obchodníkov",
          },
          [LoyaltyEventCode.HunterRecruitHunter]: {
            title: "Úlovok do tlupy",
            description: "Pozvanie nového Huntera",
          },
          [LoyaltyEventCode.HunterRecruit3]: {
            title: "Lovec Lovcov",
            description: "Pozvanie 3 nových Hunterov",
          },
          [LoyaltyEventCode.HunterRecruit10]: {
            title: "Skúsený Lovec Lovcov",
            description: "Pozvanie 10 nových Hunterov",
          },
          [LoyaltyEventCode.HunterMerchantNetwork]: {
            title: "Rozširovanie sietí",
            description: "Tvoj obchodník odporučil nového používateľa",
          },
          [LoyaltyEventCode.HunterWeeklyMerchant]: {
            title: "Štart týždennej misie",
            description: "Prvý registrovaný aktívny obchodník v týždni",
          },
          [LoyaltyEventCode.HunterMonthlyMerchant]: {
            title: "Štart mesačnej misie",
            description: "Prvý registrovaný aktívny obchodník v mesiaci",
          },
          [LoyaltyEventCode.HunterTerminalPlaced]: {
            title: "Umiestnenie terminálu",
            description: "Umiestnenie terminálu u obchodníka",
          },
          [LoyaltyEventCode.HunterTerminalPlaced3]: {
            title: "Umiestnenie 3 terminálov",
            description: "Umiestnenie 3 terminálov u obchodníkov",
          },
          [LoyaltyEventCode.HunterTerminalPlaced10]: {
            title: "Umiestnenie 10 terminálov",
            description: "Umiestnenie 10 terminálov u obchodníkov",
          },
          [LoyaltyEventCode.HunterTerminalOfTheWeek]: {
            title: "Terminál týždňa",
            description: "Prvý umiestnený terminál v týždni",
          },
          [LoyaltyEventCode.HunterTerminalOfTheMonth]: {
            title: "Terminál mesiaca",
            description: "Prvý umiestnený terminál v mesiaci",
          },
          [LoyaltyEventCode.HunterClosedHunter]: {
            title: "Uzavretie Lovca",
            description: "Pozvaný Hunter si zakúpil licenciu",
          },
          [LoyaltyEventCode.CustomerReferCustomer]: {
            title: "Affiliate odporúčania",
            description: "Pozvanie a registrácia nového používateľa",
          },
          [LoyaltyEventCode.CustomerReferCustomer10]: {
            title: "Vďaka Tebe 10!",
            description:
              "Pozvanie a registrácia 10 používateľov cez Vďaka Tebe!",
          },
          [LoyaltyEventCode.CustomerReferCustomer50]: {
            title: "Vďaka Tebe 50!",
            description:
              "Pozvanie a registrácia 50 používateľov cez Vďaka Tebe!",
          },
          [LoyaltyEventCode.CustomerReferCustomer100]: {
            title: "Vďaka Tebe 100!",
            description:
              "Pozvanie a registrácia 100 používateľov cez Vďaka Tebe!",
          },
          [LoyaltyEventCode.CustomerDailyAppOpen]: {
            title: "Denné otvorenie aplikácie",
            description: "Spusti {{appName}} aspoň raz za deň",
          },
          [LoyaltyEventCode.CustomerDailyAppOpenStreak3]: {
            title: "Streak otvorenia aplikácie 3 dni",
            description: "Prihlásenie do aplikácie 3 dni za sebou",
          },
          [LoyaltyEventCode.CustomerDailyAppOpenStreak5]: {
            title: "Streak otvorenia aplikácie 5 dní",
            description: "Prihlásenie do aplikácie 5 dní za sebou",
          },
          [LoyaltyEventCode.CustomerDailyAppOpenStreak10]: {
            title: "Streak otvorenia aplikácie 10 dní",
            description: "Prihlásenie do aplikácie 10 dní za sebou",
          },
          [LoyaltyEventCode.CustomerDailyAppOpenStreak30]: {
            title: "Streak otvorenia aplikácie 30 dní",
            description: "Prihlásenie do aplikácie 30 dní za sebou",
          },
          [LoyaltyEventCode.CustomerDailyAppOpenStreak180]: {
            title: "Streak otvorenia aplikácie 180 dní",
            description: "Prihlásenie do aplikácie 180 dní za sebou",
          },
          [LoyaltyEventCode.CustomerDailyAppOpenStreak365]: {
            title: "Streak otvorenia aplikácie 365 dní",
            description: "Prihlásenie do aplikácie 365 dní za sebou",
          },
          [LoyaltyEventCode.CustomerCompleteRegistration]: {
            title: "Kompletná registrácia",
            description: "Dokonči svoju registráciu používateľa",
          },
          [LoyaltyEventCode.TenPayments]: {
            title: "Desiatnik",
            description: "Dosiahnutie 10 platieb {{appName}}",
          },
          [LoyaltyEventCode.FiftyPayments]: {
            title: "Päťdesiatnik",
            description: "Dosiahnutie 50 platieb {{appName}}",
          },
          [LoyaltyEventCode.HundredPayments]: {
            title: "Stovkár",
            description: "Dosiahnutie 100 platieb {{appName}}",
          },
          [LoyaltyEventCode.ThousandPayments]: {
            title: "Tisíckrát {{appName}}",
            description: "Dosiahnutie 1 000 platieb {{appName}}",
          },
          [LoyaltyEventCode.Explorer]: {
            title: "Prieskumník",
            description: "Platba u 5 rôznych obchodníkov",
          },
          [LoyaltyEventCode.Discoverer]: {
            title: "Objaviteľ",
            description: "Platba u 10 rôznych obchodníkov",
          },
          [LoyaltyEventCode.Traveler]: {
            title: "Cestovateľ",
            description: "Platba u 50 rôznych obchodníkov",
          },
          [LoyaltyEventCode.FriendPayment]: {
            title: "Platba priateľovi",
            description: "Prvá priama platba cez {{appName}} priateľovi",
          },
          [LoyaltyEventCode.LargePayment]: {
            title: "Veľká platba",
            description: "Prvá veľká platba s {{appName}}",
          },
          [LoyaltyEventCode.BankConnection]: {
            title: "Bankové pripojenie",
            description: "Prvé pripojenie bankového účtu",
          },
          [LoyaltyEventCode.FirstSpending]: {
            title: "Prvé míňanie",
            description: "Prvá priama platba cez {{appName}} u obchodníka",
          },
          [LoyaltyEventCode.EngineIgnition]: {
            title: "Zážih motorov",
            description: "Prvá platba dňa (zo všetkých užívateľov)",
          },
          [LoyaltyEventCode.WeeklyMissionStart]: {
            title: "Týždenný štart misie",
            description: "Prvá platba týždňa (zo všetkých užívateľov)",
          },
          [LoyaltyEventCode.RepeatedUsage]: {
            title: "Opakované použitie",
            description: "Vykonaj 10 platieb v mesiaci",
          },
          [LoyaltyEventCode.MonthlyMissionStart]: {
            title: "Mesačný štart misie",
            description: "Prvá platba mesiaca (zo všetkých užívateľov)",
          },
          [LoyaltyEventCode.Payment]: {
            title: "Platba {{appName}}",
            description: "Transakcia uskutočnená prostredníctvom {{appName}}",
          },
          [LoyaltyEventCode.PaymentStreak3]: {
            title: "Streak platieb 3 dní",
            description: "Zaplať každý deň po dobu 3 dní",
          },
          [LoyaltyEventCode.PaymentStreak5]: {
            title: "Streak platieb 5 dní",
            description: "Zaplať každý deň po dobu 5 dní",
          },
          [LoyaltyEventCode.PaymentStreak10]: {
            title: "Streak platieb 10 dní",
            description: "Zaplať každý deň po dobu 10 dní",
          },
          [LoyaltyEventCode.PaymentStreak30]: {
            title: "Streak platieb 30 dní",
            description: "Zaplať každý deň po dobu 30 dní",
          },
          [LoyaltyEventCode.PaymentStreak180]: {
            title: "Streak platieb 180 dní",
            description: "Zaplať každý deň po dobu 180 dní",
          },
        },
      },
      UserDetailPageContent: {
        SaveSuccess: "Údaje používateľa boli úspešne uložené",
        SaveError: "Pri ukladaní údajov používateľa sa vyskytla chyba",
        DuplicateLoginError: "Tento login používa iný používateľ",
        AddressFields: {
          Legend: "Adresa",
          Type: "Typ adresy",
          Street: "Ulica",
          StreetNumber: "Súpisné číslo",
          OrientationNumber: "Orientančné číslo",
          PostalCode: "PSČ",
          Municipality: "Obec",
          Remove: {
            Button: "Odstrániť adresu",
            ConfirmTitle: "Odstrániť adresu",
            ConfirmContent: "Naozaj chcete túto adresu odstrániť?",
            SuccessMessage: "Adresa bola odstránená",
            ErrorMessage: "Pri odstraňovaní adresy došlo k chybe",
          },
        },
        Tabs: {
          User: {
            Title: "Používateľ",
            Form: {
              Login: "Login",
              Status: "Stav",
              VerificationAdditionalInfoStatus: "Stav doplňujúcich informací",
              VerificationIdentityVerificationStatus: "Stav overenia identity",
              VerificationRiskProfile: "Rizikový profil",
              VerificationBankVerificationStatus: "Stav bankovej verifikácie",
              BankVerificationSource: "Zdroj bankovej verifikácie",
              BankAccountNumber: "Číslo overovacieho účtu",
              VerificationDailyBuyLimit: "Denný limit",
              VerificationMonthlyBuyLimit: "Mesačný limit",
              Stardust: {
                Legend: "Vernostný program Stardust",
                NotAsked: "Nevyjadril sa",
                OptedIn: "Prihlásený",
                OptedOut: "Odhlásený",
                Withdrawn: "Natrvalo odstúpil",
                ChangedAt: "Od {{date}} ({{source}})",
                Source: {
                  Registration: "registrácia",
                  ConsentDialog: "dialóg Stardust",
                  ProgramSection: "sekcia Stardust",
                },
              },
              ThanksToYou: {
                Legend: "Program odporúčaní Vďaka Tebe!",
                NotAsked: "Prihlásený (bez odpovede)",
                OptedIn: "Prihlásený",
                OptedOut: "Odmietol účasť",
                Withdrawn: "Natrvalo odstúpil",
                ChangedAt: "Od {{date}} ({{source}})",
                Source: {
                  Registration: "registrácia",
                  ConsentDialog: "dialóg",
                  ProgramSection: "sekcia Vďaka Tebe!",
                },
              },
              Legend: {
                Account: "Účet",
                Verification: "Verifikácia",
                Bank: "Banka",
                Limits: "Limity",
              },
            },
          },
          Party: {
            Title: "Osoba",
            SetVerified: "Overiť identitu",
            CancelVerification: "Odobrať overenie identity",
            NoDocumentsUploaded: "Táto osoba nemá nahrané žiadne dokumenty",
            NoActingPersonLinked:
              "Nie je prepojená konajúca osoba — dokumenty nie sú k dispozícii",
            IdentityVerificationLegend: "Overenie identity",
            IdentityVerified: "Identita používateľa bola overená",
            IdentityNotVerified: "Overenie identity používateľa bolo odobraté",
            Form: {
              SubmitSuccess: "Údaje osoby boli úspešne uložené",
              SubmitError: "Při ukládání údajů osoby se vyskytla chyba",
              Save: "Uložiť",
              ClientIdentifier: "ID klienta",
              CopyClientIdentifier: "Kopírovať ID klienta",
              CopyClientIdentifierSuccess: "ID klienta skopírované",

              NaturalPerson: {
                Type: "Typ osoby",
                FirstName: "Meno",
                LastName: "Priezvisko",
                PersonalNumber: "Rodné číslo",
                BirthDate: "Dátum narodenia",
                Gender: "Pohlavie",
                BirthPlace: "Miesto narodenia",
                Nationality: "Národnosť",
                Phone: "Telefón",
                VerifiedPhone: "Overený telefón",
                Email: "E-mail",
                Legend: {
                  PersonalData: "Osobné údaje",
                  Contact: "Kontakt",
                  Documents: "Doklady",
                },
              },
              PartyIdentification: {
                Identification: "Typ identifikácie",
                IdentificationNumber: "Číslo identifikácie",
                IdentificationValidFrom: "Platnosť od",
                IdentificationValidTo: "Platnosť do",
                IdentificationIssuer: "Vydal",
                NoIdentificationsUploaded:
                  "Pre túto osobu neevidujeme žiadne nahrané doklady.",
                IdentificationsDownloadPrefix: "doklady_",
                SecondDocumentTitle: "Druhý doklad",
                AutomatedCheck: {
                  Title: "Automatická kontrola dokladu",
                  NoChecks: "Automatická kontrola zatiaľ neprebehla.",
                  LoadingError:
                    "Nepodarilo sa načítať výsledky automatickej kontroly.",
                  Document: "Doklad",
                  Documents: {
                    Primary: "Primárny doklad",
                    Secondary: "Druhý doklad",
                  },
                  Verdict: "Výsledok",
                  Date: "Dátum",
                  DocumentType: "Typ podľa Didit",
                  RequestID: "Didit request ID",
                  Warnings: "Varovania",
                  Error: "Chyba",
                },
              },
              LegalEntity: {
                Type: "Typ osoby",
                CompanyName: "Názov spoločnosti",
                CompanyNumber: "IČO",
                TaxNumber: "DIČ",
                Phone: "Telefón",
                Email: "E-mail",
                Legend: {
                  Company: "Spoločnosť",
                  Contact: "Kontakt",
                },
                RegistryLinks: {
                  Or: "Obchodný register",
                  Isir: "Register úpadcov",
                  Esm: "Evidencia vlastníkov",
                },
              },
              SelfEmployed: {
                Legend: {
                  Company: "Podnikateľ",
                  Contact: "Kontakt",
                  Documents: "Doklady",
                },
                Type: "Typ osoby",
                CompanyName: "Názov spoločnosti",
                FirstName: "Meno",
                LastName: "Priezvisko",
                CompanyNumber: "IČO",
                TaxNumber: "DIČ",
                PersonalNumber: "Rodné číslo",
                BirthDate: "Dátum narodenia",
                Gender: "Pohlavie",
                BirthPlace: "Miesto narodenia",
                Nationality: "Národnosť",
                Phone: "Telefón",
                VerifiedPhone: "Overený telefón",
                Email: "E-mail",
              },
            },
          },
          BankAccounts: {
            Title: "Bankové účty",
            Subtitle: "Pripojené bankové účty",
          },
          Licenses: {
            Title: "Licence",
            Empty: "Používateľ nemá žiadnu aktívnu licenciu.",
            Transfer: {
              Button: "Previesť licenciu",
              Title: "Prevod licencie {{licenseNo}}",
              Description:
                "Na nového huntera prejdú merchanti registrovaní na licencii, celá affiliate sieť pôvodného huntera (privedení zákazníci aj hunteri) a všetky budúce odmeny z nich. Doteraz nabehnuté a vyplatené odmeny, faktúra za nákup a uzavretá história zostávajú pôvodnému hunterovi (uvidí ich, ale už z nich neprofituje). Adresa peňaženky licencie zostáva bez zmeny.",
              TargetLabel: "Nový držiteľ licencie",
              Submit: "Previesť licenciu",
              Success: "Licencia bola prevedená",
              Error: "Pri prevode licencie sa vyskytla chyba",
            },
            Form: {
              Controls: {
                SubmitSuccess: "Údaje licencie boli uložené",
                SubmitError: "Pri ukladaní údajov licencie sa vyskytla chyba",
                Save: "Uložiť",
                SendInvoice: "Odoslať faktúru",
                SendingInvoice: "Odosielam faktúru...",
                SendInvoiceSuccess: "Faktúra bola úspešne odoslaná",
                SendInvoiceError: "Pri odosielaní faktúry sa vyskytla chyba",
                InvoiceSent: "Faktúra odoslaná",
                RegenerateInvoice: "Pregenerovať faktúru",
                RegeneratingInvoice: "Pregenerovávam faktúru...",
                RegenerateInvoiceSuccess: "Faktúra bola pregenerovaná",
                RegenerateInvoiceError:
                  "Pri pregenerovaní faktúry sa vyskytla chyba",
              },
              Fields: {
                Code: "Typ licencie",
                LicenseNo: "Číslo licencie",
                PaymentDate: "Dátum platby",
                PaymentStatus: {
                  label: "Stav platby",
                  options: {
                    Initiated: "Platba vytvořena",
                    Processing: "Probíhá zpracování",
                    Success: "Zaplaceno",
                    Fail: "Neúspěšná",
                    Cancelled: "Zrušeno",
                  },
                },
                WalletAddress: "Adresa peněženky",
              },
            },
          },
          Verification: {
            Title: "Overenie",
            Form: {
              Controls: {
                SubmitSuccess: "Údaje overenia boli uložené",
                SubmitError: "Pri ukladaní údajov overenia sa vyskytla chyba",
                Save: "Uložiť",
              },
              Fields: {
                TaxResidencyCountryID: "Daňová rezidencia",
                BusinessActivity: "Predmet podnikania",
                OtherBusinessActivityDetails: "Upresnite predmet podnikania",
                SourceOfIncome: "Zdroj príjmov",
                OtherSourceOfIncomeDetails: "Upresnite zdroj príjmov",
                LegacySourceOfIncome: "Predchádzajúci zdroj príjmov",
                ExpectedMonthlyRevenue: "Očakávaný mesačný objem",
                AverageTransactionValue: "Priemerná hodnota jednej transakcie",
                IsPoliticallyExposedPerson: "Politicky exponovaná osoba",
                HasNonEUResidence:
                  "Bydlisko ke dni registrácie mimo EU po dobu dlhšiu než 12 mesiacov",
                HasNonEUNationality:
                  "Štátnym príslušníkom inej krajiny mimo EÚ",
              },
            },
          },
          Settlement: {
            Title: "Vyúčtovanie",
          },
          HunterPrerequisites: {
            Title: "Hunter prvé kroky",
            SelectAll: "Vybrať všetky",
            DeselectAll: "Zrušiť výber",
            LoadingError: "Pri načítaní predpokladov došlo k chybe.",
            SaveSuccess: "Zmeny boli úspešne uložené.",
            SaveError: "Pri ukladaní zmien nastala chyba.",
            Note: "Poznámka",
            NotePlaceholder: "Voliteľná poznámka...",
            AutoVerified: "Automaticky overené",
            Items: {
              RegisterAsMerchant:
                "Zaregistroval/a sa ako Obchodník a prešiel/a si aplikáciu",
              InviteUserViaAffiliate:
                "Pozval/a nového používateľa cez Vďaka Tebe!",
              BanksAndPayments:
                "Pripojil/a si aspoň 3 banky a vykonal/a 30 platieb",
              OfflineTraining: "Navštívil/a offline školenie Mo.one",
              BringMerchantsWithHunter:
                "Priviedol/a 3 Obchodníkov v kooperácii so skúseným Hunterom",
            },
          },
          RelatedParties: {
            Title: "Súvisiace osoby",
            NoRelatedParties:
              "Pre túto osobu neevidujeme žiadne súvisiace osoby.",
            Add: {
              Button: "Pridať súvisiacu osobu",
              Title: "Pridať súvisiacu osobu",
              RelationTypeLabel: "Typ vzťahu",
              BeneficialOwnerOption: "Konečný užívateľ výhod",
              Submit: "Pridať",
              AddSuccess: "Súvisiaca osoba bola pridaná",
              AddError: "Pri pridávaní súvisiacej osoby došlo k chybe",
              LinkError:
                "Osoba bola vytvorená, ale nepodarilo sa ju prepojiť s firmou. Skúste to prosím znova – duplicitná osoba sa nevytvorí.",
              DocumentsTitle: "Doklady totožnosti",
              DocumentsIncomplete:
                "Priložte prosím obe strany prvého dokladu a kompletný druhý doklad.",
            },
            Delete: {
              Button: "Vymazať súvisiacu osobu",
              ConfirmTitle: "Vymazať súvisiacu osobu",
              ConfirmContent:
                "Naozaj chcete vymazať súvisiacu osobu {{name}}? Odstráni sa iba táto rola.",
              SuccessMessage: "Súvisiaca osoba bola vymazaná",
              ErrorMessage: "Pri mazaní súvisiacej osoby došlo k chybe",
            },
            Form: {
              Controls: {
                SubmitSuccess: "Údaje súvisiacej osoby boli uložené",
                SubmitError:
                  "Pri ukladaní údajů súvisiacej osoby sa vyskytla chyba",
                LoadingError:
                  "Pri načítaní údajů súvisiacej osoby sa vyskytla chyba",
                Save: "Uložiť",
              },
              Fields: {
                RelationType: "Rola",
                IsOwner: "Osoba je skutočným vlastníkom",
                BeneficialOwnerFields: {
                  Legend: {
                    PersonalData: "Osobné údaje",
                  },
                  FirstName: "Meno",
                  LastName: "Priezvisko",
                  BirthDate: "Dátum narodenia",
                  Nationality: "Národnosť",
                },
                RelatedPartyFields: {
                  Legend: {
                    PersonalData: "Osobné údaje",
                    Contact: "Kontakt",
                    Documents: "Doklady",
                    FirstDocument: "Prvý doklad",
                  },
                  DocumentsExpiringSoon: "Platnosť dokladov čoskoro vyprší",
                  DocumentsExpired: "Platnosť dokladov vypršala",
                  DocumentsValidityMissing: "Chýba platnosť dokladov",
                  FirstName: "Meno",
                  LastName: "Priezvisko",
                  PersonalNumber: "Rodné číslo",
                  BirthDate: "Dátum narodenia",
                  Gender: "Pohlavie",
                  BirthPlace: "Miesto narodenia",
                  Nationality: "Národnosť",
                  Phone: "Telefón",
                  Email: "E-mail",
                },
              },
            },
          },
        },
      },
      Contact: {
        HunterDiscord: {
          Description: "Pre rýchlu komunikáciu sa pripojte k serveru",
          Link: "Legi.one na Discorde!",
        },
        Phone: "Telefón",
        Email: "E-mail",
        PhoneDescription:
          "Telefonicky nás môžete kontaktovať v pracovné dni od 9:00 do 16:00.",
        CompanyInfo: {
          title: "Prevádzkovateľ",
          description: "Mo.one a.s.",
          CompanyNumber: "IČO: 02013517",
          TaxNumber: "DIČ: CZ02013517",
          CompanyAddress:
            "Sídlom Palackého třída 3048/124, Královo Pole, 612 00 Brno, zapísaná v obchodnom registri na Krajskom súde v Brne, sp.zn. B 9099",
        },
        HunterCompanyInfo: {
          Title: "Prevádzkovateľ",
          CompanyName: "LEGI.ONE LTD.",
          CompanyInfoLine1:
            "registrovaná vo Veľkej Británii pod číslom 15846883",
          CompanyInfoLine2:
            "so sídlom 20 Wenlock Road, Londýn, Anglicko, N1 7GU",
          CompanyInfoLine3:
            "v súvislosti a prostredníctvom svojho odštepeného závodu v Českej republike:",
        },
        BankInfo: {
          Title: "Bankové spojenie",
          CZKAccount: {
            Customer: "Fio banka: 2103087398/2010",
            Hunter: "Bankový účet CZK: 1741535007/2700",
            Merchant: "Fio banka: 2103087398/2010",
            Admin: "Fio banka: 2103087398/2010",
            Aml: "Fio banka: 2103087398/2010",
            Employee: "Fio banka: 2103087398/2010",
            CustomerOnboarding: "Fio banka: 2103087398/2010",
            HunterPlus: "Bankový účet CZK: 1741535007/2700",
            AdminLite: "Fio banka: 2103087398/2010",
            Disponent: "Fio banka: 2103087398/2010",
            Child: "Fio banka: 2103087398/2010",
          },
          EURAccount: {
            Customer: "",
            Hunter: "Bankový účet EUR: 1741535015/2700",
            Merchant: "",
            Admin: "",
            Aml: "",
            Employee: "",
            CustomerOnboarding: "",
            HunterPlus: "Bankový účet EUR: 1741535015/2700",
            AdminLite: "",
            Disponent: "",
            Child: "",
          },
        },
      },
      BankAccounts: {
        ConnectedBankAccounts: "Všetky pripojené účty",
        CurrencyGroupTitle: "Účty v mene {{currency}}",
        BankIdentityVerificationAccount: "Overovací účet",
        InvalidTokenChip: "Vypršal prístup",
        AccountMenu: {
          Renew: "Obnoviť prístup",
          RenewPayments: "Obnoviť platby",
          Remove: "Odpojiť účet",
        },
        EditOrder: "Upraviť poradie",
        PrimaryAccount: "Primárny účet",
        PrimaryAccountDescription:
          "Primárny účet nastavujete hviezdičkou pre každú menu zvlášť — je východiskovým účtom pre prijímanie a odosielanie platieb v danej mene. Nie je možné ho nastaviť na účet v stave <limitedChip /> ani <awaitingVerificationChip />.",
        HunterPrimaryAccountDescription:
          "Primárny účet nastavujete hviezdičkou pre každú menu zvlášť — na primárny účet danej meny vám budeme posielať vaše odmeny.",
        MissingLicenseHolderBankAccount:
          "Pre výplatu odmien pripojte bankový účet vedený na vlastníka franšízovej licencie.",
        VerificationStatusesTitle: "Stavy overenia účtu",
        QuickPayment: {
          Label: "Rýchla platba",
          Description:
            "Po načítaní transakcie budete automaticky presmerovaní do svojej banky na autorizáciu platby s primárnym účtom, vynecháte tak krok s detailom transakcie a výberom banky.",
        },
        EditAccountOrderDescription:
          "Poradie účtov môžete zmeniť podržaním a presunutím účtu na požadovanú pozíciu.",
        NoBankAccounts: "Nemáte žiadne pripojené bankové účty.",
        Error:
          "Pri načítaní bankových účtov sa vyskytla neočakávaná chyba. Skúste to prosím znovu neskôr.",
        NoAccountSet: "Nie je nastavený žiadny účet",
        DeleteAccount: {
          Title: "Zmazať účet",
          Prompt: "Naozaj chcete zmazať tento účet?",
          ReplacementPrimaryAccount: "Nový primárny účet",
          PrimaryAccountWarning:
            "Chystáte sa zmazať Váš <bold>primárny účet</bold>. Zvoľte si, ktorým účtom ho chcete nahradiť.",
        },
        ManualBankAccountVerificationPrompt: {
          ManualVerificationNecessary: "Tento účet je nutné overiť manuálne",
          ActivateConfirmationPrompt:
            "Naozaj chcete tento účet aktivovať? Táto akcia je nevratná.",
          Activate: "Aktivovať",
          Reject: "Zamietnuť",
          RejectConfirmationPrompt:
            "Naozaj chcete tento účet zamietnuť? Táto akcia je nevratná.",
        },
        ConnectedBankAccount: {
          Owner: "Majiteľ účtu",
          DateCreated: "Dátum pripojenia",
          Status: "Stav",
          BankVerificationSource: "Zdroj bankového overenia",
        },
        DeletedVerificationAccount: {
          Error: "Overovací účet sa nepodarilo načítať.",
        },
        Detail: {
          IBAN: "IBAN",
          AccountOwners: "Majitelia účtu",
          DateConnected: "Dátum pripojenia",
          AccountNotFound: "Tento bankový účet sa nepodarilo nájsť.",
          BackToList: "Späť na bankové účty",
          IsPrimaryNote: "Toto je váš primárny bankový účet.",
          Actions: {
            SetAsPrimary: "Nastaviť ako primárny",
            PrimaryAccountDescription:
              "Primárny účet je predvolený na prijímanie a odosielanie platieb.",
            AuthorizeAccess: "Autorizovať prístup {{bankName}}",
            AuthorizePayments: "Autorizovať platby {{bankName}}",
            AuthorizationValidUntil: "Autorizácia platná do {{date}}",
          },
          IbanCopySuccess: "IBAN skopírovaný",
          Alerts: {
            Rejected: {
              Title: "Účet bol zamietnutý",
              Description:
                "Tento účet bol zamietnutý a nedá sa v aplikácii používať.",
            },
            Inactive: {
              Title: "Účet je neaktívny",
              Description:
                "Tento účet je neaktívny. Ak ho chcete znova používať, kontaktujte podporu.",
            },
            Restricted: {
              Title: "Dokončite overenie identity",
              Description:
                "Pre plné využitie tohto účtu je potrebné dokončiť overenie identity.",
              Action: "Dokončiť overenie",
            },
            AwaitingVerification: {
              Title: "Overte pripojenie účtu",
              Description:
                "Informácie o tomto účte musí overiť niekto z tímu {{appName}}. K tomu zvyčajne dochádza, keď sa meno majiteľa účtu nepodarilo automaticky porovnať s vaším menom.",
            },
            PreApproved: {
              Title: "Účet je predschválený",
              Description:
                "Môžete prijímať platby z účtu na účet až do {{limit}}, kým nebude účet úplne overený — zostáva {{remaining}}. Po dokončení overenia sa limity automaticky zrušia.",
            },
            TokenInvalidAis: {
              Title: "Prístup k účtu vypršal",
              Description:
                "Vypršal prístup k informáciám o účte. Obnovte pripojenie, aby sme mohli načítať zostatok a transakcie.",
              Action: "Obnoviť prístup",
            },
            TokenExpiringAis: {
              Title: "Prístup k účtu čoskoro vyprší",
              Description:
                "Prístup k informáciám o účte čoskoro vyprší. Obnovte ho, aby sme mohli ďalej načítať zostatok.",
              Action: "Obnoviť prístup",
            },
            TokenInvalidPisp: {
              Title: "Autorizácia platieb vypršala",
              Description:
                "Vypršala autorizácia platieb z tohto účtu. Obnovte ju, aby ste mohli ďalej odosielať platby.",
              Action: "Obnoviť platby",
            },
            TokenExpiringPisp: {
              Title: "Autorizácia platieb čoskoro vyprší",
              Description:
                "Autorizácia platieb z tohto účtu čoskoro vyprší. Obnovte ju, aby ste mohli ďalej odosielať platby.",
              Action: "Obnoviť platby",
            },
          },
        },
      },
      MerchantFeeCalculator: {
        YearlySavingsWidget: {
          PotentialYearlySavings: "Potenciálna ročná úspora",
          WithLegione: "S Legi.one až:",
          WithMoone: "S {{appName}} až:",
        },
        CurrentTotalFee: "Aktuálny celkový poplatok",
        ProposedTotalFee: "Navrhovaný celkový poplatok",
        HideFeeTable: "Skryť detailnú tabuľku poplatkov",
        ShowFeeTable: "Zobraziť detailnú tabuľku poplatkov",
        MonthlyTurnover: "Mesačný obrat",
        AverageTransactionValue: "Priemerná hodnota transakcie",
        MooneDirectPayShare: "Podiel priamych platieb",
        Currency: "Kč",
        FeeSettings: {
          CurrentFees: "Aktuálne poplatky",
          ProposedFee: "Navrhovaný poplatok",
          DirectPaymentWithMoone: "Priama platba s {{appName}}",
          ProviderFee: "Poplatok prevádzkovateľovi",
          Acquiring: "(Acquiring)",
          FixedTransactionCost: "Fixný náklad za transakciu",
          MooneFee: "Poplatok {{appName}}",
        },
        CardTypeRatioSlider: {
          Title: "Rozloženie platobných kariet",
          ToggleButtons: {
            MostlyPersonal: "Prevažne spotrebiteľské",
            SomeCommercial: "Vyšší podiel podnikateľských",
            MostlyCommercial: "Prevažne podnikateľské",
          },
          CardTypeRatios: {
            Personal: "Spotrebiteľské",
            Commercial: "Podnikateľské",
          },
        },
        CardRatesTable: {
          Expand: "Zobraziť detailnú tabuľku poplatkov",
          Collapse: "Skryť detailnú tabuľku poplatkov",
          Headers: {
            CardType: "Typ karty",
            Interchange: "Interchange",
            SchemeFee: "Scheme fee",
            CurrentTotalRate: "Aktuálny celkový poplatek",
            ProposedTotalRate: "Navrhovaný celkový poplatek",
          },
        },
        CostsChart: {
          Title: "Náklady na transakcie",
          HighContrast: "Vysoký kontrast",
          AnnualTransactionCosts: "Ročné náklady za transakcie",
          TickLabels: {
            CurrentCosts: {
              Mobile: "Teraz",
              Full: "Aktuálne náklady",
              Description: "Priemerný poplatok",
            },
            LegioneCosts: {
              Mobile: "Legi.one",
              Full: "Náklady s Legi.one",
              Description: "Priemerný poplatok",
            },
            MooneCosts: {
              Mobile: "{{appName}}",
              Full: "Náklady s {{appName}}",
              Description: "Poplatok",
            },
          },
        },
      },
      Settlements: {
        Error:
          "Pri načítaní vyúčtovania sa vyskytla neočakávaná chyba. Skúste to prosím znovu neskôr.",
        SettlementTrigger: "Spustiť vyúčtovanie poplatkov za aktuálne obdobie.",
        SettlementTriggerError:
          "Pri spúšťaní vyúčtovania nastala chyba. Skúste to prosím znovu neskôr.",
        SettlementTriggerSuccess: "Vyúčtovanie bolo úspešne spustené.",
        SettlementTriggerLoading: "Spúšťam vyúčtovanie...",
        SettlementTriggerButtonText: "Spustiť vyúčtovanie",
      },
      Merchants: {
        StatusWidgets: {
          OpenRegistrations: "Otvorené registrácie",
          InvitationsSent: "Odoslané pozvánky",
          InOnboarding: "Prebieha onboarding",
          Completed: "Aktívni obchodníci",
        },
        Error:
          "Pri načítaní obchodníkov sa vyskytla neočakávaná chyba. Skúste to prosím znovu neskôr.",
        TableHeaders: {
          Status: "Stav",
          CompanyName: "Názov firmy",
          CompanyNumber: "IČO",
          LicenseType: "Typ licencie",
          LicenseOwner: "Hunter (majiteľ licencie)",
          LicenseNumber: "Číslo licencie",
          DateCreated: "Dátum vytvorenia",
          TransactionsCount: "Počet transakcií",
        },
        OrbitLOnboarding: {
          Title: "OrbitL Onboarding",
          ActionRequiredBadge: "Vyžaduje akciu",
          LoadingError: "Nepodarilo sa načítať dáta OrbitL onboardingu",
          Table: {
            CompanyNumber: "IČO",
            CompanyName: "Názov firmy",
            Hunter: "Hunter",
            ActivatedAt: "OrbitL aktivovaný",
            Phase: "Fáza",
            ComgateStatus: "Comgate status",
            ComgateMID: "MID",
            TimeSinceSubmit: "Čas od odoslania",
            LastStatusChange: "Posledná zmena stavu",
            FinancingModel: "Financovanie",
            Hours: "{{count}}h",
            Days: "{{count}}d",
            TerminalCount: "Terminály",
            TerminalCountRequest: "Žiadosť o zmenu počtu",
            OnlyOpenRequests: "Len s otvorenou žiadosťou",
          },
          TerminalCountChange: {
            SectionTitle: "Počet terminálov",
            OpenRequestHeading: "Otvorená žiadosť o zmenu",
            RequestedBy: "Požiadal {{user}}",
            SystemActor: "systém",
            ContractTotal: "Dohodnutý počet: {{count}}",
            ContractSoftPosTotal: "SoftPOS: {{count}}",
            ContractLevelChange: "Celkový počet",
            SoftPosChange: "SoftPOS {{from}} → {{to}}",
            SoftPosTotal: "SoftPOS: {{from}} → {{to}}",
            HistoryHeading: "História zmien",
            NoHistory: "Zatiaľ žiadne zmeny počtu terminálov",
            ResolveButton: "Vyriešené",
            DismissButton: "Zamietnuť",
            ResolveHint:
              "Vyriešenie žiadosť len uzavrie — samotný počet zmeňte cez úpravu prevádzky.",
            DismissDialogTitle: "Zamietnuť žiadosť",
            DismissNoteLabel: "Dôvod zamietnutia",
            DismissNoteRequired: "Uveďte dôvod zamietnutia",
            DismissConfirm: "Zamietnuť žiadosť",
            Cancel: "Zrušiť",
            ResolveSuccess: "Žiadosť bola označená ako vyriešená",
            DismissSuccess: "Žiadosť bola zamietnutá",
            Error: "Žiadosť sa nepodarilo vyriešiť",
            Source: {
              MerchantSelfService: "Obchodník",
              Admin: "Podpora",
              InitialOrder: "Objednávka",
            },
            Status: {
              Applied: "Vykonané",
              Pending: "Čaká na vyriešenie",
              Resolved: "Vyriešené",
              Dismissed: "Zamietnuté",
            },
          },
          Detail: {
            Title: "Detail OrbitL onboardingu",
            CloseButton: "Zavrieť",
            ChecklistSection: "Kontrolný zoznam",
            RejectionSection: "Chyby Comgate",
            TerminalsSection: "Priradenie terminálov",
            CommentsSection: "Comgate komentáre",
            NoTerminals: "Žiadne priradené terminály",
            NoComments: "Zatiaľ žiadne komentáre",
            SendNoteLabel: "Odoslať poznámku do Comgate",
            SendNoteButton: "Odoslať",
            SendNotePlaceholder: "Napíšte správu...",
            SendNoteSuccess: "Komentár bol úspešne odoslaný",
            SendNoteError: "Nepodarilo sa odoslať komentár",
            ResubmitButton: "Znovu odoslať do Comgate",
            ResubmitConfirmTitle: "Potvrdiť opätovné odoslanie",
            ResubmitConfirmText:
              "Týmto znovu odošlete dáta a dokumenty obchodníka do Comgate. Uistite sa, že všetky problémy boli vyriešené. Status bude nastavený na REQUESTED.",
            ResubmitConfirmButton: "Znovu odoslať",
            ResubmitCancelButton: "Zrušiť",
            ResubmitSuccess: "Úspešne odoslané do Comgate",
            ResubmitError: "Nepodarilo sa znovu odoslať do Comgate",
            CommentAuthor: "Autor",
            CommentDate: "Dátum",
            SwapTerminal: "Vymeniť",
            SwapTerminalTitle: "Výmena terminálu",
            SwapTerminalSearch: "Hľadať podľa sériového čísla...",
            SwapTerminalConfirm: "Vymeniť terminál",
            SwapTerminalCancel: "Zrušiť",
            SwapTerminalSuccess: "Terminál úspešne vymenený",
            SwapTerminalSuccessWithCode:
              "Terminál vymenený. Aktivačný kód {{code}} je opäť platný pre nové zariadenie",
            SwapTerminalError: "Nepodarilo sa vymeniť terminál",
            SwapTerminalNoResults: "Žiadne dostupné terminály",
            SwapTerminalTmsUpdateWarning:
              "Terminál je už zaregistrovaný v Switchio TMS. Výmena sériového čísla bude vykonaná aj v TMS.",
            TerminalStatusDeployed: "Registrovaný v TMS",
            Tid: "TID",
            TidTypesSection: "Typy terminálov (TIDy z Comgate)",
            TidTypesHint:
              "Pri týchto TIDoch sa nepodarilo určiť typ. Označte ich; ostatné TIDy sa registrujú aj bez nich. TID nad rámec objednávky nejde označiť, kým sa na zmluve nenavýši počet terminálov alebo SoftPOS.",
            TidTypePhysical: "Fyzický terminál",
            TidTypeSoftPos: "SoftPOS",
            TidTypeUnknown: "Neurčené",
            TidTypeManual: "Ručne",
            SaveTidTypes: "Uložiť typy",
            SaveTidTypesSuccess: "Typy TIDov uložené",
            SaveTidTypesError: "Nepodarilo sa uložiť typy TIDov",
            SaveTidTypesExceedError:
              "Označené typy presahujú počty na zmluve (fyzické / SoftPOS). Najprv navýšte počet na zmluve.",
            RegisterTmsButton: "Spustiť registráciu do TMS",
            RegisterTmsSuccess:
              "Registrácia do TMS: {{registered}}/{{expected}} terminálov",
            RegisterTmsError: "Registrácia do TMS zlyhala",
            ActivationCode: "Aktivačný kód",
            ReactivateCodeButton: "Uvoľniť kód pre nové zariadenie",
            ReactivateCodeSuccess:
              "Väzba na zariadenie zrušená, aktivačný kód možno použiť znova",
            ReactivateCodeError: "Väzbu na zariadenie sa nepodarilo zrušiť",
          },
          FindByTerminal: {
            Button: "Vyhľadať terminál",
            Title: "Vyhľadanie merchanta podľa terminálu",
            SearchLabel: "Hľadať podľa TID alebo sériového čísla...",
            NoResults: "Žiadne terminály nenájdené",
            Close: "Zavrieť",
          },
        },
      },
      Users: {
        VerificationCell: {
          AdditionalInfo: "Dodatočné informácie",
          IdentityVerification: "Overenie identity",
          RiskProfile: "Rizikový profil",
          BankVerification: "Overenie bankového účtu",
        },
        ExcludeAnonymous: "Nezobrazovať anonymných používateľov",
        Error:
          "Pri načítaní používateľov sa vyskytla neočakávaná chyba. Skúste to prosím znovu neskôr.",
        TableHeaders: {
          Verification: "Overenie",
          Login: "Login",
          Role: "Rola",
          Status: "Stav",
          FirstName: "Meno",
          LastName: "Priezvisko",
          Company: "Spoločnosť",
          ClientIdentifier: "ID",
          DateCreated: "Dátum vytvorenia",
          PaymentReference: "Var. s. platby licencie",
          Version: "Verzia {{appName}}",
          DocumentExpiration: "Expirácia dokladu",
          Settlement: "Vyúčtovanie",
          Admin: "Admin",
        },
        Filters: {
          ExpiringWithin30Days: "Expiruje do 30 dní",
          Expired: "Expirované",
        },
        ConnectedBankAccounts: {
          LoadingError:
            "Chyba, nepodarilo sa načítať pripojené bankové účty používateľa.",
          NoBankAccounts: "Používateľ nemá pripojené žiadne bankové účty.",
          UnassignedContext: "Nepriradené k roli (staršie pripojenie)",
        },
        ToBeVerified: {
          Subtitles: {
            UserVerification: "Používatelia na overenie",
            BankVerification: "Používatelia s bankovými účtami na schválenie",
          },
          AdditionalInfo: "Doplňujúce informácie",
          RiskProfile: "Rizikový profil",
          BankVerification: "Overenie bankového účtu",
          IdentityVerification: "Overenie identity",
        },
        RolesPermissions: {
          TableHeaders: {
            RoleName: "Názov role",
            RoleCode: "Kód role",
            AccessRightCode: "Prístupové právo",
            CanRead: "Čítanie",
            CanCreate: "Vytváranie",
            CanUpdate: "Úpravy",
            CanDelete: "Mazanie",
            CanExport: "Export",
          },
          NoAccessRights: "Žiadne prístupové práva",
          AccessRightSingular: "prístupové právo",
          AccessRightPlural: "prístupové práva",
        },
      },
      Dashboard: {
        BankAccountsWidget: {
          Title: "Pripojené účty",
          ConnectionFailed: "Pripojené účty sa nepodarilo načítať.",
          NoActiveAccounts: "Žiadny aktívny účet na zobrazenie.",
        },
        PreApprovalWidget: {
          Title: "Predschválený limit",
          Description:
            "Kým váš účet úplne neoveríme, platia nasledujúce obmedzenia:",
          LimitPerTransaction:
            "maximálna výška jednej transakcie <amount>{{amount}}</amount>",
          LimitTotal: "celkový limit <amount>{{amount}}</amount>",
          Remaining: "Zostáva {{remaining}}",
        },
        TransactionFees: {
          Admin: {
            allTime: "Celkový zárobok za transakcie",
            currentMonth: "Zárobok za tento mesiac",
            lastMonth: "Zárobok za predchádzajúci mesiac",
          },
        },
      },
      Welcome: {
        RegistrationSuccess:
          "Vytvorili sme Váš používateľský účet. Nižšie si prečítajte, ako začať s prijímaním výplaty v bitcoinoch.",
        UnverifiedAccountLimits:
          "Keďže je Váš účet zatiaľ neoverený, máte nastavené nízke limity transakcií. Dodatočné overenie môžete následne vykonať vo svojom profile.",
        TransactionLimitsLink: "Limity transakcií",
        Complete: "Dokončiť",
      },
      AnonymousDashboard: {
        RegistrationRequired:
          "Pre prístup k plnej verzii aplikácie sa prosím zaregistrujte",
        Register: "Zaregistrovať",
      },
      Redeem: {
        Step1: "1. Mincou zoškrabte kryciu vrstvu",
        Step2: "2. Opište 16-miestny kód z karty",
        NoCardYet: "Ešte nemáte kartu? Zakúpite ju",
      },
      RedeemPublic: {
        Step1: "1. Mincou zoškrabte kryciu vrstvu",
        Step2: "2. Opište 16-miestny kód z karty",
      },
      LeadInvitation: {
        Description:
          "Zadajte e-mail priateľa, ktorého chcete pozvať. Ak bude Váš priateľ účet aktívne využívať, dostanete za neho odmenu!",
      },
      ColdWallet: {
        WithdrawalTitle: "Výber zo systémovej peňaženky:",
        DepositTitle: "Vloženie na systémovú peňaženku:",
        GenerateAddress: "Generovať novú systémovú adresu",
      },
      SystemReport: {
        HotWallet: "+ Na Hot Wallet",
        ColdWallet: "+ Na Cold Wallet",
        ExchangeWithdrawal: " + K výberu z burzy ",
        UserAccounts: "- Na účtoch uživatelů",
        ControlSum: "Kontrolný súčet",
        SystemWalletWithdrawal: "K výberu zo systémovej peňaženky",
        ExchangeWithdrawalFee: "Poplatek za výber z burzy",
        BalanceOnExchange: "Zostatok {{currencyCode}} na burze",
        TradingVolume: "Obchodovaný objem",
        PerMonth: "Za mesiac",
        PerWeek: "Za týždeň",
        PurchasedBTC: "Nakúpené BTC",
        WithdrawnOrPending: "Vybrané alebo na výber",
        BTCLedgerSum: "Suma účetní knihy BTC",
        CZKLedgerSum: "Suma účetní knihy CZK",
        SystemVersion: "Verzia systému: {{version}}",
      },
      BankingAuth: {
        BankListTitle: "Ponuka bánk",
        BanksInPreparation: "Banky, ktoré pripravujeme",
      },
      Account: {
        ProfileError:
          "Ospravedlňujeme sa, pri zobrazovaní Vášho profilu nastala neočakávaná chyba, skúste to prosím znovu neskôr.",
      },
      Help: {
        HelpInPreparation: "Podrobnú nápovedu aktuálne pripravujeme.",
        ContactEmail:
          "V prípade otázok sa na nás môžete obrátiť písomne e-mailom na adresu:",
      },
      Error403: {
        Logout: "Odhlásiť sa",
      },
      CustomerAnonymousPaymentPay: {
        SignIn: "Prihláste sa.",
        ConfirmBox: {
          Title: "Účtenka už letí na Váš e-mail",
          Description:
            "Chcete nabudúce platiť jedným ťuknutím a mať všetky platby na jednom mieste? Vytvorte si vlastný {{appName}} účet, bude to raz-dva! 🚀",
          CreateAccountButton: "Vytvoriť účet",
          CloseButton: "Zavrieť",
        },
        TermsAgreement: {
          text: "Kliknutím na tlačidlo zaplatiť súhlasíte s",
          link: "{{apiUrl}}/content/terms/1-one-time-payment-docs.pdf",
          linkText: "Podmienkami AIS a PIS",
        },
        Steps: {
          detail: "Vitajte v {{appName}}",
          bank: "Pripojenie banky",
          account: "Platba s {{appName}}",
        },
        BankSelection: {
          InfoBox:
            'Vyberte si banku pre platbu cez {{appName}} podľa nášho "Hodnotenia bánk".',
          WarningBox:
            "Upozornenie: Kvalita pripojenia závisí od bánk. Ak máte problém s prihlásením alebo platbou, kontaktujte svoju banku.",
        },
        AccountSelection: {
          InfoBox:
            "Autorizujte platbu u vašej banky. Pri problémoch s autorizáciou kontaktujte svoju banku.",
        },
      },
      NotificationsManagement: {
        NewNotification: "Nová notifikácia",
        PlannedNotifications: "Plánované notifikácie",
        SentNotifications: "Odoslané notifikácie",
        DisabledNotifications: "Zrušené notifikácie",
        NoNotifications: "Žiadne notifikácie",
      },
      NotificationForm: {
        Name: "Názov",
        Description: "Popis",
        NotificationType: "Typ notifikácie",
        Duration: {
          FromDate: "Dátum zobrazenia",
          FromTime: "Čas zobrazenia",
          ToDate: "Dátum skrytia",
          ToTime: "Čas skrytia",
        },
        DurationType: {
          Dismiss: "Kým ju používateľ nezatvorí",
          Period: "Na určité časové obdobie",
        },
        DurationPrompt: "Ako dlho má zostať notifikácia zobrazená?",
        Filters: {
          Banks: "Len pre banky:",
          UserTypes: "Len pre používateľov:",
          BanksPlaceholder: "Žiadny filter bánk",
          UserTypesPlaceholder: "Žiadny filter používateľov",
        },
        Link: "Odkaz",
        Create: "Vytvoriť",
        Preview: "Náhľad",
      },
    },
  },
  Sentry: {
    FormTitle: "Nahlásiť chybu",
    NameLabel: "Meno",
    EmailLabel: "E-mail",
    MessageLabel: "Popis chyby",
    MessageCharCount: "{{count}} / {{maxCount}}",
    CancelButtonLabel: "Zrušiť",
    SubmitButtonLabel: "Odoslať",
    NamePlaceholder: "Vaše meno",
    EmailPlaceholder: "Váš e-mail",
    MessagePlaceholder: "Opíšte chybu",
    SuccessMessageText: "Ďakujeme za nahlásenie chyby.",
    ErrorMessageText: "Hlásenie sa nepodarilo odoslať. Skúste to prosím znova.",
    Validation: {
      MessageRequired: "Opíšte prosím chybu.",
      MessageTooShort: "Popis musí mať aspoň {{minLength}} znakov.",
      EmailInvalid: "Zadajte platný e-mail.",
    },
  },
  Support: {
    ButtonLabel: "Podpora",
    Contact: {
      PhoneNumber: "+420 226 633 296",
      Email: "info@mo.one",
      HunterEmail: "info@legi.one",
    },
    Choice: {
      Title: "Napíšte nám",
      Description:
        "Prosím špecifikujte svoju požiadavku alebo problém čo najpresnejšie, pomôže nám to odpovedať vám čo najskôr.",
      TechnicalProblemButton: "Technický problém",
      TechnicalProblemDescription:
        "Aplikácia spadne, platba neprejde, stránka sa nenačíta. Smeruje na vývojárov.",
      TechnicalProblemUnavailable:
        "Hlásenie chýb je momentálne nedostupné. Použite prosím požiadavku na podporu.",
      SupportRequestButton: "Požiadavka na podporu",
      SupportRequestDescription:
        "Fakturácia, účet, objednávky, ako niečo funguje. Odpovie zákaznícka podpora.",
      UrgentHelp: "Pospiechate?",
      CallPhone: "Volajte {{phoneNumber}}",
    },
    Request: {
      Title: "Požiadavka na podporu",
      CategoryLabel: "Kategória požiadavky",
      CategoryPlaceholder: "Vyberte kategóriu",
      SubjectLabel: "Názov požiadavky",
      DescriptionLabel: "Popis",
      DescriptionCharCount: "{{count}} / {{maxCount}}",
      AttachmentLabel: "Príloha",
      AttachmentPlaceholder: "Nahrať súbor",
      AttachmentRemove: "Odobrať prílohu",
      NameLabel: "Meno a priezvisko",
      EmailLabel: "E-mail",
      SubmitButton: "Odoslať",
      CancelButton: "Zrušiť",
      Categories: {
        ClientOnboarding: "Onboarding klientov",
        CommissionsAndPayouts: "Provízie a výplaty",
        ValorPoints: "Valor body",
        TechnicalIssues: "Technické problémy (prihlásenie / apka)",
        StardustPoints: "Stardust body",
        PaymentIssues: "Problémy s platbou",
        AccountAndSignIn: "Prihlásenie a správa účtu",
        TransactionComplaints: "Transakčné reklamácie",
        HardwareAndConnectivity: "Hardware a konektivita",
        FinanceAndSettlement: "Financie a vyúčtovanie",
        AccountAdministration: "Administratíva a správa účtu",
        Other: "Ostatné",
      },
      Validation: {
        CategoryRequired: "Vyberte kategóriu požiadavky.",
        SubjectRequired: "Zadajte názov požiadavky.",
        DescriptionRequired: "Zadajte popis požiadavky.",
        DescriptionTooShort: "Popis musí mať aspoň {{minLength}} znakov.",
        NameRequired: "Zadajte meno a priezvisko.",
        EmailRequired: "Zadajte e-mail.",
        EmailInvalid: "Zadajte platný e-mail.",
        AttachmentTooLarge: "Súbor môže mať najviac {{maxSizeMb}} MB.",
        AttachmentTypeNotSupported: "Podporované formáty sú PNG, JPG a PDF.",
      },
      SuccessMessage: "Požiadavka bola odoslaná. Ozveme sa vám čo najskôr.",
      ErrorMessage: "Požiadavku sa nepodarilo odoslať. Skúste to prosím znova.",
      RateLimitedMessage:
        "Odoslali ste príliš veľa požiadaviek. Skúste to prosím o chvíľu.",
    },
    ContentReport: {
      Title: "Nahlásiť obsah",
      PickerButton: "Nahlásiť profil alebo správu",
      PickerDescription:
        "Profil alebo správa, ktoré porušujú zákon alebo naše podmienky. Posudzuje tím Mo.one podľa nariadenia o digitálnych službách (DSA).",
      TargetProfile: "Nahlasujete profil {{user}}.",
      TargetMessage: "Nahlasujete správu od {{user}}.",
      HandleLabel: "Používateľské meno nahlasovaného profilu",
      HandlePlaceholder: "napr. jan.novak",
      MessageHint:
        "Správu v chate nahlásite priamo pri nej – otvorte ponuku správy a zvoľte Nahlásiť.",
      CategoryLabel: "Dôvod nahlásenia",
      CategoryPlaceholder: "Vyberte dôvod",
      ExplanationLabel: "Odôvodnenie",
      ExplanationHelper:
        "Opíšte čo najpresnejšie, čo je na obsahu zlé – čo presne obsahuje a ak ho považujete za nezákonný, aký zákon porušuje.",
      NameLabel: "Meno a priezvisko",
      EmailLabel: "E-mail",
      ContactOptionalNote:
        "Pri sexuálnom zneužívaní detí môžete oznámenie podať anonymne. Bez e-mailu vám však nebudeme môcť oznámiť výsledok.",
      BonaFideLabel:
        "Vyhlasujem, že informácie a tvrdenia v tomto oznámení sú podľa môjho najlepšieho vedomia presné a úplné.",
      LegalNote:
        "Potvrdenie o prijatí a rozhodnutie vám zašleme e-mailom. Oznámenia spracúvame podľa čl. 16 nariadenia (EÚ) 2022/2065 (DSA).",
      SubmitButton: "Odoslať oznámenie",
      CancelButton: "Zrušiť",
      Categories: {
        ChildSexualAbuse: "Sexuálne zneužívanie detí",
        ThreatsOrViolence: "Vyhrážky, násilie alebo terorizmus",
        HateSpeech: "Nenávistné prejavy",
        FraudOrScam: "Podvod alebo scam",
        Impersonation: "Vydávanie sa za niekoho iného",
        PersonalDataOrPrivacy: "Zneužitie osobných údajov alebo súkromia",
        IntellectualProperty:
          "Porušenie autorských práv alebo ochrannej známky",
        OtherIllegal: "Iný nezákonný obsah",
        HarassmentOrBullying: "Obťažovanie alebo šikana",
        SpamOrUnwantedContact: "Spam alebo nevyžiadaný kontakt",
        OtherTermsViolation: "Iné porušenie podmienok",
      },
      Validation: {
        CategoryRequired: "Vyberte dôvod nahlásenia.",
        HandleRequired: "Zadajte používateľské meno nahlasovaného profilu.",
        ExplanationRequired: "Zadajte odôvodnenie.",
        ExplanationTooShort: "Odôvodnenie musí mať aspoň {{minLength}} znakov.",
        NameRequired: "Zadajte meno a priezvisko.",
        EmailRequired: "Zadajte e-mail.",
        EmailInvalid: "Zadajte platný e-mail.",
        BonaFideRequired:
          "Bez tohto vyhlásenia nie je možné oznámenie odoslať.",
      },
      SuccessMessage:
        "Oznámenie bolo prijaté. Posúdime ho bez zbytočného odkladu a o výsledku vás budeme informovať e-mailom.",
      SuccessMessageWithReference:
        "Oznámenie bolo prijaté pod číslom {{referenceNumber}}. Potvrdenie sme vám poslali e-mailom; o výsledku vás budeme informovať.",
      ErrorMessage: "Oznámenie sa nepodarilo odoslať. Skúste to prosím znova.",
      NotFoundMessage:
        "Tento profil sme nenašli. Skontrolujte používateľské meno.",
      SelfReportMessage: "Vlastný obsah nie je možné nahlásiť.",
      RateLimitedMessage:
        "Odoslali ste príliš veľa oznámení. Skúste to prosím o chvíľu.",
    },
    Result: {
      ErrorTitle: "Niečo sa nepodarilo",
    },
  },
  Employee: {
    Create: {
      Title: "Pridat zamestnanca",
      CreateButton: "Pridat zamestnanca",
      CreateError: "Pri vytváraní zamestnanca nastala chyba.",
      CreateSuccess: "Zamestnanec bol vytvorený",
      MissingMerchantID: "Chyba - ID obchodníka nie je k dispozícii.",
      Legend: "Nový zamestnanec",
    },
    EmployeeStatus: {
      Inactive: "Neaktívny",
      InvitedWaitingForConfirmation: "Pozvaný, čaká na potvrdenie",
      Active: "Aktívny",
      Created: "Vytvorený",
    },
    Detail: {
      Title: "Detail zamestnanca",
      NoEmployeeSelectedError:
        "Chyba - Zamestnanec nie je vybraný alebo neexistuje",
      EmployeeNotFoundError: "Chyba - Zamestnanec neexistuje",
      SendAccess: "Poslať prístup",
      CancelInvitation: "Zrušiť pozvánku",
      CancelInvitationConfirmText:
        "Pozvánka bude stiahnutá a zamestnanec ju už nebude môcť prijať. Novú pozvánku môžete poslať kedykoľvek.",
      RemoveEmployee: "Odobrať zamestnanca",
      RemoveEmployeeConfirmText:
        "Zamestnanec stratí prístup k vašej firme a nebude sa môcť prepnúť do zamestnaneckého kontextu. Záznam zostane v zozname ako neaktívny a prístup mu môžete kedykoľvek poslať znova.",
      RemovedInfo:
        "Zamestnanec bol odobratý. Odoslaním prístupu ho môžete pozvať znova.",
      SaveError: "Pri ukladaní zmien nastala chyba.",
      SaveSuccess: "Zmeny boli úspešne uložené.",
      AccessSent: "Prístup byl odeslán",
    },
    List: {
      LoadingError: "Seznam zamestnancov sa nepodarilo načítať.",
      AddEmployee: "Pridat zamestnanca",
      FilterLabels: {
        Created: "Vytvorený",
        InvitedWaitingForConfirmation: "Odeslaný přístup",
        Active: "Aktívny",
        Inactive: "Neaktívny",
      },
    },
    Dashboard: {
      Title: "Priehľad",
    },
    KeypadPayment: {
      Title: "Platba na pokladnici",
      ComingSoon: "Platbu pripravujeme.",
    },
  },
  TransactionErrors: {
    UnknownError: "Pri spracovaní transakcie sa vyskytla neznáma chyba",
    UnknownPaymentError: "Neznáma chyba počas platby",
    TransactionNotFound: "Transakcia neexistuje alebo je nedostupná",
    BankTemporarilyUnavailable:
      "Banka je momentálne nedostupná, skúste to prosím o chvíľu znova.",
    BankConnectionExpired:
      "Prepojenie s bankou vypršalo, prepojte prosím účet znova.",
    InsufficientBalance: "Nedostatočný zostatok na účte",
    BalanceVerificationFailed: "Nepodarilo sa overiť zostatok na účte",
    SameAccountError: "Účet odosielateľa a príjemcu nemôže byť rovnaký",
    InvalidAccountCurrency: "Neplatná mena účtu",
    InvalidTransactionCurrency: "Neplatná mena transakcie",
    TransactionTypeNotAllowed: "Transakcia pre tento typ účtu nie je povolená",
    TransactionLimitExceeded: "Bol prekročený limit transakcií",
    UnspecifiedError: "Nastala nešpecifikovaná chyba.",
    TransactionProcessingFailed:
      "Transakciu sa nepodarilo spracovať, alebo už bola uhradená",
    UnspecifiedPaymentError: "Nastala nešpecifikovaná chyba",
    BankAccount: "Nie je nastavený primárny bankový účet.",
    User: "{{appName}} Lite používatelia môžu platbu poslať len obchodníkom",
    InvalidBankAccountForReceivingPayment:
      "Vybraný bankový účet nemôže prijímať platby",
    ActiveTransactionExists:
      "Na tomto paypointe už existuje aktívna transakcia. Počkajte, kým sa dokončí, pred iniciovaním novej.",
    AuthLimitExceeded: "Prekročený limit autorizácií",
    InvalidJsonFormat: "Neplatný formát JSON",
    GeneralRejection: "Transakcia bola zamietnutá",
    NotUniqueTransactionReference: "Neunikátne referenčné číslo transakcie",
    InvalidCharacterSet: "Neplatná znaková sada transakcie",
    InvalidAccountNumber: "Neplatné číslo účtu príjemcu alebo odosielateľa",
    FieldInvalid: "Hodnota poľa je neplatná",
    FieldMissing: "Chýbajúce povinné pole",
    TransactionAmountForbidden: "Zakázaná výška sumy transakcie",
    AccountInvalid: "Účet príjemcu alebo odosielateľa je neplatný",
    TransactionDecimalNumbersForbidden: "Zakázaný počet desatinných miest",
    InvalidDate: "Neplatný dátum transakcie",
    TransactionInvalidIBAN: "Neplatné IBAN príjemcu",
    InstantPaymentsNotAvailable: "Instantné platby nie sú dostupné",
    TransactionNotSignable: "Transakciu nie je možné autorizovať",
    DebtorBankAccountForbidden:
      "Účet odosielateľa nie je pre túto transakciu povolený.",
    PaymentLimitExceeded: "Platba sa nepodarila – na účte je prekročený limit.",
    PaymentRejectedByBank: "Platba bola bankou zamietnutá.",
    PaymentCancelledByUser: "Platba nebola v banke potvrdená.",
    PaymentExpired: "Platba nebola dokončená včas a bola zrušená.",
    PaymentUnauthorized:
      "Banka platbu neautorizovala. Pripojte účet znova a skúste to prosím ešte raz.",
    PaymentTechnicalError:
      "Platba sa nepodarila kvôli technickej chybe. Skúste to prosím znova, prípadne kontaktujte podporu.",
    DebtorCreditorAccountIdentical: "Účet príjemcu a platiteľa je totožný",
    TransactionLimits: {
      generatedTransactionLimitExceeded:
        "Generovaná platba presahuje limit na 1 transakciu.",
      oneTimeSendLimitExceeded: "Suma presahuje limit na 1 transakciu.",
      dailySendLimitExceeded: "Suma transakcie presahuje denný limit.",
      generatedDailySendLimitExceeded:
        "Suma generovanej transakcie presahuje denný limit.",
      monthlySendLimitExceeded:
        "Suma transakcie presahuje celkový mesačný limit.",
      generatedMonthlySendLimitExceeded:
        "Suma generovanej transakcie presahuje mesačný limit.",
      generatedTransactionLimitExceededIncompleteRegistration:
        "Generovaná platba presahuje limit na 1 transakciu. Prosím dokončite registráciu.",
      oneTimeSendLimitExceededIncompleteRegistration:
        "Suma presahuje limit na 1 transakciu. Prosím dokončite registráciu.",
      dailySendLimitExceededIncompleteRegistration:
        "Suma transakcie presahuje denný limit. Prosím dokončite registráciu.",
      generatedDailySendLimitExceededIncompleteRegistration:
        "Suma generovanej transakcie presahuje denný limit. Prosím dokončite registráciu.",
      monthlySendLimitExceededIncompleteRegistration:
        "Suma transakcie presahuje mesačný limit. Prosím dokončite registráciu.",
      generatedMonthlySendLimitExceededIncompleteRegistration:
        "Suma generovanej transakcie presahuje mesačný limit. Prosím dokončite registráciu.",
      oneTimeReceiveLimitExceededPreApproval:
        "Platba presahuje limit na jednu platbu v rámci predschválenia.",
      cumulativeReceiveLimitExceededPreApproval:
        "Platba by prekročila celkový limit pre príjem v rámci predschválenia. Vyššie sumy budete môcť prijímať, hneď ako bude váš bankový účet overený.",
      currencyNotSupportedPreApproval:
        "V rámci predschválenia môžete prijímať platby iba v CZK. Platby v iných menách budete môcť prijímať, hneď ako bude váš bankový účet overený.",
      unspecifiedError: "Nastala nespecifikovaná chyba.",
    },
    TransactionNotFoundOrNotAccessible:
      "Transakcia {{transactionPublicID}} neexistuje alebo nie je dostupná.",
    Status: "Transakcia bola zrušená.",
    TransactionAlreadyCompleted: "Tato transakcia už bola dokončená.",
    TransactionCancelled: "Tato transakcia bola zrušená.",
    TransactionExpired:
      "Platnosť platby vypršala. Požiadajte príjemcu o vystavenie novej platby.",
  },
  Campaigns: {
    Campaign: {
      DefaultHeader: "Podporte túto kampaň",
      DefaultLearnMore: "Zistiť viac",
      DonationForm: {
        AmountLabel: "Zadajte darovanú sumu",
        AmountRequired: "Zadajte sumu",
        AmountMin: "Suma musí byť aspoň {{minAmount}} {{currencySymbol}}",
        SubmitButton: "Darovať",
        TransactionError:
          "Nepodarilo sa vytvoriť transakciu. Skúste to prosím znovu.",
      },
      Page: {
        Loading: "Načítanie...",
        CampaignNotFound: "Kampaň nenájdená",
        CampaignNotFoundMessage:
          "Kampaň nebola nájdená alebo už nie je k dispozícii.",
        StatusNotStarted: "Kampaň ešte nezačala",
        StatusNotStartedWithDate:
          "Táto kampaň začne {{date}}. Vráťte sa prosím neskôr, aby ste mohli darovať.",
        StatusNotStartedWithoutDate: "Táto kampaň ešte nezačala.",
        StatusFinished: "Kampaň skončila",
        StatusFinishedWithDate:
          "Táto kampaň skončila {{date}}. Ďakujeme za váš záujem!",
        StatusFinishedWithoutDate:
          "Táto kampaň skončila. Ďakujeme za váš záujem!",
        EndsOn: "Končí {{date}}",
        DonationsNotAvailable: "V tejto chvíli nie je možné poslať príspevok.",
      },
      CreateAccountButton: "VYTVORIŤ ÚČET V JEDNOM KLIKU",
      InfoCards: {
        HelpingNeedy: {
          Title: "Pomáhame potrebným",
          Description:
            "Postupne pridávame nadácie, ktorým s {{appName}} pomáhame.",
        },
        TestingPayment: {
          Title: "Testovanie platobnej metódy",
          Description:
            "Pomôžete otestovať novú platobnú metódu českej spoločnosti {{appName}}, ktorá pomáha udržať peniaze v ČR.",
        },
        CreateAccountAndHelp: {
          Title: "Vytvorte si účet a pomáhajte",
          Description:
            "Vytvorte si účet, platte s {{appName}} a my za každú vašu platbu prispievame na vámi vybranú organizáciu.",
        },
      },
      TimelineSteps: {
        Donate: {
          Title: "Darujte ľubovoľnú sumu vybranej organizácii",
        },
        JoinTeam: {
          Title: "Vytvorte si účet a pridajte sa do tímu {{campaignName}}!",
          Description:
            "Vytvorením účtu získate možnosť platiť s {{appName}}, súťažiť v rámci súťaže Stardust a pomáhať tímu {{campaignName}}.",
        },
        PayAtCafe: {
          Title: "Plaťte s {{appName}} vo vašej obľúbenej kaviarni",
          Description: "ADD TEXT LATER",
        },
        AnyMethod: {
          Title: "Hotovosť, karta? Len s {{appName}}!",
          Description: "ADD TEXT LATER",
        },
      },
    },
  },
  Notifications: {
    Variants: {
      Critical: "Kritické upozornenie",
      Error: "Chyba",
      Announcement: "Oznámenie",
      Completed: "Dokončené",
      Stardust: "Stardust/Valor",
      Raffle: "Žrebovanie",
    },
  },
  UserMenu: {
    MooneLiteInfo:
      "Ak by ste boli registrovaní, tak {{appName}} platí za to, že platíte.",
    ManageAccount: "Spravovať účet {{appName}}",
    Invitations: "Pozvánky",
    Logout: "Odhlásiť sa",
    Rewards: {
      TotalRewards: "Celkové odmeny",
      TotalStardust: "Stardust celkom",
      TotalValor: "Valor celkom",
      MyShare: "Môj podiel",
      OpenRewardsDetails: "Otvoriť detaily odmeny",
    },
    Notifications: {
      Title: "Notifikácie",
      NoNewNotifications: "Žiadne nové notifikácie",
      NoNotifications: "Žiadne notifikácie",
      Today: "Dnes",
      Yesterday: "Včera",
      Older: "Staršie",
      ShowAll: "Všetky notifikácie",
      DeleteAll: "Zmazať všetky",
    },
  },
  Raffle: {
    Notifications: {
      Title: "Žrebovanie o ceny",
      Registration:
        "Získal/a si {{count}} žrebov do žrebovania za dokončenie registrácie.",
      Registration_one:
        "Získal/a si {{count}} žreb do žrebovania za dokončenie registrácie.",
      Registration_few:
        "Získal/a si {{count}} žreby do žrebovania za dokončenie registrácie.",
      Registration_other:
        "Získal/a si {{count}} žrebov do žrebovania za dokončenie registrácie.",
      Referral:
        "Získal/a si {{count}} žrebov do žrebovania — tvoj pozvaný dokončil registráciu.",
      Referral_one:
        "Získal/a si {{count}} žreb do žrebovania — tvoj pozvaný dokončil registráciu.",
      Referral_few:
        "Získal/a si {{count}} žreby do žrebovania — tvoj pozvaný dokončil registráciu.",
      Referral_other:
        "Získal/a si {{count}} žrebov do žrebovania — tvoj pozvaný dokončil registráciu.",
      Payment:
        "Získal/a si {{count}} žrebov do žrebovania za platbu u obchodníka.",
      Payment_one:
        "Získal/a si {{count}} žreb do žrebovania za platbu u obchodníka.",
      Payment_few:
        "Získal/a si {{count}} žreby do žrebovania za platbu u obchodníka.",
      Payment_other:
        "Získal/a si {{count}} žrebov do žrebovania za platbu u obchodníka.",
    },
    Dashboard: {
      Title: "Žrebovanie o ceny",
      TicketCount: "Tvoje žreby",
      DrawDate: "Žrebovanie",
      DateToBeAnnounced: "Dátum bude upresnený",
      ShowDetail: "Zobraziť detail",
      CompetitionsRunning: "Prebieha {{count}} súťaží",
      CompetitionsRunning_one: "Prebieha {{count}} súťaž",
      CompetitionsRunning_few: "Prebiehajú {{count}} súťaže",
      CompetitionsRunning_other: "Prebieha {{count}} súťaží",
    },
    Page: {
      Title: "Žrebovanie",
      NotRunning: "Momentálne neprebieha žiadne žrebovanie.",
      LoadError: "Žrebovanie sa nepodarilo načítať.",
      MainDraw: "Hlavné žrebovanie",
      MyTickets: "Tvoje žreby",
      MoveTickets: "Presunúť žreby",
      DrawDate: "Dátum žrebovania",
      Rewards: "Výhry",
      History: "Predchádzajúce žrebovania",
      HistoryEmpty: "Zatiaľ si sa žiadneho žrebovania nezúčastnil/a.",
      HistoryTickets: "{{count}} žrebov",
      HistoryTickets_one: "{{count}} žreb",
      HistoryTickets_few: "{{count}} žreby",
      HistoryTickets_other: "{{count}} žrebov",
      Drawn: "Vyžrebované",
    },
    MoveDialog: {
      Title: "Presunúť žreby",
      TargetLabel: "Do súťaže",
      CountLabel: "Počet žrebov",
      CountHelper: "Zadaj počet od 1 do {{max}}",
      Submit: "Presunúť",
      MovedToast: "Presunutých {{count}} žrebov",
      MovedToast_one: "Presunutý {{count}} žreb",
      MovedToast_few: "Presunuté {{count}} žreby",
      MovedToast_other: "Presunutých {{count}} žrebov",
      MoveError: "Presun žrebov sa nepodaril",
      NothingMoved: "Nič sa nepresunulo — tvoje žreby sa medzitým zmenili.",
      CompetitionsChanged:
        "Súťaže sa medzitým zmenili — nič sa nepresunulo. Skontroluj aktuálny stav.",
    },
  },
  Chat: {
    Title: "{{appName}} Chat",
    FindPeople: "Nájsť ľudí",
    ReadBy: "Zobrazené: {{count}}",
    SelectConversation: "Vyberte konverzáciu",
    ClosedConversation: "Táto konverzácia je uzavretá.",
    Unavailable: "Chat zatiaľ nie je pre váš účet dostupný.",
    DisclosedNamesUnavailable:
      "Mená sa nepodarilo načítať – niektorí ľudia sa môžu zatiaľ zobrazovať len ako @handle.",
    BackToDashboard: "Späť na {{appName}}",
    PushNotifications: {
      DeviceToggleLabel: "Upozornenia na správy na tomto zariadení",
      DeviceToggleDescription:
        "Upozorníme vás na nové správy, aj keď je aplikácia zatvorená.",
      DeniedHint:
        "Oznámenia pre {{appName}} sú vypnuté. Zapnete ich v nastaveniach systému.",
    },
    Thread: {
      Title: "Vlákno",
    },
    FindInConversation: {
      MenuItem: "Hľadať v konverzácii",
      Placeholder: "Hľadať v tejto konverzácii",
      Counter: "{{current}} z {{total}}",
      NoMatches: "Žiadne zhody",
      Older: "Staršia zhoda",
      Newer: "Novšia zhoda",
      Close: "Zavrieť hľadanie",
      JumpError: "Na správu sa nepodarilo prejsť, skúste to prosím znova",
      SearchError: "Vyhľadávanie zlyhalo",
    },
    HandleGate: {
      Title: "Zvoľte si prezývku",
      Description: "Podľa nej vás ostatní v Chate nájdu a môžu vám napísať.",
    },
    Reactions: {
      Title: "Reakcie",
    },
    PhoneGate: {
      Title: "Overenie telefónneho čísla",
      DescriptionVerify:
        "Pre používanie chatu prosím overte svoje telefónne číslo. Pomáha to chrániť chat pred spamom a falošnými účtami.",
      DescriptionAdd:
        "Pre používanie chatu prosím zadajte a overte svoje telefónne číslo. Pomáha to chrániť chat pred spamom a falošnými účtami.",
      PhoneLabel: "Telefónne číslo",
      SendCode: "Odoslať kód",
      CodeSent: "Kód odoslaný na {{phone}}",
      Verify: "Overiť",
      EditPhone: "Zmeniť telefónne číslo",
      ResendCode: "Odoslať znovu",
      SmsFailed: "Nepodarilo sa odoslať overovací kód",
      TooManyAttempts: "Príliš veľa pokusov, skúste to prosím neskôr",
      WrongCode: "Nesprávny kód. Vyžiadajte si prosím nový.",
      VerifySuccess: "Telefónne číslo bolo úspešne overené",
    },
    Layout: {
      SearchPlaceholder: "Vyhľadať...",
    },
    Categories: {
      All: "Všetko",
      Mutual: "Vzájomní",
      Shopping: "Nákupy",
      Merchants: "Obchodníci",
      Groups: "Skupiny",
      Requests: "Žiadosti",
    },
    NoChannels: "Zatiaľ tu nič nie je",
    NoSearchResults: "Hľadaniu nezodpovedá žiadna konverzácia",
    NewChat: {
      Title: "Nová konverzácia",
      DirectTitle: "Nový chat",
      CreateGroupWith: "Vytvoriť skupinový chat s {{name}}",
      GroupTitle: "Nová skupinová konverzácia",
      OpenError: "Konverzáciu sa nepodarilo otvoriť. Skúste to prosím znova.",
      PrivateSenderNotice:
        "Váš profil je súkromný – osoba, ktorej napíšete, uvidí vaše meno.",
      RemoveMember: "Odstrániť {{name}}",
      SearchPlaceholder: "Hľadať podľa @handle alebo mena",
      MembersLabel: "Členovia",
      SuggestionsLabel: "Návrhy",
      ResultsLabel: "Výsledky hľadania",
      EligibilityLabel: "Kto sa môže pripojiť",
      EligibilityAnyone: "Ktokoľvek (Moone Lite aj Full Moone)",
      EligibilityFullMooneOnly: "Iba overení používatelia (Full Moone)",
      FullMooneOnlyBadge: "Iba overení používatelia",
      CreateError: "Skupinu sa nepodarilo vytvoriť. Skúste to prosím znova.",
      CreateIneligibleMemberError:
        "Niekto z vybraných nie je overený používateľ (Full Moone) a do skupiny len pre overených sa nemôže pripojiť.",
      IneligibleSelectedWarning:
        "Sivo zobrazení ľudia nie sú overení používatelia (Full Moone) a do skupiny len pre overených sa nemôžu pripojiť. Odstráňte ich alebo povoľte pripojenie komukoľvek.",
      CustomerSelectedWarning:
        "Zosivení ľudia sú zákazníci. Obchodníci a hunteri nemôžu zákazníkov osloviť ani pridať do skupiny, najprv musí kontaktovať zákazník vás. Odstráňte ich, aby ste mohli pokračovať.",
      GroupNameLabel: "Názov skupiny",
      ChannelNamePlaceholder: "Názov konverzácie (voliteľné)",
      NoResults: "Žiadne výsledky",
      UnknownUser: "Neznámy používateľ",
      Cancel: "Zrušiť",
      Create: "Vytvoriť",
    },
    Members: {
      Title: "Členovia",
      You: "Vy",
      AddTitle: "Pridať člena",
      Add: "Pridať",
      Cancel: "Zrušiť",
      AddError: "Nepodarilo sa pridať člena",
      Remove: "Odobrať",
      RemoveError: "Nepodarilo sa odobrať člena",
      Owner: "Vlastník",
      AlreadyMember: "Už je členom",
      NotFullMoone: "Neoverený",
      CustomerWritesFirst: "Kontaktuje prvý zákazník",
      LeaveChannel: "Opustiť kanál",
      LeaveConfirmTitle: "Opustiť kanál?",
      LeaveConfirmMessage:
        "Naozaj chcete opustiť tento kanál? Prestanete dostávať správy z tejto konverzácie.",
      Leave: "Opustiť",
      LeaveError: "Nepodarilo sa opustiť kanál",
    },
    Roles: {
      Customer: "Používateľ",
      Merchant: "Obchodník",
      Hunter: "Hunter",
      HunterPlus: "Hunter",
      Admin: "Administrátor",
      CustomerOnboarding: "Zákaznícka podpora",
    },
    Rename: {
      Title: "Premenovať konverzáciu",
      Save: "Uložiť",
      Cancel: "Zrušiť",
      Error: "Nepodarilo sa premenovať konverzáciu",
    },
    Requests: {
      Accept: "Prijať",
      Reject: "Odmietnuť",
      RequestMessage: "{{name}} chce s vami chatovať",
      AcceptError: "Nepodarilo sa prijať žiadosť o chat",
      RejectError: "Nepodarilo sa odmietnuť žiadosť o chat",
      ShowRejected: "Odmietnuté pozvánky",
      ShowPending: "Späť na žiadosti",
      Join: "Pripojiť sa",
      JoinError: "Nepodarilo sa pripojiť ku kanálu",
      RejectedMessage: "Túto pozvánku ste odmietli",
    },
    PaymentRequest: {
      Pending: "Čaká na platbu",
      Pay: "Zaplatiť",
      Drawer: {
        Title: "Požiadavka na platbu",
        BankAccount: "Bankový účet",
        Amount: "Suma",
        Note: "Pridať poznámku",
        NotePlaceholder: "Text poznámky",
        Submit: "Odoslať požiadavku",
        Error: "Nepodarilo sa vytvoriť požiadavku",
        InvalidCurrency:
          "Vybraný účet je vedený v inej mene, než v ktorej je možné požiadavku vytvoriť",
        Validation: {
          SelectBankAccount: "Vyberte bankový účet",
          EnterAmount: "Zadajte sumu",
          AmountMustBePositive: "Suma musí byť kladná",
        },
      },
    },
    DirectPayment: {
      Sent: "Odoslaná platba",
      Received: "Prijatá platba",
      Drawer: {
        Title: "Priama platba",
        BankAccount: "Bankový účet",
        Amount: "Suma",
        Note: "Pridať poznámku",
        NotePlaceholder: "Text poznámky",
        Submit: "Odoslať platbu",
        Error: "Nepodarilo sa odoslať platbu",
        RecipientNoPrimaryAccount:
          "Príjemca nemá aktívny primárny bankový účet",
        InvalidCurrency: "Účet príjemcu je vedený v inej mene",
        RecipientCurrencyNotSupported:
          "Príjemca zatiaľ môže prijímať platby iba v CZK",
        RecipientLimitExceeded:
          "Príjemca by touto platbou prekročil svoj limit pre prijímanie platieb",
        NotChannelMember: "Platbu môžete poslať len členovi tejto konverzácie",
        MessageNotPosted:
          "Platba bola odoslaná, ale nepodarilo sa ju zverejniť v konverzácii",
      },
    },
    MultiPayerRequest: {
      Description: "Požiadavka na platbu pre všetkých",
      ThreadTitle: "Skupinová platba",
      Pay: "Zaplatiť",
      Close: "Uzavrieť",
      CloseError: "Požiadavku sa nepodarilo uzavrieť",
      Closed: "Uzavreté",
      Unavailable: "Nedostupné",
      Payments: {
        Count: "{{count}} platieb",
        Count_one: "{{count}} platba",
        Count_few: "{{count}} platby",
        Count_other: "{{count}} platieb",
      },
      Drawer: {
        Title: "Požiadavka na platbu",
        Amount: "Suma za osobu",
        Hint: "Každý člen skupiny môže túto sumu zaplatiť na váš hlavný účet, a to aj opakovane. Platby sa zobrazia pod požiadavkou.",
        Submit: "Odoslať požiadavku",
        Error: "Požiadavku sa nepodarilo odoslať",
      },
    },
    PaymentMenu: {
      DirectPayment: "Odoslať platbu",
      PaymentRequest: "Zaplať mi",
      LiteRestriction:
        "Platby v chate budú dostupné po dokončení Vašej registrácie.",
      LiteBankRestriction:
        "Vaše osobné údaje a doklad totožnosti už máme. Platby v chate budú dostupné po pripojení a overení Vášho bankového účtu.",
      LitePayUnavailable: "Na zaplatenie dokončite registráciu",
      RecipientNotFullMoone:
        "Tento používateľ zatiaľ nedokončil registráciu, preto mu nie je možné poslať platbu.",
    },
    TransactionStatus: {
      Created: "Vytvorené",
      Initiated: "Zahájené",
      Processing: "Spracovanie",
      Success: "Úspech",
      Fail: "Zlyhanie",
      Cancelled: "Zrušené",
      Unknown: "Neznámy",
    },
    Preview: {
      PaymentRequest: "Požiadavka na platbu",
      DirectPayment: "Priama platba",
    },
    PushCaption: {
      PaymentRequest: "Požiadavka na platbu",
      DirectPaymentSent: "Odoslané",
    },
  },
  Admin: {
    Terminals: {
      PageTitle: "Terminály",
      Table: {
        SerialNumber: "Sériové číslo",
        Tid: "TID",
        Mid: "MID",
        HardwareModel: "Typ terminálu",
        Status: "Stav",
        Financing: "Financovanie",
        Hunter: "Hunter",
        Merchant: "Obchodník",
        Facility: "Prevádzka",
        PurchasePrice: "Kúpna cena",
        LastChangedAt: "Posledná zmena",
        Ship: "Odoslať",
      },
      Status: {
        InStock: "Sklad",
        AssignedToHunter: "U Huntera",
        AssignedToMerchant: "Priradené",
        Shipped: "Odoslané",
        WithMerchant: "U Obchodníka",
        Deployed: "Nasadený",
        Returned: "Vrátený",
      },
      Financing: {
        Moone: "Mo.one",
        Hunter: "Hunter",
      },
      Form: {
        SerialNumber: "Sériové číslo",
        HardwareModel: "Typ terminálu",
        PurchasePrice: "Kúpna cena",
        Currency: "Mena",
        Status: "Stav",
        AddTitle: "Pridať terminál",
        Save: "Uložiť",
        Cancel: "Zrušiť",
        Delete: "Zmazať",
      },
      AssignHunter: {
        HunterLabel: "Hunter",
        SearchHint: "Meno, firma alebo e-mail",
        NoOptions: "Žiadni hunteri nenájdení",
      },
      Validation: {
        SerialNumberRequired: "Sériové číslo je povinné",
        HardwareModelRequired: "Typ terminálu je povinný",
      },
      Audit: {
        Title: "História zmien",
        Empty: "Zatiaľ žiadne zmeny",
        When: "Kedy",
        Field: "Pole",
        Change: "Zmena",
        Who: "Kto",
      },
      Messages: {
        LoadError: "Nepodarilo sa načítať terminály",
        UpdateSuccess: "Terminál bol uložený",
        CreateSuccess: "Terminál bol pridaný",
        UpdateError: "Uloženie terminálu sa nepodarilo",
        DuplicateSerialNumber: "Terminál s týmto sériovým číslom už existuje",
        DeleteSuccess: "Terminál bol zmazaný",
        DeleteError: "Zmazanie terminálu sa nepodarilo",
        DeleteConfirm:
          "Naozaj chcete zmazať terminál {{serialNumber}}? Použite len pre záznamy, ktoré vznikli omylom.",
        ShipSuccess: "Terminál bol označený ako odoslaný",
        ShipError: "Terminál sa nepodarilo označiť ako odoslaný",
      },
    },
    SsoClients: {
      PageTitle: "SSO aplikácie",
      CreateButton: "Registrovať aplikáciu",
      Table: {
        ClientId: "Client ID",
        DisplayName: "Názov",
        Type: "Typ",
        Confidential: "S backendom",
        Public: "Verejná (PKCE)",
        RedirectUris: "Redirect URI",
        AllowedRoles: "Smie konať ako",
        AllowedScopes: "Oblasti API",
        Actions: "Akcie",
        RotateSecret: "Vygenerovať nový secret",
        Delete: "Zmazať",
      },
      Form: {
        CreateTitle: "Registrovať aplikáciu",
        EditTitle: "Upraviť aplikáciu {{clientId}}",
        ClientId: "Client ID",
        DisplayName: "Názov (zobrazí sa používateľovi pri súhlase)",
        IsConfidential: "Aplikácia má vlastný backend (dostane client secret)",
        IsConfidentialHint:
          "Bez backendu (SPA, mobil) je aplikácia verejná: iba PKCE, bez secretu, nemôže konať za používateľa. Typ sa neskôr nedá zmeniť.",
        RedirectUris: "Redirect URI",
        RedirectUrisHint:
          "Presná zhoda, https (http iba pre localhost). Enter pridá ďalšiu.",
        PostLogoutRedirectUris: "Redirect URI po odhlásení",
        AllowedRoles: "Roly, za ktoré smie konať",
        AllowedRolesHint:
          "Prázdne = aplikácia iba prihlasuje. S rolou dostane výmenu za kontextový token.",
        AllowedScopes: "Oblasti API (scopes)",
        AllowedScopesHint:
          "Čo smie aplikácia volať. Scopy „Aplikácia: …“ sú pre backend bez používateľa (client_credentials), ostatné pre konanie za prihláseného používateľa. Prázdne = iba prihlásenie a kontexty.",
        ListPlaceholder: "Napíšte hodnotu a stlačte Enter",
        Submit: "Registrovať",
        Save: "Uložiť",
        Cancel: "Zrušiť",
      },
      Validation: {
        ClientIdInvalid: "3–64 znakov: malé písmená, číslice a pomlčky",
        DisplayNameRequired: "Názov je povinný",
        RedirectUriRequired: "Aspoň jedna redirect URI je povinná",
        RedirectUriInvalid:
          "Redirect URI musí byť absolútna https adresa bez fragmentu (http iba pre localhost)",
        ScopeRequiresRole:
          "Oblasť API vyžaduje aspoň jednu rolu, za ktorú aplikácia koná",
      },
      Scopes: {
        Payments: "Platby (platobné API)",
        Merchant: "Merchant (zamestnanci, platobné miesta, PIN, firemné údaje)",
        Hunter: "Hunter (vlastné terminály, body, affiliate odkaz)",
        TerminalsManage: "Aplikácia: sklad terminálov (čítanie aj zápis)",
        DirectoryRead:
          "Aplikácia: zoznamy používateľov a hunterov, merchanti huntera",
        CouponsCreate: "Aplikácia: vydávanie kupónov",
        LoyaltyRead: "Aplikácia: vernostný program (obdobia, rebríček)",
      },
      Secret: {
        Title: "Client secret pre {{clientId}}",
        Warning:
          "Secret sa zobrazuje iba teraz. Uložte ho do trezora hesiel a odovzdajte bezpečne; znova sa nedá zobraziť, iba vygenerovať nový.",
        Label: "Client secret",
        Copy: "Kopírovať secret",
        Copied: "Skopírované!",
        Close: "Mám uložené",
      },
      Messages: {
        LoadError: "Zoznam aplikácií sa nepodarilo načítať",
        CreateSuccess: "Aplikácia bola zaregistrovaná",
        CreateError: "Aplikáciu sa nepodarilo zaregistrovať",
        ClientIdTaken: "Toto Client ID už existuje",
        UpdateSuccess: "Aplikácia bola uložená",
        UpdateError: "Aplikáciu sa nepodarilo uložiť",
        DeleteConfirmTitle: "Zmazať aplikáciu",
        DeleteConfirm:
          "Naozaj zmazať aplikáciu {{clientId}}? Všetky jej súhlasy a tokeny zaniknú, používatelia budú z aplikácie odhlásení.",
        DeleteSuccess: "Aplikácia bola zmazaná",
        DeleteError: "Aplikáciu sa nepodarilo zmazať",
        RotateConfirmTitle: "Nový client secret",
        RotateConfirm:
          "Vygenerovať nový secret pre {{clientId}}? Starý prestane platiť okamžite, aplikácia sa bez nového neprihlási.",
        RotateError: "Nový secret sa nepodarilo vygenerovať",
      },
    },
    Coupons: {
      PageTitle: "Zľavové kupóny",
      CreateButton: "Vytvoriť kupón",
      Table: {
        Code: "Kód",
        Region: "Krajina",
        Discount: "Zľava",
        DiscountType: "Typ zľavy",
        Expiration: "Expirácia",
        Usage: "Použité",
        Status: "Stav",
        Delete: "Zmazať",
        CopyCode: "Kopírovať kód",
        CodeCopied: "Skopírované!",
      },
      Status: {
        Active: "Aktívny",
        Expired: "Vypršaný",
        OutOfStock: "Vyčerpaný",
      },
      Form: {
        DialogTitle: "Vytvoriť nový kupón",
        Code: "Kód kupónu",
        Region: "Krajina",
        AutoGenerate: "Vygenerovať kód automaticky",
        Discount: "Zľava",
        DiscountType: "Typ zľavy",
        Percentage: "Percentá (%)",
        FixedAmount: "Pevná čiastka",
        Expiration: "Dátum expirácie",
        Stock: "Počet použití",
        StockHelp: "Minimum: {{min}} (už použité)",
        Submit: "Vytvoriť",
        Save: "Uložiť",
        Cancel: "Zrušiť",
        EditTitle: "Upraviť kupón",
        EditTitleWithCode: "Upraviť kupón {{code}}",
      },
      Validation: {
        CodeRequired: "Kód kupónu je povinný",
        DiscountRequired: "Zľava je povinná",
        DiscountPositive: "Zľava musí byť kladná",
        DiscountMax100: "Percentuálna zľava nesmie prekročiť 100 %",
        ExpirationRequired: "Dátum expirácie je povinný",
        StockRequired: "Počet použití je povinný",
        StockMin: "Počet použití musí byť aspoň 1",
      },
      Messages: {
        CreateSuccess: "Kupón bol vytvorený",
        CreateError: "Nepodarilo sa vytvoriť kupón",
        LoadError: "Chyba pri načítaní kupónov",
        DeleteSuccess: "Kupón bol zmazaný",
        DeleteError: "Nepodarilo sa zmazať kupón",
        DeleteConfirmTitle: "Zmazať kupón",
        DeleteConfirm: "Naozaj chcete zmazať kupón {{code}}?",
        UpdateSuccess: "Kupón bol upravený",
        UpdateError: "Nepodarilo sa upraviť kupón",
      },
    },
    Raffle: {
      PageTitle: "Žrebovanie",
      CreateButton: "Nové kolo",
      Table: {
        Region: "Trh",
        Name: "Názov",
        Type: "Typ",
        TypeDefault: "Hlavné kolo",
        TypeCompetition: "Súťaž",
        Status: "Stav",
        DrawDate: "Dátum žrebovania",
        Tickets: "Žreby",
        Participants: "Účastníci",
        Checksum: "Odtlačok podkladu na žrebovanie (SHA-256)",
        ChecksumHelp:
          "Vznikol pri uzavretí kola z vygenerovaného zoznamu čísel (bez údajov o držiteľoch). Stiahnutý podklad sa proti nemu overuje a rovnaký odtlačok patrí do zápisu o žrebovaní — dokazuje, že sa žrebovalo nad súborom, ktorý vytvoril systém.",
        ChecksumCopied: "Odtlačok skopírovaný",
        AllocationChecksum: "Odtlačok pridelenia čísel (SHA-256)",
        AllocationChecksumHelp:
          "Vznikol pri uzavretí kola a zapečaťuje, kto drží ktoré čísla. Patrí do zápisu o žrebovaní vedľa odtlačku podkladu. Dohľadanie výhercu ho zakaždým overuje — ak pridelenie prestane odtlačku zodpovedať, dohľadanie odmietne odpovedať.",
        AllocationChecksumCopied: "Odtlačok skopírovaný",
        Empty: "Zatiaľ žiadne kolá — prvé kolo spustí zbieranie žrebov.",
        Unscheduled: "Bez dátumu žrebovania",
      },
      Status: {
        Draft: "Rozpracované",
        Announced: "Vyhlásené",
        Closed: "Uzavreté",
        Drawn: "Vyžrebované",
        Cancelled: "Zrušené",
      },
      Actions: {
        Edit: "Upraviť",
        View: "Zobraziť detail",
        Announce: "Vyhlásiť",
        Close: "Uzavrieť",
        Complete: "Označiť vyžrebované",
        Export: "Stiahnuť podklad",
        FindHolder: "Dohľadať výhercu",
        Cancel: "Zrušiť súťaž",
        SetDefault: "Nastaviť ako hlavné kolo",
      },
      Form: {
        CreateTitle: "Nové žrebovacie kolo",
        EditTitle: "Upraviť kolo",
        Region: "Trh",
        Name: "Názov kola",
        DrawDate: "Dátum žrebovania",
        Rewards: "Výhry",
        AddReward: "Pridať výhru",
        RewardTitle: "Názov výhry",
        RewardDescription: "Popis",
        RewardQuantity: "Počet kusov",
        RemoveReward: "Odobrať",
        Submit: "Uložiť",
        Cancel: "Zrušiť",
        MainRoundWarning:
          "Na tomto trhu zatiaľ nebeží žiadne hlavné kolo. Toto kolo sa stane hlavným kolom trhu a hneď doň začnú pribúdať žreby. Hlavné kolo nie je možné zrušiť.",
      },
      Validation: {
        NameRequired: "Zadajte názov kola",
        RewardTitleRequired: "Zadajte názov výhry",
        RegionRequired: "Vyberte trh",
        RewardQuantityInvalid: "Počet výhier musí byť celé nezáporné číslo",
        TicketNumberInvalid: "Zadajte kladné celé číslo žrebu",
        TicketNumberRange: "Zadajte číslo žrebu od 1 do {{max}}",
      },
      Messages: {
        LoadError: "Žrebovacie kolá sa nepodarilo načítať",
        CreateSuccess: "Kolo bolo založené",
        CreateError: "Kolo sa nepodarilo založiť",
        UpdateSuccess: "Kolo bolo uložené",
        UpdateError: "Kolo sa nepodarilo uložiť",
        UpdateConflict:
          "Kolo medzitým niekto vyhlásil alebo zrušil, upraviť sa už nedá.",
        AnnounceSuccess: "Kolo bolo vyhlásené",
        AnnounceError: "Kolo sa nepodarilo vyhlásiť",
        AnnounceConfirmTitle: "Vyhlásiť kolo „{{name}}“ ({{region}})?",
        AnnounceConfirm:
          "Vyhlásením sa dátum žrebovania a zoznam výhier stávajú verejným prísľubom a už ich nebude možné zmeniť. Zmeny budú možné len pre ďalšie kolo.",
        AnnounceRequirements:
          "Pred vyhlásením doplň budúci dátum žrebovania, aspoň jednu výhru a vlastný názov kola",
        CloseSuccess: "Kolo bolo uzavreté",
        CloseError: "Kolo sa nepodarilo uzavrieť",
        CloseConfirmTitle: "Uzavrieť kolo „{{name}}“ ({{region}})?",
        CloseConfirm:
          "Uzavretie je nevratné: žrebom sa pridelia čísla, vytvorí sa podklad pre žrebovanie a zbieranie pokračuje do ďalšieho kola. Žreby získané po uzavretí patria do ďalšieho kola.",
        CloseCompetitionConfirm:
          "Uzavretie je nevratné: žrebom sa pridelia čísla a vytvorí sa podklad pre žrebovanie.",
        CompleteSuccess: "Kolo je označené ako vyžrebované",
        CompleteError: "Kolo sa nepodarilo označiť",
        CompleteConfirmTitle:
          "Označiť kolo „{{name}}“ ({{region}}) ako vyžrebované?",
        CompleteConfirm:
          "Potvrdzuješ, že prebehlo žrebovanie podľa dokumentovaného procesu a výsledok je zapísaný.",
        CancelSuccess: "Súťaž bola zrušená",
        CancelError: "Súťaž sa nepodarilo zrušiť",
        CancelConfirmTitle: "Zrušiť súťaž „{{name}}“ ({{region}})?",
        CancelConfirm:
          "Rozpracovaná súťaž bude zrušená a zostane v evidencii ako zrušená. Vyhlásenú súťaž zrušiť nemožno.",
        SetDefaultSuccess: "Kolo je teraz hlavným kolom trhu",
        SetDefaultError: "Hlavné kolo sa nepodarilo nastaviť",
        SetDefaultConfirmTitle:
          "Nastaviť kolo „{{name}}“ ({{region}}) ako hlavné?",
        SetDefaultConfirm:
          "Nové žreby sa odteraz budú pripisovať do tohto kola. Doterajšie hlavné kolo sa stane bežnou súťažou: ak už bolo vyhlásené, žreby v ňom zostávajú; nevyhlásené (rozpracované) kolo svoje žreby odovzdá novému hlavnému kolu.",
        ExportError: "Podklad sa nepodarilo stiahnuť",
        ExportIntegrityError:
          "Podklad neprešiel kontrolou integrity — nežrebuj z neho a kontaktuj vývoj.",
      },
      HolderLookup: {
        Title: "Dohľadanie výhercu",
        TicketNumber: "Číslo žrebu",
        Search: "Dohľadať",
        HolderName: "Držiteľ",
        Email: "E-mail",
        TicketCount: "Počet žrebov v kole",
        Range: "Rozsah čísel",
        NotFound: "Číslo žrebu sa nepodarilo dohľadať",
        SealMismatch:
          "Pridelenie čísel nezodpovedá stavu pri uzavretí kola — dohľadanie bolo odmietnuté. Kontaktuj vývoj.",
        Error: "Dohľadanie sa nepodarilo — skús to znova",
      },
    },
    Campaigns: {
      PageTitle: "Administrácia kampaní",
      CreatePageTitle: "Vytvoriť kampaň",
      CreateButton: "Vytvoriť novú kampaň",
      DraftCampaigns: "Koncepty",
      PublishedCampaigns: "Publikované kampane",
      ArchivedCampaigns: "Archivované kampane",

      Table: {
        CampaignName: "Názov kampane",
        Code: "Kód",
        Receiver: "Príjemca",
        Affiliate: "Affiliate",
        Status: "Stav",
        StatusOnRestore: "Stav po obnovení",
        StartDate: "Dátum začiatku",
        EndDate: "Dátum konca",
        Created: "Vytvorené",
        Deleted: "Zmazané",
        Actions: "Akcie",
        Unlimited: "Neobmedzené",
        Enabled: "Povolené",
        Disabled: "Zakázané",
        NoReceiverAssigned: "Nepriradený príjemca",
        ViewCampaign: "Zobraziť kampaň",
        Edit: "Upraviť",
        Delete: "Zmazať",
        Restore: "Obnoviť",
        CopyUrl: "Kopírovať URL kampane",
        UrlCopied: "URL skopírovaná",
      },

      Status: {
        Draft: "Koncept",
        DraftDescription: "Táto kampaň je v koncepte",
        Archived: "Archivované",
        ArchivedDescription: "Táto kampaň je archivovaná",
        ActiveUnlimited: "Aktívna (Neobmedzená)",
        UnlimitedDescription: "Táto kampaň beží neobmedzene",
        StartsToday: "Začína dnes",
        StartsTomorrow: "Začína zajtra",
        StartsInDays: "Začína za {{days}} dní",
        StartsOn: "Začína {{date}}",
        Finished: "Ukončená",
        EndedOn: "Skončila {{date}}",
        EndsToday: "Končí dnes",
        DayLeft: "Zostáva 1 deň",
        DaysLeft: "Zostáva {{days}} dní",
        EndsOn: "Končí {{date}}",
        Active: "Aktívna",
        CurrentlyRunning: "Práve beží",
        NotStarted: "Plánovaná",
      },

      Form: {
        BasicInformation: "Základné informácie",
        CampaignName: "Názov kampane",
        CampaignNamePlaceholder: "napr. Nadácia Help Pes",
        CampaignCode: "Kód kampane (URL cesta)",
        CampaignCodePlaceholder: "napr. nadacia-help-pes",
        CampaignCodeHelperCreate:
          "Používajte iba malé písmená bez diakritiky, číslice a pomlčky.",
        CampaignCodeHelperEdit: "Kód nemožno po vytvorení zmeniť",
        Description: "Popis",
        DescriptionPlaceholder: "Krátky popis kampane",
        DescriptionCharCount: "{{count}}/500",
        EnableAffiliateProgram: "Povoliť affiliate program",

        CampaignValidity: "Platnosť kampane",
        DateModeUnlimited: "Neobmedzená",
        DateModeUnlimitedDescription:
          "Kampaň nemá počiatočný ani koncový dátum",
        DateModeFromTo: "Od - Do",
        DateModeFromToDescription: "Kampaň beží medzi konkrétnymi dátumami",
        StartDate: "Dátum začiatku",
        EndDate: "Dátum konca",
        UnlimitedDateInfo:
          "Táto kampaň pobeží neobmedzene bez počiatočného či koncového dátumu.",

        PaymentReceiver: "Príjemca platby",
        PaymentReceiverDescription:
          "Vyberte používateľa obchodníka, ktorý bude prijímať platby z tejto kampane",
        MerchantUser: "Používateľ obchodníka",

        CampaignContent: "Úvodná stránka kampane",
        HeaderTitle: "Hlavný nadpis",
        HeaderTitlePlaceholder: "napr. Podporte výcvik asistenčných psov",
        FoundationLinkName: "Názov odkazu nadácie",
        FoundationLinkNamePlaceholder: "napr. Viac informácií",
        FoundationLinkNameHelper: "Text odkazu na web nadácie",
        FoundationLinkUrl: "URL odkazu nadácie",
        FoundationLinkUrlPlaceholder: "https://example.org",
        FoundationLinkUrlHelper: "URL na web nadácie",
        SuccessfulPaymentText: "Poďakovanie po úspešnej platbe",
        SuccessfulPaymentTextPlaceholder: "Ďakujeme za Váš príspevok!",
        SuccessfulPaymentTextHelper:
          "Text zobrazený po úspešnej platbe ({{count}}/1000)",

        ThankYouSection: "Podľakovanie po úspešnej platbe",
        Color: "Farba kampane",
        ColorHelp:
          "Primárna farba kampane (hex formát, napr. #FF9400). Farba pri navedení bude automaticky tmavšia. Ponechajte prázdne pre predvolenú farbu motívu.",
        PaymentInstructionsText: "Pokyny k platbe",
        PaymentInstructionsTextHelper:
          "Text zobrazený v kroku časovej osi 'Zaplaťte v kaviarni'. Popisuje, ako platby pomáhajú kampani. Max 500 znakov.",
        OnlyWithMooneText: "Text Jedine s Mo.one",
        OnlyWithMooneTextHelper:
          "Text zobrazený v kroku časovej osi 'Akákoľvek metóda'. Propaguje používanie Mo.one pre platby. Max 500 znakov.",

        Images: "Obrázky (Pripravujeme)",
        Logo: "Logo",
        LogoHelper: "Logo kampane (PNG/SVG)",
        LandingImage: "Úvodný obrázok",
        LandingImageHelper: "Náhľadový obrázok úvodnej stránky (PNG/JPG)",
        Icon: "Ikona (voliteľné)",
        IconHelper: "Ikona kampane (PNG/SVG)",
        ThankYouImage: "Obrázok úspešnej platby",
        ThankYouImageHelper: "Obrázok zobrazený po úspešnej platbe",
        ImageUploadSuccess: "Obrázok bol nahraný",
        ImageUploadError: "Nahranie obrázka sa nepodarilo",
        UploadError: {
          invalidFileType:
            "Nepodporovaný typ súboru. Povolené formáty: PNG, JPEG, SVG.",
          fileSizeExceeded: "Súbor je príliš veľký.",
          fileContentMismatch: "Obsah súboru nezodpovedá typu súboru.",
        },

        StepBasicInfo: "Základné informácie",
        StepLandingPage: "Úvodná stránka",
        StepThankYouPage: "Ďakovacia stránka",
        StepValidity: "Platnosť",
        PreviewCampaignPage: "Náhľad stránky kampane",
        PreviewThankYouPage: "Náhľad ďakovacej stránky",
        ImageDeleteSuccess: "Obrázok bol zmazaný",
        ImageDeleteError: "Zmazanie obrázka sa nepodarilo",
        CreateButton: "Vytvoriť kampaň",
        UpdateLandingPageButton: "Aktualizovať úvodnú stránku",
        UpdateThankYouPageButton: "Aktualizovať ďakovaciu stránku",
        NextStepButton: "Ďalší krok",
        PreviousStepButton: "Predchádzajúci krok",
        SaveChangesButton: "Uložiť zmeny",
        SaveButton: "Uložiť",
        CloseButton: "Zavrieť",
        PublishButton: "Publikovať",
        PublishRequiresReceiver:
          "Pre publikovanie kampane je nutné vybrať príjemcu platieb.",
        ArchiveButton: "Archivovať",
        UnpublishButton: "Vrátiť do konceptu",
        CampaignIsLive: "Kampaň je publikovaná",
        UpdateButton: "Aktualizovať kampaň",
        Validation: {
          NameRequired: "Názov kampane je povinný",
          CodeRequired: "Kód kampane je povinný",
          CodeInvalidFormat:
            "Kód musí obsahovať len malé písmená, čísla a pomlčky. Špeciálne znaky nie sú povolené.",
          DescriptionRequired: "Popis je povinný",
          InvalidUrl: "Musí byť platná URL adresa",
          InvalidColor:
            "Musí byť platná farba v hex formáte (napr. #FF9400 alebo #FF940080)",
          MaxLength: "Maximálna dĺžka je {{max}} znakov",
          DateRangeRequired:
            "Počiatočný a koncový dátum sú povinné pri výbere rozsahu dátumov",
          EndDateAfterStartDate:
            "Koncový dátum musí byť po alebo rovnaký ako počiatočný dátum",
        },
        PaymentInstructionsTextPlaceholder:
          "Zaplaťte za kávu s Mo.one. My za vás prispíme na ďalší projekt nadácie, napríklad terapeutickú podporu pre dieťa s poruchou autistického spektra a jeho rodinu. Aby mohli zostať pohromade.",
        OnlyWithMooneTextPlaceholder:
          "Kdekoľvek zaplatíte s Mo.one, my posielame peniaze na podporu detí s poruchou autistického spektra a ich rodín. Choďte a vyžadujte platbu jedine s Mo.one.<newline/><newline/>Stačí si jednoducho vytvoriť účet a začať!",
      },

      Messages: {
        CreateSuccess: "Kampaň bola úspešne vytvorená! URL: /campaign/{{code}}",
        CreateError: "Nepodarilo sa vytvoriť kampaň",
        UpdateSuccess: "Kampaň bola úspešne aktualizovaná!",
        UpdateError: "Nepodarilo sa aktualizovať kampaň",
        PublishSuccess: "Kampaň bola publikovaná",
        ArchiveSuccess: "Kampaň bola archivovaná",
        UnpublishSuccess: "Kampaň bola vrátená do konceptu",
        CodeExistsError: "Kód kampane už existuje alebo je neplatný",
        DeleteConfirm: "Naozaj chcete zmazať túto kampaň?",
        DeleteSuccess: "Kampaň bola úspešne zmazaná",
        DeleteError: "Nepodarilo sa zmazať kampaň",
        RestoreConfirm: "Naozaj chcete obnoviť túto kampaň?",
        RestoreSuccess: "Kampaň bola úspešne obnovená",
        RestoreError: "Nepodarilo sa obnoviť kampaň",
        LoadCampaignsError: "Nepodarilo sa načítať kampane",
        EditCampaignTitle: "Upraviť kampaň: {{name}}",
      },
    },
    SettlementPoolBoosts: {
      StardustBoost: "Stardust Boost",
      ValorBoost: "Valor Boost",
      Regions: {
        CZ: "Česko",
        SK: "Slovensko",
      },
      BoostAmount: "Boost čiastka ({{currency}})",
      DistributionRatio: "Pomer rozdelenia",
      HunterPoolRatio: "Licencie",
      ValorPoolRatio: "Valor body",
      CurrentPoolTotal: "Aktuálny pool celkom ({{currency}})",
      PoolTotalLoadError: "Nepodarilo sa načítať aktuálny pool",
      SaveButton: "Uložiť",
      SaveSuccess: "Boost bol úspešne aktualizovaný",
      LoadingError: "Nepodarilo sa načítať nastavenia boostov",
      Validation: {
        BoostAmountNonNegative: "Čiastka boostu nemôže byť záporná",
        RatioSumMustBe100: "Súčet pomerov musí byť 100",
      },
    },
    VatStatusRefresh: {
      Title: "Registre DPH",
      Description:
        "Znovu overí stav registrácie k DPH všetkých firiem a SZČO v registroch (CZ: Register platcov DPH, SK: VIES). Beží na pozadí, výsledok je v logu Workera.",
      Button: "Aktualizovať stav DPH",
      Loading: "Spúšťam...",
      Success: "Aktualizácia stavu DPH bola spustená.",
      Error: "Aktualizáciu stavu DPH sa nepodarilo spustiť.",
    },
    PaymentSimulation: {
      Title: "Simulácia zaplatenia (sandbox)",
      Description:
        "Označí sandbox platbu ako zaplatenú, akoby banka vrátila stav „zaplatené“. Len pre transakcie typu Platba so sandbox bankou v stave Začaté, Spracováva sa alebo Vyžaduje prešetrenie. Dostupné iba na testovacom a staging prostredí.",
      PublicIDLabel: "Kód transakcie",
      Button: "Označiť ako zaplatenú",
      Loading: "Označujem...",
      ConfirmTitle: "Simulovať zaplatenie?",
      ConfirmText:
        "Transakcia {{publicID}} bude označená ako zaplatená. Spustia sa rovnaké následné kroky ako pri skutočnej platbe (notifikácie, webhook, vyúčtovanie).",
      Success: "Transakcia {{publicID}} je označená ako zaplatená.",
      Errors: {
        NotFound:
          "Transakcia sa nenašla, alebo je simulácia na tomto prostredí vypnutá.",
        Forbidden: "Simuláciu môže spustiť iba administrátor.",
        NotPayment: "Simulovať je možné len transakcie typu Platba.",
        NotSandbox:
          "Transakcia nemá sandbox platbu. Najprv ju zaplaťte sandbox bankou.",
        StatusNotAllowed:
          "Transakcia nie je v stave, z ktorého je možné zaplatenie simulovať.",
        Generic: "Simuláciu zaplatenia sa nepodarilo vykonať.",
      },
    },
  },
  Devices: {
    List: {
      LoadingError: "Chyba pri načítaní zariadení",
      Name: "Názov",
      PayPoint: "Paypoint",
      DateCreated: "Vytvorené",
      LastUsedAt: "Naposledy použité",
      RevokeConfirm: "Naozaj chcete odpojiť toto zariadenie?",
      RevokeSuccess: "Zariadenie bolo odpojené",
      RevokeError: "Odpojenie zariadenia sa nepodarilo",
      RegenerateConfirm:
        "Naozaj chcete vygenerovať nový kľúč? Existujúci kľúč prestane fungovať.",
      RegenerateSuccess: "Nový kľúč bol vygenerovaný",
      RegenerateError: "Vygenerovanie nového kľúča sa nepodarilo",
      NewDeviceSecret: "Nový kľúč zariadenia",
      CopyDeviceSecret: "Skopírovať kľúč",
      DeviceSecretCopied: "Kľúč bol skopírovaný do schránky",
      AddDevice: "Pridať zariadenie",
      DeviceName: "Názov zariadenia",
      SelectPayPoint: "Vyberte paypoint",
      LinkSuccess: "Zariadenie bolo pripojené",
      LinkError: "Pripojenie zariadenia sa nepodarilo",
      NoTerminalPayPoints:
        "Nemáte žiadny voľný terminálový paypoint. Najprv vytvorte paypoint typu Terminál.",
      DeviceSecretWarning:
        "Tento kľúč sa zobrazí iba raz. Skopírujte ho a bezpečne uložte — neskôr ho nebude možné znova získať.",
    },
  },
  PaymentGateways: {
    Legend: "Platobná brána",
    Description:
      "Prístupové údaje na integráciu platobnej brány Mo.one do vášho e-shopu. Client secret sa zobrazí iba raz pri vygenerovaní.",
    ClientID: "Client ID",
    CopyClientID: "Skopírovať Client ID",
    ClientIDCopied: "Client ID bolo skopírované",
    LastUsedAt: "Naposledy použité",
    NoCredential: "Prístupové údaje zatiaľ neboli vygenerované.",
    Generate: "Vygenerovať prístupové údaje",
    Regenerate: "Nový client secret",
    Revoke: "Zrušiť prístupové údaje",
    Secret: {
      CreatedTitle: "Prístupové údaje vytvorené",
      RegeneratedTitle: "Nový client secret vygenerovaný",
      Warning:
        "Client secret sa zobrazí iba raz. Skopírujte ho a bezpečne uložte — neskôr ho nebude možné znova získať.",
      ClientID: "Client ID",
      ClientSecret: "Client secret",
      Copied: "Skopírované do schránky",
      Close: "Zavrieť",
    },
    Messages: {
      GenerateError: "Vygenerovanie prístupových údajov sa nepodarilo",
      RegenerateConfirmTitle: "Vygenerovať nový client secret",
      RegenerateConfirm:
        "Naozaj chcete vygenerovať nový client secret? Existujúci okamžite prestane fungovať a je nutné ho aktualizovať v e-shope.",
      RegenerateError: "Vygenerovanie nového client secretu sa nepodarilo",
      RevokeConfirmTitle: "Zrušiť prístupové údaje",
      RevokeConfirm:
        "Naozaj chcete zrušiť prístupové údaje? E-shop okamžite prestane prijímať platby, kým nevygenerujete nové.",
      RevokeSuccess: "Prístupové údaje boli zrušené",
      RevokeError: "Zrušenie prístupových údajov sa nepodarilo",
    },
  },
  TerminalPin: {
    Title: "PIN pre terminál",
    Description:
      "Tento štvormiestny PIN zadávate na termináli pri prihlásení. Slúži na identifikáciu obsluhy.",
    NoPinYet:
      "PIN ešte nemáte pridelený. Bude vygenerovaný, keď vás merchant priradí na terminálový paypoint.",
    Reveal: "Zobraziť",
    Hide: "Skryť",
    Regenerate: "Vygenerovať nový PIN",
    RegenerateConfirm:
      "Naozaj chcete vygenerovať nový PIN? Existujúci PIN prestane fungovať.",
    RegenerateSuccess: "Nový PIN bol vygenerovaný",
    RegenerateError: "Vygenerovanie nového PINu sa nepodarilo",
  },
  UserSettings: {
    BalanceVisibility: {
      Title: "Zobrazenie zostatku",
      Label: "Zobrazovať zostatok na hlavnej obrazovke",
      Description:
        "Ak je vypnuté, zostatok je skrytý a zobrazí sa až po kliknutí na ikonu oka.",
    },
    QuickPayment: {
      Title: "Rýchla platba",
    },
  },
  Sso: {
    Consent: {
      Intro: "Aplikácia {{app}} žiada o prístup k vášmu účtu {{appName}}.",
      PermissionsHeading: "Aplikácia získa:",
      RevokeHint:
        "Prístup môžete kedykoľvek odobrať v nastaveniach v sekcii Pripojené aplikácie.",
      Allow: "Povoliť",
      Deny: "Zamietnuť",
      Redirecting: "Pokračujeme do aplikácie…",
      ReauthTitle: "Prihláste sa znova",
      ReauthText:
        "Aplikácia {{app}} vyžaduje čerstvé prihlásenie. Po opätovnom prihlásení budete pokračovať späť sem.",
      ReauthButton: "Prihlásiť sa znova",
      SignedInAs: "Prihlásení ako {{who}}",
      UseAnotherAccount: "Použiť iný účet",
      MissingRequest:
        "Chýba identifikácia požiadavky o prihlásenie. Začnite prosím znova z aplikácie, do ktorej sa prihlasujete.",
    },
    ConnectedApps: {
      Empty: "Zatiaľ ste sa cez {{appName}} neprihlásili do žiadnej aplikácie.",
      ConnectedAt: "Pripojené {{date}}",
      Disconnect: "Odpojiť",
      DisconnectConfirmTitle: "Odpojiť aplikáciu",
      DisconnectConfirm:
        "Aplikácia {{app}} stratí prístup k vášmu účtu. Pri ďalšom prihlásení vás znova požiada o súhlas.",
      DisconnectSuccess: "Aplikácia bola odpojená.",
      DisconnectError: "Aplikáciu sa nepodarilo odpojiť.",
      LoadError: "Pripojené aplikácie sa nepodarilo načítať.",
    },
    Scopes: {
      OpenId: "Prihlásenie",
      Profile: "Vaše meno",
      Email: "Vašu e-mailovú adresu",
      OfflineAccess: "Zostať prihlásení (bez opakovaného prihlasovania)",
      Contexts: "Konať za vaše roly v {{appName}}",
      Payments: "Prijímať platby za vašu firmu",
      Merchant: "Spravovať zamestnancov, platobné miesta a PINy vašej firmy",
      Hunter: "Vaše terminály, body a affiliate odkaz",
      TerminalsManage: "Sklad terminálov",
      DirectoryRead: "Zoznamy používateľov a hunterov",
      CouponsCreate: "Vydávanie kupónov",
      LoyaltyRead: "Vernostný program",
    },
    Errors: {
      RequestNotFound:
        "Požiadavka o prihlásenie neexistuje. Začnite prosím znova z aplikácie.",
      RequestExpired:
        "Požiadavka o prihlásenie vypršala. Začnite prosím znova z aplikácie.",
      RequestNotPending:
        "Táto požiadavka už bola vybavená. Začnite prosím znova z aplikácie.",
      IdentityRequired:
        "Váš účet je potrebné najprv dokončiť. Prihláste sa do {{appName}} a skúste to znova.",
      IdentityNotActive:
        "Váš účet nie je aktívny, prihlásenie do aplikácií nie je možné.",
      BackOfficeNotAllowed:
        "Administrátorským účtom sa do partnerských aplikácií prihlásiť nedá.",
      ConsentNotFound: "Súhlas už neplatí. Začnite prosím znova z aplikácie.",
      ClientNotFound: "Aplikácia nie je registrovaná.",
      Unknown: "Prihlásenie do aplikácie sa nepodarilo.",
    },
  },
  Beta: {
    Badge: "Beta",
    RoadmapUrl: "https://mo.one/roadmap",
    AuthCard: {
      Title: "Vitajte v Bete {{appName}}!",
      Body: "Pracujeme na vylepšeniach. Plány nájdete v <roadmap>Roadmape</roadmap>.",
    },
    Drawer: {
      Title: "Vitajte v Bete {{appName}}!",
      BodyFirst:
        "Na aplikácii stále pracujeme a každý deň ju posúvame o kus ďalej. Ak narazíte na chybu alebo nepresnosť, dajte nám prosím vedieť pomocou tlačidla <reportButton /> v hornej časti obrazovky.",
      BodySecond:
        "Ak vás zaujíma, kam {{appName}} smeruje, nahliadnite do <roadmap>našej Roadmapy</roadmap>.",
      BodyThird: "Ďakujeme, že nám pomáhate rásť.",
      Continue: "Pokračovať",
      Close: "Zavrieť",
    },
    MenuItem: "{{appName}} Beta",
  },
};
